/* eslint-disable react/display-name */
import React, { FC, memo } from "react";
import { SvgIconConstituentValues } from "../index";

//COUNTRY ICONS
/*
    This country icon pack is made available free for personal and commercial use from flaticon.com.
  For more information, please read their terms of use here. Each component name maps to the alpha-2 country code.
*/

export const AD: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1346)">
      <path
        d="M6.78285 22.8093C8.36047 23.5721 10.1303 24 12.0002 24C13.8701 24 15.64 23.5721 17.2176 22.8093L18.2611 12L17.2176 1.19072C15.64 0.427875 13.8701 0 12.0002 0C10.1303 0 8.36047 0.427875 6.78285 1.19072L5.73936 12L6.78285 22.8093Z"
        fill="#FFDA44"
      />
      <path
        d="M17.2169 22.809C21.2309 20.8681 23.9995 16.7577 23.9995 12.0002C23.9995 7.24269 21.2309 3.13222 17.2169 1.19132V22.809Z"
        fill="#D80027"
      />
      <path
        d="M6.78233 22.809V1.19132C2.76838 3.13222 -0.000289917 7.24264 -0.000289917 12.0002C-0.000289917 16.7577 2.76838 20.8681 6.78233 22.809Z"
        fill="#0052B4"
      />
      <path
        d="M12 16.1734C12 14.2585 12 11.9995 12 11.9995H15.1304V13.5647C15.1304 13.8366 14.6087 14.833 13.3209 15.6517C12.8332 15.9618 12.3283 16.0615 12 16.1734Z"
        fill="#D80027"
      />
      <path d="M11.9998 8.86883H8.86931V11.9993H11.9998V8.86883Z" fill="#D80027" />
      <path
        d="M13.5653 7.8262C13.5653 7.24987 13.0981 6.78271 12.5219 6.78271C12.3315 6.78271 12.1537 6.83446 12.0001 6.92343C11.8465 6.83446 11.6687 6.78271 11.4784 6.78271C10.9021 6.78271 10.4349 7.24987 10.4349 7.8262H7.82625V13.0435C7.82625 14.9858 9.36872 16.1091 10.5783 16.6914C10.4878 16.846 10.4349 17.0254 10.4349 17.2175C10.4349 17.7938 10.9021 18.261 11.4784 18.261C11.6687 18.261 11.8466 18.2092 12.0001 18.1203C12.1537 18.2092 12.3315 18.261 12.5219 18.261C13.0981 18.261 13.5653 17.7938 13.5653 17.2175C13.5653 17.0254 13.5125 16.846 13.4219 16.6914C14.6315 16.1091 16.174 14.9859 16.174 13.0435V7.8262H13.5653ZM14.6088 13.0435C14.6088 13.3155 14.6088 14.1428 13.3211 14.9616C12.8333 15.2717 12.3285 15.4728 12.0001 15.5846C11.6718 15.4728 11.167 15.2717 10.6792 14.9616C9.39145 14.1428 9.39145 13.3155 9.39145 13.0435V9.3914H14.6088V13.0435Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1346">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M6.78262 16.1729L7.82611 23.2527C9.12604 23.7351 10.5322 23.999 12 23.999C17.1595 23.999 21.5581 20.7425 23.2536 16.1729H6.78262Z"
      fill="black"
    />
    <path
      d="M6.78262 7.8266L7.82611 0.746785C9.12604 0.264394 10.5322 0.000488281 12 0.000488281C17.1595 0.000488281 21.5581 3.25699 23.2536 7.8266H6.78262Z"
      fill="#6DA544"
    />
    <path
      d="M0.000396729 12C0.000396729 17.1596 3.25694 21.5581 7.82651 23.2536V0.746399C3.25694 2.44191 0.000396729 6.84043 0.000396729 12Z"
      fill="#A2001D"
    />
  </svg>
));
export const AF: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1309)">
      <path
        d="M17.2172 1.19072C15.6396 0.427875 13.8697 0 11.9998 0C10.13 0 8.36009 0.427875 6.78247 1.19072L5.73898 12L6.78247 22.8093C8.36009 23.5721 10.13 24 11.9998 24C13.8697 24 15.6396 23.5721 17.2172 22.8093L18.2607 12L17.2172 1.19072Z"
        fill="#D80027"
      />
      <path
        d="M6.78273 1.19131C2.76883 3.13227 0.000106812 7.24269 0.000106812 12.0002C0.000106812 16.7577 2.76883 20.8681 6.78273 22.809V1.19131Z"
        fill="black"
      />
      <path
        d="M17.2175 1.19131V22.809C21.2314 20.8681 24.0001 16.7577 24.0001 12.0002C24.0001 7.24269 21.2314 3.13227 17.2175 1.19131Z"
        fill="#496E2D"
      />
      <path
        d="M11.9997 7.82675C9.69446 7.82675 7.82579 9.69547 7.82579 12.0006C7.82579 14.3058 9.69451 16.1745 11.9997 16.1745C14.3049 16.1745 16.1736 14.3058 16.1736 12.0006C16.1736 9.69547 14.3049 7.82675 11.9997 7.82675ZM11.9997 14.6093C10.5589 14.6093 9.39099 13.4413 9.39099 12.0006C9.39099 10.5599 10.559 9.39196 11.9997 9.39196C13.4404 9.39196 14.6084 10.5599 14.6084 12.0006C14.6084 13.4413 13.4404 14.6093 11.9997 14.6093Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0001 10.4363C11.4237 10.4363 10.9566 10.9034 10.9566 11.4798V13.045H13.0435V11.4798C13.0435 10.9034 12.5764 10.4363 12.0001 10.4363Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1309">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1379)">
      <path
        d="M4.57764e-05 11.9993C4.57764e-05 12.8212 0.0829208 13.6238 0.240374 14.3993L12 15.1297L23.7598 14.3993C23.9173 13.6238 24 12.8212 24 11.9993C24 11.1773 23.9172 10.3747 23.7598 9.59929L12 8.86884L0.240374 9.59929C0.0829208 10.3747 4.57764e-05 11.1773 4.57764e-05 11.9993Z"
        fill="#0052B4"
      />
      <path
        d="M23.7595 14.3992H0.240082C1.35191 19.8765 6.19433 23.9992 11.9998 23.9992C17.8052 23.9992 22.6476 19.8765 23.7595 14.3992Z"
        fill="#F0F0F0"
      />
      <path d="M0.240097 9.6H23.7595C22.6476 4.12266 17.8053 0 11.9998 0C6.19425 0 1.35193 4.12266 0.240097 9.6Z" fill="black" />
      <path
        d="M17.2176 9.59939H6.78285L8.91473 8.59655L7.77946 6.53194L10.0944 6.97467L10.3878 4.63612L12.0002 6.35615L13.6127 4.63612L13.906 6.97467L16.221 6.53194L15.0858 8.59664L17.2176 9.59939Z"
        fill="#FFDA44"
      />
      <path
        d="M4.57764e-05 12.0008C4.57764e-05 18.6282 5.37267 24.0008 12 24.0008L2.39986 4.80037C0.893108 6.8061 4.57764e-05 9.29906 4.57764e-05 12.0008Z"
        fill="#A2001D"
      />
      <path
        d="M11.9996 23.9998C18.627 23.9998 23.9997 18.6272 23.9997 11.9998C23.9997 9.29811 23.1066 6.80516 21.5998 4.79942L11.9996 23.9998Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1379">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
    <path
      d="M11.9674 12.0005H11.9996C11.9996 11.9897 11.9996 11.9792 11.9996 11.9684C11.9889 11.9791 11.9782 11.9898 11.9674 12.0005Z"
      fill="#F0F0F0"
    />
    <path
      d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.07072 1.56508C4.1939 2.63378 2.63357 4.19407 1.56491 6.07089V11.9999H4.69536V4.69563V4.69553H11.9997C11.9997 3.70821 11.9997 2.76761 11.9997 1.56508H6.07072Z"
      fill="#D80027"
    />
    <path
      d="M11.9995 10.5248L7.73602 6.2614H6.26039V6.26149L11.9994 12.0005H11.9995C11.9995 12.0005 11.9995 10.983 11.9995 10.5248Z"
      fill="#D80027"
    />
    <path
      d="M20.2942 13.7573C20.6392 13.2826 20.8697 12.7028 20.8697 12.0007V6.78334C20.4337 7.1109 19.8918 7.30506 19.3045 7.30506C18.4511 7.30506 17.6935 6.89523 17.2175 6.26167C16.7416 6.89523 15.9839 7.30506 15.1306 7.30506C14.5432 7.30506 14.0014 7.11085 13.5654 6.78343V12.0007C13.5654 12.7028 13.7959 13.2826 14.1409 13.7573H20.2942Z"
      fill="#F3F3F3"
    />
    <path
      d="M19.2084 11.0321C19.3745 10.6269 19.5037 10.0345 19.5037 9.73971C19.5037 9.26604 18.8862 8.88209 18.8862 8.88209C18.8862 8.88209 18.2686 9.26604 18.2686 9.73971C18.2686 10.0346 18.3979 10.6269 18.5639 11.0321L18.2074 11.837C18.417 11.9223 18.646 11.9696 18.8862 11.9696C19.1265 11.9696 19.3554 11.9222 19.565 11.837L19.2084 11.0321Z"
      fill="#FF9811"
    />
    <path
      d="M16.7952 8.4267C16.3614 8.48548 15.7837 8.66994 15.5284 8.81731C15.1182 9.05417 15.0944 9.78087 15.0944 9.78087C15.0944 9.78087 15.7358 10.1237 16.1459 9.88686C16.4013 9.73944 16.8496 9.33144 17.1174 8.98494L17.9928 8.89119C17.9619 8.66722 17.8882 8.44517 17.7682 8.23719C17.648 8.0292 17.4926 7.85445 17.314 7.71556L16.7952 8.4267Z"
      fill="#FF9811"
    />
    <path
      d="M15.7446 11.8206C16.0124 12.1669 16.4609 12.5748 16.7162 12.7223C17.1265 12.9591 17.7678 12.6164 17.7678 12.6164C17.7678 12.6164 17.7438 11.8896 17.3337 11.6528C17.0783 11.5053 16.5008 11.3211 16.0668 11.2624L15.548 10.5511C15.3695 10.69 15.214 10.8648 15.0939 11.0726C14.9739 11.2807 14.9004 11.5027 14.8692 11.7268L15.7446 11.8206Z"
      fill="#FF9811"
    />
    <path
      d="M14.0114 13.5656C14.9858 15.1291 17.2171 15.6525 17.2171 15.6525C17.2171 15.6525 19.4484 15.1291 20.4229 13.5656H14.0114Z"
      fill="#338AF3"
    />
  </svg>
));
export const AL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M18.7825 8.90744H14.436C14.7043 8.62647 14.8694 8.24608 14.8694 7.82688C14.8694 6.96245 14.1686 6.26167 13.3042 6.26167C12.7596 6.26167 12.2802 6.53992 11.9999 6.96185C11.7195 6.53992 11.2401 6.26167 10.6955 6.26167C9.83111 6.26167 9.13033 6.96245 9.13033 7.82688C9.13033 8.24608 9.29547 8.62652 9.56378 8.90744H5.2173C5.2173 10.06 6.22122 10.9944 7.37374 10.9944H7.30418C7.30418 12.147 8.23854 13.0814 9.39119 13.0814C9.39119 13.4547 9.48958 13.8047 9.66133 14.1077L7.93024 15.8388L9.25839 17.1669L11.1424 15.2829C11.2162 15.31 11.2925 15.3317 11.3714 15.3464L10.2329 17.9168L11.9999 19.8269L13.7668 17.9167L12.6284 15.3463C12.7073 15.3316 12.7836 15.3099 12.8574 15.2828L14.7414 17.1668L16.0695 15.8387L14.3384 14.1075C14.5102 13.8046 14.6086 13.4545 14.6086 13.0812C15.7612 13.0812 16.6955 12.1469 16.6955 10.9942H16.626C17.7785 10.9943 18.7825 10.06 18.7825 8.90744Z"
      fill="black"
    />
  </svg>
));
export const AM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1395)">
      <path
        d="M24.0001 12C24.0001 10.5322 23.7361 9.12608 23.2537 7.82615L12.0001 7.30438L0.746497 7.8261C0.264154 9.12608 0.000106812 10.5322 0.000106812 12C0.000106812 13.4679 0.264154 14.874 0.746497 16.1739L12.0001 16.6957L23.2537 16.174C23.7361 14.874 24.0001 13.4679 24.0001 12Z"
        fill="#0052B4"
      />
      <path
        d="M12.0001 23.9995C17.1596 23.9995 21.5582 20.743 23.2537 16.1734H0.74646C2.44198 20.743 6.84049 23.9995 12.0001 23.9995Z"
        fill="#FF9811"
      />
      <path d="M0.746323 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84035 0 2.44184 3.2565 0.746323 7.82611Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_5_1395">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1355)">
      <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#D80027" />
      <path
        d="M23.9998 12.0003C23.9998 18.6277 18.6272 24.0003 11.9998 24.0003C5.37244 24.0003 -0.000183105 18.6277 -0.000183105 12.0003"
        fill="black"
      />
      <path
        d="M10.354 9.54357L11.3713 10.2819L10.9836 11.4775L12.0001 10.738L13.0175 11.4763L12.6284 10.281L13.6448 9.5416L12.3878 9.54235L11.9986 8.34708L11.6109 9.54277L10.354 9.54357Z"
        fill="#FFDA44"
      />
      <path
        d="M14.9998 6.80329C14.0541 6.25734 13.0202 5.99967 11.9998 6.00145V7.56633C12.754 7.56497 13.5182 7.75528 14.2171 8.15887C16.3348 9.38156 17.063 12.0992 15.8403 14.2169C14.6177 16.3346 11.9001 17.0628 9.78233 15.8401C9.16536 15.4839 8.66731 15.0003 8.30019 14.4421L6.9935 15.3048C7.49023 16.0599 8.16505 16.7137 8.99975 17.1956C11.8649 18.8498 15.5417 17.8646 17.1958 14.9994C18.8501 12.1342 17.8649 8.45751 14.9998 6.80329Z"
        fill="#FFDA44"
      />
      <path
        d="M8.53956 10.956C8.12472 11.7144 8.40325 12.6655 9.16159 13.0804L14.2451 15.8582C13.8994 16.4901 14.083 17.2593 14.715 17.605L16.0882 18.3561C16.7201 18.7019 17.5128 18.4698 17.8585 17.8378L18.6097 16.4646L8.53956 10.956Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1355">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1388)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0002 -0.000930786C7.24267 -0.000930786 3.13192 2.76774 1.19092 6.78169H22.8094C20.8685 2.76774 16.7577 -0.000930786 12.0002 -0.000930786Z"
        fill="#338AF3"
      />
      <path
        d="M12.0005 23.9988C16.7579 23.9988 20.8687 21.2301 22.8097 17.2161H1.19118C3.13218 21.2301 7.24293 23.9988 12.0005 23.9988Z"
        fill="#338AF3"
      />
      <path
        d="M15.5865 12.0001L14.121 12.6894L14.9014 14.1088L13.31 13.8043L13.1083 15.4119L11.9999 14.2296L10.8914 15.4119L10.6898 13.8043L9.09836 14.1087L9.87874 12.6894L8.41324 12.0001L9.87879 11.3107L9.09836 9.89138L10.6897 10.1958L10.8914 8.58817L11.9999 9.77054L13.1084 8.58817L13.31 10.1958L14.9014 9.89138L14.121 11.3107L15.5865 12.0001Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1388">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1337)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M17.8217 1.50525C16.0974 0.54675 14.1127 0 12 0C5.37309 0 0.00084375 5.37178 0 11.9986L8.34783 7.82611L17.8217 1.50525Z"
        fill="#0052B4"
      />
      <path
        d="M-0.000305176 12.0019C0.000538574 18.6287 5.37279 24.0005 11.9997 24.0005C14.1123 24.0005 16.0971 23.4538 17.8214 22.4952L8.34752 16.1744L-0.000305176 12.0019Z"
        fill="#0052B4"
      />
      <path
        d="M18.8213 2.12703C18.499 1.90395 18.165 1.69648 17.8209 1.50519L-0.000411987 11.9983C-0.000411987 11.9988 -0.000411987 11.9993 -0.000411987 11.9998C-0.000411987 12.0002 -0.000411987 12.0007 -0.000411987 12.0012L17.8209 22.4943C18.1651 22.3029 18.499 22.0955 18.8214 21.8724L2.05374 11.9998L18.8213 2.12703Z"
        fill="#D80027"
      />
      <path
        d="M20.8692 11.5526H19.4397C19.8114 11.1064 19.7885 10.4425 19.3698 10.0238C19.8133 9.58035 19.8133 8.86124 19.3698 8.41766L19.343 8.44447C19.7865 8.00099 19.8133 7.25507 19.3698 6.81158L12.9453 13.2361C13.3888 13.6797 14.0953 13.6744 14.5388 13.2308L14.6624 13.1178L17.7387 12.8382V14.1613H18.7822V12.7433L20.3474 12.601L20.8692 11.5526Z"
        fill="#A2001D"
      />
      <path d="M13.0439 14.6089L12 14.0872L13.0439 13.5654H19.8265V14.6089H13.0439Z" fill="#FFDA44" />
    </g>
    <defs>
      <clipPath id="clip0_5_1337">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1426)">
      <path
        d="M23.2541 16.173C23.7365 14.8731 24.0005 13.467 24.0005 11.9991C24.0005 10.5313 23.7365 9.12528 23.2541 7.82525L12.0005 6.78177L0.746848 7.82525C0.264505 9.12528 0.000457764 10.5313 0.000457764 11.9991C0.000457764 13.467 0.264505 14.8731 0.746848 16.173L12.0005 17.2165L23.2541 16.173Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0006 23.9995C17.1601 23.9995 21.5587 20.743 23.2542 16.1734H0.746933C2.4425 20.743 6.84096 23.9995 12.0006 23.9995Z"
        fill="#D80027"
      />
      <path d="M12.0002 0C6.8406 0 2.44213 3.2565 0.746567 7.82611H23.2538C21.5583 3.2565 17.1598 0 12.0002 0Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_5_1426">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1409)">
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z"
        fill="#0052B4"
      />
      <path
        d="M11.9678 12.0004H11.9999C11.9999 11.9895 11.9999 11.9791 11.9999 11.9682C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9997 6.26165C11.9997 4.15017 11.9997 2.76656 11.9997 0.000793457H11.9977C5.37125 0.00187158 -0.000244141 5.37398 -0.000244141 12.0007H6.26061V8.47518L9.78617 12.0007H11.9677C11.9784 11.9901 11.9891 11.9794 11.9998 11.9686C11.9998 11.1602 11.9998 10.4388 11.9998 9.78726L8.47419 6.26165H11.9997Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07114 1.5657C4.19431 2.63441 2.63403 4.19469 1.56532 6.07152V12.0005H4.69578V4.6962V4.69616H12.0001C12.0001 3.70883 12.0001 2.76824 12.0001 1.5657H6.07114Z"
        fill="#D80027"
      />
      <path
        d="M12.0004 10.5249L7.73698 6.2615H6.26131C6.26131 6.26145 6.26131 6.2615 6.26131 6.2615L12.0003 12.0005H12.0004C12.0004 12.0005 12.0004 10.9831 12.0004 10.5249Z"
        fill="#D80027"
      />
      <path
        d="M7.23755 14.0865L7.89614 15.4635L9.38335 15.1198L8.71735 16.4933L9.91331 17.4418L8.42424 17.7774L8.42841 19.3038L7.23755 18.3488L6.04674 19.3038L6.05091 17.7774L4.56178 17.4418L5.7578 16.4933L5.0917 15.1198L6.579 15.4635L7.23755 14.0865Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.9671 16.6954L18.2964 17.3839L19.04 17.212L18.707 17.8988L19.305 18.373L18.5604 18.5408L18.5625 19.3041L17.9671 18.8265L17.3717 19.3041L17.3738 18.5408L16.6292 18.373L17.2272 17.8988L16.8942 17.212L17.6378 17.3839L17.9671 16.6954Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.9034 9.39142L15.2327 10.08L15.9763 9.90807L15.6433 10.5948L16.2413 11.0691L15.4968 11.2369L15.4988 12.0001L14.9034 11.5226L14.308 12.0001L14.31 11.2369L13.5655 11.0691L14.1635 10.5948L13.8305 9.90807L14.5741 10.08L14.9034 9.39142Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.9671 5.21762L18.2964 5.90622L19.04 5.73432L18.707 6.42109L19.305 6.89528L18.5604 7.06314L18.5625 7.82636L17.9671 7.34884L17.3717 7.82636L17.3738 7.06314L16.6292 6.89528L17.2272 6.42109L16.8942 5.73432L17.6378 5.90622L17.9671 5.21762Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.6422 8.34778L20.9714 9.03637L21.7151 8.86443L21.3821 9.5512L21.9801 10.0254L21.2355 10.1933L21.2376 10.9565L20.6422 10.479L20.0468 10.9565L20.0488 10.1933L19.3043 10.0254L19.9023 9.5512L19.5693 8.86443L20.3129 9.03637L20.6422 8.34778Z"
        fill="#F0F0F0"
      />
      <path
        d="M18.7292 12.0003L18.9882 12.7975H19.8264L19.1483 13.2902L19.4074 14.0873L18.7292 13.5946L18.0511 14.0873L18.3101 13.2902L17.632 12.7975H18.4702L18.7292 12.0003Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1409">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1400)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path d="M12 24.0002C15.6371 24.0002 18.896 22.3819 21.0966 19.8264H2.90341C5.10405 22.3819 8.36294 24.0002 12 24.0002Z" fill="#338AF3" />
      <path
        d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z"
        fill="#338AF3"
      />
      <path
        d="M0.953644 16.6962C1.18497 17.2398 1.45539 17.7625 1.76107 18.2614H22.2385C22.5442 17.7625 22.8146 17.2397 23.046 16.6962H0.953644Z"
        fill="#338AF3"
      />
      <path
        d="M5.49897 7.56907L3.15446 6.53435L5.49897 5.49964L6.53364 3.15518L7.56831 5.49964L9.91276 6.53435L7.56831 7.56907L6.53364 9.91353L5.49897 7.56907Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.5337 4.44733L7.17265 5.89525L8.62062 6.5343L7.17265 7.1733L6.5337 8.62122L5.89465 7.1733L4.44673 6.5343L5.89465 5.89525L6.5337 4.44733Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1400">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AX: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1317)">
      <path
        d="M23.5864 15.1299C23.8554 14.1317 23.9998 13.0826 23.9998 11.9994C23.9998 10.9163 23.8554 9.86714 23.5864 8.86898L10.9563 0.0450897C8.61155 0.247121 6.45985 1.12321 4.69543 2.47889L0.413162 8.86898C0.144146 9.86714 -0.000228882 10.9163 -0.000228882 11.9994C-0.000228882 13.0762 0.142412 14.1196 0.408427 15.1125L4.69538 21.52C6.4598 22.8757 8.61151 23.7518 10.9562 23.9538L23.5864 15.1299Z"
        fill="#FFDA44"
      />
      <path d="M0.412949 15.1305C1.10726 17.7067 2.6375 19.9396 4.69521 21.5206V15.1305H0.412949Z" fill="#0052B4" />
      <path
        d="M10.9559 23.9544C11.2999 23.984 11.6477 24.0001 11.9994 24.0001C17.5437 24.0001 22.209 20.2397 23.586 15.1305H10.9559V23.9544Z"
        fill="#0052B4"
      />
      <path d="M23.586 8.86955C22.209 3.76036 17.5437 0 11.9994 0C11.6477 0 11.2999 0.0160312 10.9559 0.0456562V8.86955H23.586Z" fill="#0052B4" />
      <path d="M4.69521 2.47978C2.6375 4.06088 1.10726 6.29367 0.412949 8.86988H4.69521V2.47978Z" fill="#0052B4" />
      <path
        d="M23.8987 10.4343H9.39165H9.3916V0.284729C8.28263 0.530635 7.23127 0.929213 6.26115 1.45857V10.4342H0.101868C0.0350712 10.9466 0.000289917 11.469 0.000289917 11.9995C0.000289917 12.53 0.0350712 13.0524 0.101868 13.5647H6.2611H6.26115V22.5404C7.23127 23.0697 8.28263 23.4684 9.3916 23.7142V13.5648V13.5647H23.8987C23.9654 13.0524 24.0003 12.53 24.0003 11.9995C24.0003 11.469 23.9654 10.9466 23.8987 10.4343Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1317">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const AZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1432)">
      <path
        d="M23.9996 12C23.9996 10.5322 23.7356 9.12608 23.2532 7.82615L11.9996 7.30438L0.745979 7.8261C0.263635 9.12608 -0.000411987 10.5322 -0.000411987 12C-0.000411987 13.4679 0.263635 14.874 0.745979 16.1739L11.9996 16.6957L23.2532 16.174C23.7356 14.874 23.9996 13.4679 23.9996 12Z"
        fill="#D80027"
      />
      <path
        d="M12.0003 23.9995C17.1599 23.9995 21.5584 20.743 23.2539 16.1734H0.746719C2.44224 20.743 6.84075 23.9995 12.0003 23.9995Z"
        fill="#6DA544"
      />
      <path
        d="M0.746719 7.82519H23.254C21.5584 3.25558 17.1599 -0.000915527 12.0003 -0.000915527C6.84075 -0.000915527 2.44224 3.25558 0.746719 7.82519Z"
        fill="#338AF3"
      />
      <path
        d="M12.2605 15.3911C10.3876 15.3911 8.86922 13.8727 8.86922 11.9997C8.86922 10.1268 10.3876 8.60843 12.2605 8.60843C12.8445 8.60843 13.394 8.75609 13.8737 9.01606C13.1211 8.28007 12.0919 7.82581 10.9562 7.82581C8.65097 7.82581 6.7823 9.69452 6.7823 11.9997C6.7823 14.3049 8.65102 16.1736 10.9562 16.1736C12.092 16.1736 13.1212 15.7193 13.8737 14.9833C13.394 15.2434 12.8445 15.3911 12.2605 15.3911Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.8695 9.65082L15.3187 10.9141L16.5297 10.3384L15.954 11.5494L17.2173 11.9986L15.954 12.4479L16.5297 13.6589L15.3187 13.0831L14.8695 14.3465L14.4204 13.0831L13.2093 13.6589L13.7851 12.4479L12.5217 11.9986L13.7851 11.5494L13.2093 10.3384L14.4204 10.9141L14.8695 9.65082Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1432">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1624)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.9995 -0.000701904C7.74463 -0.000701904 4.00729 2.21381 1.87654 5.553L18.1496 22.3047C21.6532 20.2093 23.9995 16.3785 23.9995 11.9993C23.9995 5.37192 18.6269 -0.000701904 11.9995 -0.000701904Z"
        fill="#FFDA44"
      />
      <path
        d="M24.0001 11.9991C24.0001 8.8856 22.8142 6.04928 20.8696 3.91656V20.0817C22.8142 17.949 24.0001 15.1127 24.0001 11.9991Z"
        fill="#0052B4"
      />
      <path
        d="M14.9905 22.5869L16.2474 22.5861L16.6352 21.3904L17.0243 22.5857L17.6548 22.5853C18.0414 22.3783 18.4153 22.1509 18.7751 21.9042L2.09515 5.22433C1.82027 5.6254 1.56959 6.04418 1.34416 6.47824L1.49238 6.93349L2.74934 6.93269L1.7329 7.67215L2.12205 8.86741L1.10468 8.12923L0.497882 8.5706C0.174398 9.65698 0.000350952 10.8077 0.000350952 11.9991C0.000350952 18.6265 5.37298 23.9991 12.0003 23.9991C13.4015 23.9991 14.7464 23.7586 15.9964 23.317L14.9905 22.5869ZM2.67687 11.4774L3.06452 10.2817L2.04724 9.54344L3.30419 9.54265L3.6919 8.34691L4.08105 9.54218L5.33801 9.54138L4.32152 10.2808L4.71068 11.4761L3.6933 10.7379L2.67687 11.4774ZM5.26554 14.0861L5.65319 12.8904L4.63591 12.1521L5.89287 12.1513L6.28057 10.9556L6.66973 12.1509L7.92668 12.1501L6.91024 12.8895L7.2994 14.0848L6.28202 13.3466L5.26554 14.0861ZM7.85416 16.6948L8.24182 15.4991L7.22454 14.7608L8.48149 14.76L8.86919 13.5643L9.25835 14.7596L10.5153 14.7588L9.49887 15.4982L9.88802 16.6935L8.87065 15.9552L7.85416 16.6948ZM11.4593 18.564L10.4428 19.3035L10.8304 18.1078L9.81316 17.3695L11.0701 17.3687L11.4579 16.173L11.847 17.3682L13.104 17.3674L12.0875 18.1069L12.4767 19.3022L11.4593 18.564ZM13.0315 21.9122L13.4191 20.7165L12.4018 19.9782L13.6588 19.9774L14.0465 18.7817L14.4356 19.9769L15.6926 19.9761L14.6762 20.7156L15.0653 21.9109L14.0479 21.1726L13.0315 21.9122Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1624">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BB: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1455)">
      <path
        d="M17.2172 1.1909C15.6396 0.428058 13.8697 0.000183105 11.9998 0.000183105C10.13 0.000183105 8.36009 0.428058 6.78247 1.1909L5.73898 12.0002L6.78247 22.8095C8.36009 23.5723 10.13 24.0002 11.9998 24.0002C13.8697 24.0002 15.6396 23.5723 17.2172 22.8095L18.2607 12.0002L17.2172 1.1909Z"
        fill="#FFDA44"
      />
      <path
        d="M6.78273 1.19128C2.76883 3.13219 0.000106812 7.24261 0.000106812 12.0001C0.000106812 16.7577 2.76883 20.8681 6.78273 22.809V1.19128Z"
        fill="#0052B4"
      />
      <path
        d="M17.2176 1.19171V22.8094C21.2315 20.8685 24.0002 16.7581 24.0002 12.0006C24.0002 7.24309 21.2315 3.13262 17.2176 1.19171Z"
        fill="#0052B4"
      />
      <path
        d="M15.6522 7.30337L16.3522 7.65334L15.6522 7.30337L14.9522 6.9534C14.91 7.03783 13.996 8.8975 13.8467 11.7382H12.7827V7.30337L12 6.25989L11.2174 7.30337V11.7382H10.1534C10.004 8.8975 9.09008 7.03783 9.04784 6.9534L7.64787 7.65339C7.65753 7.67261 8.60876 9.60878 8.60876 12.5208V13.3034H11.2175V17.7382H12.7827V13.3034H15.3913V12.5207C15.3913 11.0152 15.6518 9.77378 15.8704 8.99744C16.1087 8.15087 16.3507 7.65648 16.3531 7.65156L15.6522 7.30337Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1455">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BD: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D" />
    <path
      d="M9.39127 17.2174C12.2727 17.2174 14.6086 14.8815 14.6086 12C14.6086 9.11855 12.2727 6.78265 9.39127 6.78265C6.50979 6.78265 4.17389 9.11855 4.17389 12C4.17389 14.8815 6.50979 17.2174 9.39127 17.2174Z"
      fill="#D80027"
    />
  </svg>
));
export const BE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1474)">
      <path
        d="M16.1736 0.746574C14.8736 0.26423 13.4675 0.000183105 11.9997 0.000183105C10.5318 0.000183105 9.12576 0.26423 7.82577 0.746574L6.78229 12.0002L7.82577 23.2538C9.12576 23.7362 10.5318 24.0002 11.9997 24.0002C13.4675 24.0002 14.8736 23.7362 16.1736 23.2538L17.217 12.0002L16.1736 0.746574Z"
        fill="#FFDA44"
      />
      <path
        d="M23.9999 11.9993C23.9999 6.83976 20.7434 2.4412 16.1738 0.745728V23.253C20.7434 21.5574 23.9999 17.1589 23.9999 11.9993Z"
        fill="#D80027"
      />
      <path
        d="M-0.000396729 12C-0.000396729 17.1596 3.2561 21.5581 7.82571 23.2536V0.746399C3.2561 2.44187 -0.000396729 6.84043 -0.000396729 12Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1474">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BF: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1718)">
      <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#D80027" />
      <path d="M24 12.0007C24 18.6281 18.6274 24.0007 12 24.0007C5.37262 24.0007 0 18.6281 0 12.0007" fill="#6DA544" />
      <path
        d="M12 7.82538L12.9064 10.6153H15.8402L13.4668 12.3396L14.3733 15.1297L12 13.4054L9.62665 15.1297L10.5333 12.3396L8.15984 10.6153H11.0935L12 7.82538Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1718">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1713)">
      <path
        d="M24 12.0007C24 10.5328 23.736 9.12671 23.2537 7.82677L12 7.30501L0.746436 7.82673C0.264093 9.12671 4.57764e-05 10.5328 4.57764e-05 12.0007C4.57764e-05 13.4685 0.264093 14.8746 0.746436 16.1745L12 16.6963L23.2537 16.1746C23.736 14.8746 24 13.4685 24 12.0007Z"
        fill="#496E2D"
      />
      <path
        d="M11.9999 23.9999C17.1595 23.9999 21.558 20.7434 23.2535 16.1738H0.746292C2.44181 20.7434 6.84032 23.9999 11.9999 23.9999Z"
        fill="#D80027"
      />
      <path
        d="M0.746292 7.82541H23.2536C21.558 3.2558 17.1595 -0.000701904 11.9999 -0.000701904C6.84032 -0.000701904 2.44181 3.2558 0.746292 7.82541Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1713">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1447)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0001 -0.000915527C9.59183 -0.000915527 7.34971 0.709006 5.4704 1.93024L8.5566 3.99879L4.69574 5.99876L8.5566 7.99872L4.69574 9.99869L8.5566 11.9984L4.69574 13.9984L8.5566 15.9983L4.69574 17.9984L8.5566 19.9984L5.47002 22.0676C7.34943 23.2891 9.59169 23.9991 12.0001 23.9991C18.6275 23.9991 24.0001 18.6265 24.0001 11.9991C24.0001 5.37171 18.6275 -0.000915527 12.0001 -0.000915527Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1447">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1723)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M19.307 2.48002C15.0108 -0.825891 8.98982 -0.825891 4.69363 2.47997L12.0003 9.78666L19.307 2.48002Z" fill="#D80027" />
      <path d="M12.0005 14.2139L4.69388 21.5205C8.99007 24.8264 15.0111 24.8264 19.3073 21.5205L12.0006 14.2138L12.0005 14.2139Z" fill="#D80027" />
      <path d="M9.7868 12.0003L2.48016 4.6936C-0.825744 8.98979 -0.825744 15.0108 2.48016 19.307L9.7868 12.0003Z" fill="#6DA544" />
      <path d="M14.2143 12.0003L21.5209 19.307C24.8268 15.0108 24.8268 8.98979 21.5209 4.6936L14.2143 12.0003Z" fill="#6DA544" />
      <path
        d="M12.0003 17.2179C14.8818 17.2179 17.2177 14.882 17.2177 12.0005C17.2177 9.11901 14.8818 6.78311 12.0003 6.78311C9.11883 6.78311 6.78293 9.11901 6.78293 12.0005C6.78293 14.882 9.11883 17.2179 12.0003 17.2179Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9999 8.34824L12.4517 9.13086H13.3554L12.9035 9.91344L13.3554 10.6961H12.4517L11.9999 11.4787L11.548 10.6961H10.6444L11.0962 9.91344L10.6444 9.13086H11.548L11.9999 8.34824Z"
        fill="#D80027"
      />
      <path
        d="M9.70352 12.001L10.1553 12.7836H11.059L10.6072 13.5662L11.059 14.3488H10.1553L9.70352 15.1314L9.25164 14.3488H8.34798L8.79981 13.5662L8.34798 12.7836H9.25164L9.70352 12.001Z"
        fill="#D80027"
      />
      <path
        d="M14.297 12.001L14.7488 12.7836H15.6525L15.2007 13.5662L15.6525 14.3488H14.7488L14.297 15.1314L13.8451 14.3488H12.9415L13.3933 13.5662L12.9415 12.7836H13.8451L14.297 12.001Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1723">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BJ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1490)">
      <path
        d="M7.82625 10.9568L8.86973 23.5869C9.86784 23.856 10.917 24.0003 12.0001 24.0003C18.6275 24.0003 24.0001 18.6277 24.0001 12.0003L7.82625 10.9568Z"
        fill="#D80027"
      />
      <path
        d="M7.82625 12.0002L8.86969 0.413574C9.86784 0.144558 10.917 0.000183105 12.0001 0.000183105C18.6275 0.000183105 24.0001 5.37281 24.0001 12.0002H7.82625Z"
        fill="#FFDA44"
      />
      <path
        d="M-0.000427246 11.9997C-0.000427246 17.544 3.75993 22.2093 8.86912 23.5863V0.413086C3.75993 1.79009 -0.000427246 6.45537 -0.000427246 11.9997Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1490">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M21.4265 9.65242H17.4786C17.4786 8.93206 16.8947 8.34808 16.1743 8.34808L15.1308 10.435C15.1308 10.435 16.2439 13.5655 16.2091 13.5655H17.5134C18.2338 13.5655 18.8177 12.9815 18.8177 12.2611C19.5381 12.2611 20.1221 11.6772 20.1221 10.9568H20.0786C20.799 10.9568 21.4265 10.3728 21.4265 9.65242Z"
      fill="#ACABB1"
    />
    <path
      d="M2.57417 9.65224H6.52199C6.52199 8.93188 7.10597 8.3479 7.82632 8.3479L8.86982 10.4348C8.86982 10.4348 7.75675 13.5653 7.79156 13.5653H6.48723C5.76682 13.5653 5.18289 12.9814 5.18289 12.261C4.46249 12.261 3.87856 11.677 3.87856 10.9566H3.922C3.20159 10.9566 2.57417 10.3726 2.57417 9.65224Z"
      fill="#ACABB1"
    />
    <path d="M16.1737 16.6957V17.2174H7.82587V16.6957H5.73892V18.7826H7.82587V19.3043H16.1737V18.7826H18.2607V16.6957H16.1737Z" fill="#FFDA44" />
    <path
      d="M7.82587 8.34851V13.5659C7.82587 16.7608 11.9998 17.7398 11.9998 17.7398C11.9998 17.7398 16.1736 16.7608 16.1736 13.5659V8.34851L11.9998 7.82678L7.82587 8.34851Z"
      fill="#0052B4"
    />
    <path d="M16.1736 10.4341H7.82587V13.5646H16.1736V10.4341Z" fill="#D80027" />
    <path
      d="M14.0867 5.73875V6.52136L13.565 6.78225L13.0433 6.26047V4.69525H10.9563V6.26047L10.4346 6.78225L9.91281 6.52136V5.73875H7.82587V8.34742H16.1737V5.73875H14.0867Z"
      fill="#FFDA44"
    />
  </svg>
));
export const BM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1495)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027" />
      <path d="M11.9998 5.73889V9.78622L7.82596 5.73889H11.9998Z" fill="#0052B4" />
      <path d="M6.26078 11.9996H9.78629L6.26078 7.30396L5.73906 10.9561L6.26078 11.9996Z" fill="#0052B4" />
      <path
        d="M11.9683 12.0012H12.0005C12.0005 11.9904 12.0005 11.9798 12.0005 11.969C11.9898 11.9797 11.9791 11.9905 11.9683 12.0012Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9991 6.26141C11.9991 4.14992 11.9991 2.76641 11.9991 0.000549316H11.9971C5.37052 0.00167432 -0.000930786 5.37378 -0.000930786 12.0005H6.25993V8.47503L9.78544 12.0005H11.967C11.9777 11.9899 11.9884 11.9792 11.9991 11.9684C11.9991 11.16 11.9991 10.4386 11.9991 9.78702L8.47351 6.26141H11.9991Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.0706 1.56525C4.19377 2.63395 2.63345 4.19423 1.56479 6.07106V12.5218H4.69524V4.6958V4.6957H12.5213C12.5213 3.70837 12.5213 2.76778 12.5213 1.56525H6.0706Z"
        fill="#D80027"
      />
      <path
        d="M12.4763 11.0002L7.73577 6.25977H6.26015V6.25986L12.4762 12.4759H12.4763C12.4763 12.476 12.4763 11.4584 12.4763 11.0002Z"
        fill="#D80027"
      />
      <path d="M13.5652 6.25989V11.999C13.5652 14.7946 20.8696 14.7946 20.8696 11.999V6.25989H13.5652Z" fill="#F3F3F3" />
      <path
        d="M13.5652 12.0005V12.0005C13.5652 14.7961 17.2174 15.6527 17.2174 15.6527C17.2174 15.6527 20.8696 14.7961 20.8696 12.0005V12.0005H13.5652Z"
        fill="#6DA544"
      />
      <path d="M17.2175 9.70447L15.5218 10.4349V12.0001L17.2175 13.0436L18.9132 12.0001V10.4349L17.2175 9.70447Z" fill="#A2001D" />
      <path d="M18.9132 8.86859H15.5218V10.4338H18.9132V8.86859Z" fill="#338AF3" />
    </g>
    <defs>
      <clipPath id="clip0_5_1495">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12.0004 23.9977C18.6269 23.9977 23.9987 18.6259 23.9987 11.9994C23.9987 5.373 18.6269 0.00120544 12.0004 0.00120544C5.37399 0.00120544 0.00219727 5.373 0.00219727 11.9994C0.00219727 18.6259 5.37399 23.9977 12.0004 23.9977Z"
      fill="#F0F0F0"
    />
    <path
      d="M1.60954 6.00126C1.06798 6.93915 0.668502 7.91971 0.402481 8.91849L20.4681 20.5035C21.2001 19.7737 21.8496 18.9374 22.391 17.9995L1.60954 6.00126Z"
      fill="black"
    />
    <path
      d="M17.9988 1.60924C13.1979 -1.16249 7.27844 -0.238704 3.53178 3.49694L23.5974 15.0818C24.9593 9.96944 22.7996 4.38102 17.9988 1.60924Z"
      fill="#FFDA44"
    />
    <path
      d="M6.00068 22.3899C10.8014 25.1617 16.7211 24.2379 20.4677 20.5023L0.401955 8.91724C-0.95984 14.0298 1.19983 19.6182 6.00068 22.3899Z"
      fill="#FFDA44"
    />
    <path
      d="M15.3909 10.6963C15.3909 12.569 13.8728 14.0872 12.0001 14.0872C10.1274 14.0872 8.60927 12.569 8.60927 10.6963C8.60927 10.1125 8.75688 9.56303 9.01686 9.08334C8.28104 9.83584 7.82677 10.8649 7.82677 12.0005C7.82677 14.3053 9.6952 16.1738 12.0001 16.1738C14.305 16.1738 16.1734 14.3054 16.1734 12.0005C16.1734 10.8649 15.7192 9.83584 14.9833 9.08334C15.2433 9.56312 15.3909 10.1125 15.3909 10.6963Z"
      fill="#D80027"
    />
    <path d="M12.7828 6.78357H11.2178V14.6085H12.7828V6.78357Z" fill="#D80027" />
    <path
      d="M14.6081 8.34829H9.39149C9.39149 8.70844 9.70524 9.00038 10.0653 9.00038H10.0436C10.0436 9.36053 10.3356 9.65247 10.6957 9.65247C10.6957 10.0126 10.9877 10.3046 11.3478 10.3046H12.6519C13.0121 10.3046 13.304 10.0126 13.304 9.65247C13.6642 9.65247 13.9561 9.36053 13.9561 9.00038H13.9344C14.2944 9.00033 14.6081 8.70848 14.6081 8.34829Z"
      fill="#D80027"
    />
    <path d="M15.6521 15.13H8.3488V16.695H15.6521V15.13Z" fill="#D80027" />
    <path d="M16.6947 15.651H13.5648V17.216H16.6947V15.651Z" fill="#D80027" />
    <path d="M10.435 15.651H7.30504V17.216H10.435V15.651Z" fill="#D80027" />
  </svg>
));
export const BO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M24 12.0006C24 10.5328 23.736 9.12669 23.2536 7.82676L12 7.30499L0.746391 7.82671C0.264 9.12669 0 10.5328 0 12.0006C0 13.4685 0.264 14.8746 0.746391 16.1745L12 16.6963L23.2536 16.1746C23.736 14.8746 24 13.4685 24 12.0006Z"
      fill="#FFDA44"
    />
    <path d="M12 23.9999C17.1595 23.9999 21.5581 20.7434 23.2536 16.1738H0.746353C2.44187 20.7434 6.84038 23.9999 12 23.9999Z" fill="#6DA544" />
    <path
      d="M0.746185 7.82638H23.2534C21.5579 3.25677 17.1594 0.000274658 11.9998 0.000274658C6.84022 0.000274658 2.4417 3.25677 0.746185 7.82638Z"
      fill="#D80027"
    />
  </svg>
));
export const BQ1: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2890)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.9998 0.000919973C11.9886 -0.00751753 -0.00335471 11.9978 -0.000167211 12.0009C-0.000167211 5.37354 5.37246 0.000919973 11.9998 0.000919973Z"
        fill="#D80027"
      />
      <path
        d="M11.9998 -5.65897e-05C12.011 -0.00849409 24.003 11.9968 23.9998 11.9999C23.9998 5.37257 18.6272 -5.65897e-05 11.9998 -5.65897e-05Z"
        fill="#D80027"
      />
      <path
        d="M11.9995 23.9994C11.9883 24.0078 -0.00365989 12.0026 -0.000472387 11.9994C-0.000472387 18.6268 5.37215 23.9994 11.9995 23.9994Z"
        fill="#0052B4"
      />
      <path d="M11.9995 23.9989C12.0107 24.0073 24.0027 12.0021 23.9995 11.9989C23.9995 18.6263 18.6269 23.9989 11.9995 23.9989Z" fill="#0052B4" />
      <path
        d="M12 6.26068L13.295 10.2464H17.4859L14.0954 12.7097L15.3905 16.6955L12 14.2322L8.60952 16.6955L9.90458 12.7097L6.51411 10.2464H10.7049L12 6.26068Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2890">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BQ2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2997)">
      <path
        d="M5.23689 21.9128C7.1628 23.2293 9.49141 23.9997 12.0003 23.9997C14.5093 23.9997 16.8379 23.2293 18.7638 21.9128L12.0003 20.8693L5.23689 21.9128Z"
        fill="#D80027"
      />
      <path
        d="M18.7638 2.08709C16.8379 0.770606 14.5093 0.00012207 12.0003 0.00012207C9.49141 0.00012207 7.16271 0.770606 5.23689 2.08709L12.0003 3.13057L18.7638 2.08709Z"
        fill="#D80027"
      />
      <path
        d="M5.23689 21.9128C7.1628 23.2293 9.49141 23.9997 12.0003 23.9997C14.5093 23.9997 16.8379 23.2293 18.7638 21.9128L12.0003 20.8693L5.23689 21.9128Z"
        fill="#D80027"
      />
      <path
        d="M18.7638 2.08709C16.8379 0.770606 14.5093 0.00012207 12.0003 0.00012207C9.49141 0.00012207 7.16271 0.770606 5.23689 2.08709L12.0003 3.13057L18.7638 2.08709Z"
        fill="#D80027"
      />
      <path
        d="M23.9703 11.2165C23.686 7.51289 21.4357 3.91214 18.7643 2.08603H5.23744C2.27794 4.1092 0.27042 7.42271 0.0261078 11.2165L12.0009 11.9991L23.9703 11.2165Z"
        fill="#0052B4"
      />
      <path
        d="M0.0251312 12.7822C0.269444 16.576 2.27691 19.8895 5.23641 21.9126H18.7633C21.723 19.8895 23.7303 16.576 23.9746 12.7822L11.9999 11.9996L0.0251312 12.7822Z"
        fill="#0052B4"
      />
      <path
        d="M23.9695 11.2173H12.7827V1.56519H11.2175V11.2173H0.0253114C0.00867078 11.4761 4.57764e-05 11.737 4.57764e-05 12C4.57764e-05 12.2629 0.0086239 12.5238 0.0252645 12.7826H11.2175V22.4348H12.7827V12.7826H23.9749C23.9915 12.5238 24 12.2629 24 12C24 11.7389 23.9895 11.4779 23.9695 11.2173Z"
        fill="#D80027"
      />
      <path d="M4.69586 11.9993L12.0002 7.40823L19.3045 11.9993L12.0002 16.5903L4.69586 11.9993Z" fill="#F0F0F0" />
      <path
        d="M7.82591 14.0873H17.2172L15.1303 10.9568L14.0868 12.0003L13.0433 11.4786L11.9998 13.0438H9.91283L8.86935 12.0003L7.82591 14.0873Z"
        fill="#6DA544"
      />
      <path
        d="M12.0003 8.86896L12.2593 9.66607H13.0974L12.4194 10.1588L12.6784 10.9559L12.0003 10.4633L11.3222 10.9559L11.5812 10.1588L10.9032 9.66607H11.7413L12.0003 8.86896Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0002 6.09656L2.60896 11.9993L12.0002 17.9021L21.3916 11.9993L12.0002 6.09656ZM5.55028 11.9993L12.0002 7.94526L18.4503 11.9993L12.0002 16.0534L5.55028 11.9993Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2997">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BQ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1617)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M3.51494 3.51431C0.943141 6.0861 -0.216875 9.53489 0.0340473 12.898L12.8986 0.0334636C9.53547 -0.217505 6.08674 0.942511 3.51494 3.51431Z"
        fill="#FFDA44"
      />
      <path
        d="M4.28491 21.1899C8.99965 25.1565 16.0477 24.9219 20.4854 20.4843C24.923 16.0467 25.1576 8.99858 21.1909 4.28389L4.28491 21.1899Z"
        fill="#0052B4"
      />
      <path
        d="M11.9569 11.5167L12.991 10.9566L11.9569 10.3964C11.7155 8.82794 10.4762 7.58861 8.90771 7.34721L8.34751 6.31305L7.78735 7.34716C6.21892 7.58857 4.97963 8.82789 4.73813 10.3964L3.70398 10.9566L4.73809 11.5167C4.97954 13.0852 6.21882 14.3246 7.7873 14.566L8.34751 15.6001L8.90766 14.566C10.4762 14.3246 11.7155 13.0852 11.9569 11.5167ZM8.34755 13.0436C7.19495 13.0436 6.26059 12.1092 6.26059 10.9566C6.26059 9.80393 7.1949 8.86961 8.34755 8.86961C9.50021 8.86961 10.4345 9.80393 10.4345 10.9566C10.4345 12.1092 9.50016 13.0436 8.34755 13.0436Z"
        fill="black"
      />
      <path
        d="M8.34772 9.39093L8.79955 10.1735H9.70325L9.25137 10.9561L9.70325 11.7388H8.79955L8.34772 12.5213L7.89589 11.7388H6.99223L7.44406 10.9561L6.99223 10.1735H7.89589L8.34772 9.39093Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1617">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544" />
    <path d="M12.0004 4.69609L21.9134 12.0004L12.0004 19.3048L2.08736 12.0004L12.0004 4.69609Z" fill="#FFDA44" />
    <path
      d="M12.0001 16.1738C14.3053 16.1738 16.174 14.3051 16.174 11.9999C16.174 9.69476 14.3053 7.82605 12.0001 7.82605C9.69493 7.82605 7.82622 9.69476 7.82622 11.9999C7.82622 14.3051 9.69493 16.1738 12.0001 16.1738Z"
      fill="#F0F0F0"
    />
    <path
      d="M9.91318 11.7395C9.18737 11.7395 8.48692 11.8499 7.82758 12.0548C7.85678 14.3348 9.71321 16.1743 12.0002 16.1743C13.4143 16.1743 14.6632 15.4704 15.4182 14.3946C14.1265 12.7775 12.1389 11.7395 9.91318 11.7395Z"
      fill="#0052B4"
    />
    <path
      d="M16.0966 12.7998C16.1468 12.5409 16.174 12.2737 16.174 12.0001C16.174 9.69491 14.3053 7.82624 12.0001 7.82624C10.2801 7.82624 8.8035 8.86691 8.1645 10.3528C8.72934 10.2357 9.31415 10.1741 9.91317 10.1741C12.3374 10.174 14.5305 11.1817 16.0966 12.7998Z"
      fill="#0052B4"
    />
  </svg>
));
export const BS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1440)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M7.30568 7.82519H23.2549C21.5594 3.25558 17.1609 -0.000915527 12.0013 -0.000915527C8.68756 -0.000915527 5.68789 1.34247 3.51645 3.51419L7.30568 7.82519Z"
        fill="#338AF3"
      />
      <path
        d="M7.30468 16.1725H23.2539C21.5584 20.7421 17.1599 23.9986 12.0003 23.9986C8.68655 23.9986 5.68688 22.6552 3.51544 20.4835L7.30468 16.1725Z"
        fill="#338AF3"
      />
      <path
        d="M3.51444 3.51428C-1.17184 8.20056 -1.17184 15.7986 3.51444 20.4849C5.45098 18.5484 7.31347 16.6859 11.9997 11.9996L3.51444 3.51428Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1440">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1512)">
      <path
        d="M3.51422 20.4854C-1.17206 15.7991 -1.17206 8.20118 3.51422 3.51485C8.2005 -1.17148 15.7985 -1.17143 20.4848 3.51485C20.4848 3.51649 23.6708 14.2988 18.9845 18.9851C14.2983 23.6715 3.5175 20.4887 3.51422 20.4854Z"
        fill="#FFDA44"
      />
      <path
        d="M3.51466 20.4846C8.20094 25.1709 15.799 25.1709 20.4853 20.4846C25.1716 15.7983 25.1716 8.20036 20.4853 3.51404L3.51466 20.4846Z"
        fill="#FF9811"
      />
      <path
        d="M18.7885 6.78192V4.69495H14.7884L14.4828 5.00052C13.3958 6.08751 13.5787 7.35557 13.7122 8.28145C13.836 9.14034 13.8508 9.46935 13.5314 9.78881C13.212 10.1082 12.8829 10.0934 12.0241 9.96946C11.0982 9.83601 9.83021 9.65315 8.74323 10.7401C7.65629 11.827 7.83924 13.095 7.97284 14.0208C8.09673 14.8796 8.11164 15.2086 7.79232 15.5279C7.47296 15.8472 7.14385 15.8323 6.28524 15.7084C5.95046 15.6601 5.60429 15.6102 5.23473 15.6061L5.21181 17.693C5.44309 17.6955 5.70742 17.7336 5.98726 17.774C6.31857 17.8219 6.69357 17.876 7.08854 17.876C7.49785 17.876 7.92845 17.8176 8.3537 17.634V19.3037H11.4842V17.7385H9.91895V16.695H10.9624V15.1298H10.1284C10.168 14.6235 10.0984 14.1386 10.0384 13.7229C9.91454 12.8641 9.89964 12.5351 10.2189 12.2159C10.5384 11.8965 10.8673 11.9113 11.7263 12.0351C12.4009 12.1324 13.2572 12.2553 14.0929 11.8946V13.5646H17.2233V11.9994H15.6581V10.9559H16.7016V9.3907H15.8677C15.9073 8.88431 15.8378 8.39948 15.7778 7.98365C15.6913 7.3836 15.6579 7.04217 15.7547 6.78196H18.7885V6.78192Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1512">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1631)">
      <path
        d="M0.567067 8.34777C0.199474 9.49944 0.000395638 10.7263 0.000442513 11.9999C0.000395638 13.2735 0.199474 14.5004 0.567114 15.6521L12.0004 16.1739L23.4337 15.6521C23.8013 14.5004 24.0004 13.2734 24.0004 12C24.0004 10.7264 23.8013 9.49944 23.4337 8.34777L12.0004 7.82605L0.567067 8.34777Z"
        fill="#F0F0F0"
      />
      <path
        d="M24.0003 12.0005C24.0003 11.2887 23.938 10.5913 23.8191 9.91353H0.181648C0.0626794 10.5913 0.000335693 11.2886 0.000335693 12.0005C0.000335693 12.7124 0.0627263 13.4096 0.181648 14.0875H23.8191C23.9379 13.4096 24.0003 12.7124 24.0003 12.0005Z"
        fill="black"
      />
      <path
        d="M11.9998 23.9997C17.3537 23.9997 21.8879 20.4933 23.4331 15.6518H0.566513C2.11175 20.4932 6.64601 23.9996 11.9998 23.9997Z"
        fill="#338AF3"
      />
      <path
        d="M12.0003 -0.000625608C6.64652 -0.000625608 2.1123 3.50576 0.566971 8.34711L23.4335 8.34716C21.8884 3.50577 17.3541 -0.000719358 12.0003 -0.000625608Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1631">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1462)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC" />
      <path d="M4.95669 11.1289L3.65234 8.76256L4.95669 6.43329L6.26103 8.76256L4.95669 11.1289Z" fill="#A2001D" />
      <path d="M2.34777 11.1289L1.04343 8.76256L2.34777 6.43329L3.65211 8.76256L2.34777 11.1289Z" fill="#A2001D" />
      <path d="M4.95669 17.5644L3.65234 15.198L4.95669 12.8688L6.26103 15.198L4.95669 17.5644Z" fill="#A2001D" />
      <path d="M2.34777 17.5644L1.04343 15.198L2.34777 12.8688L3.65211 15.198L2.34777 17.5644Z" fill="#A2001D" />
      <path d="M6.26053 2.32881L5.89125 1.66937C5.2289 2.06181 4.60767 2.51617 4.03528 3.02448L4.95619 4.69516L6.26053 2.32881Z" fill="#A2001D" />
      <path d="M4.95617 19.3043L4.02551 20.9663C4.59739 21.4752 5.2182 21.9303 5.88026 22.3235L6.26056 21.6336L4.95617 19.3043Z" fill="#A2001D" />
      <path
        d="M7.3042 15.1307V23.0461C8.7465 23.6601 10.3334 24.0002 11.9999 24.0002C17.1594 24.0002 21.5579 20.7437 23.2535 16.1741L7.3042 15.1307Z"
        fill="#6DA544"
      />
      <path
        d="M23.2535 16.1741C23.7359 14.8741 23.9999 13.468 23.9999 12.0002C23.9999 5.37281 18.6272 0.000183105 11.9999 0.000183105C10.3335 0.000183105 8.7465 0.340167 7.3042 0.953996V16.1741H23.2535V16.1741Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1462">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const BZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1479)">
      <path
        d="M23.9996 12C23.9996 7.88156 21.9245 4.24814 18.763 2.08701L11.9996 1.56525L5.23613 2.08697C2.07474 4.24814 -0.000411987 7.88161 -0.000411987 12C-0.000411987 16.1186 2.07474 19.752 5.23613 21.9131L11.9996 22.4348L18.763 21.9131C21.9245 19.752 23.9996 16.1186 23.9996 12Z"
        fill="#0052B4"
      />
      <path
        d="M18.764 2.08715C16.8381 0.770621 14.5094 0.000183105 12.0005 0.000183105C9.49161 0.000183105 7.1629 0.770621 5.23705 2.08715H18.764Z"
        fill="#A2001D"
      />
      <path
        d="M5.23631 21.9133C7.16213 23.2299 9.49088 24.0003 11.9998 24.0003C14.5087 24.0003 16.8374 23.2299 18.7632 21.9133H5.23631Z"
        fill="#A2001D"
      />
      <path
        d="M12.0004 17.7382C15.17 17.7382 17.7396 15.1687 17.7396 11.999C17.7396 8.82939 15.17 6.25989 12.0004 6.25989C8.83076 6.25989 6.26126 8.82939 6.26126 11.999C6.26126 15.1687 8.83076 17.7382 12.0004 17.7382Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9999 16.6955C14.5932 16.6955 16.6955 14.5931 16.6955 11.9998C16.6955 9.40646 14.5932 7.30414 11.9999 7.30414C9.40653 7.30414 7.30421 9.40646 7.30421 11.9998C7.30421 14.5931 9.40653 16.6955 11.9999 16.6955Z"
        fill="#6DA544"
      />
      <path
        d="M11.9997 15.1295C13.7286 15.1295 15.1301 13.7279 15.1301 11.999C15.1301 10.2701 13.7286 8.86859 11.9997 8.86859C10.2708 8.86859 8.8692 10.2701 8.8692 11.999C8.8692 13.7279 10.2708 15.1295 11.9997 15.1295Z"
        fill="#F0F0F0"
      />
      <path d="M11.9995 11.2171L10.3039 11.9997V13.3041L11.9995 14.3476L13.6952 13.3041V11.9997L11.9995 11.2171Z" fill="#0052B4" />
      <path d="M13.6952 10.4359H10.3039V12.0011H13.6952V10.4359Z" fill="#FFDA44" />
    </g>
    <defs>
      <clipPath id="clip0_5_1479">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1750)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M24.0008 12.0011C24.0008 7.24352 21.2322 3.13277 17.2182 1.19177V22.8103C21.2322 20.8693 24.0008 16.7586 24.0008 12.0011Z"
        fill="#D80027"
      />
      <path
        d="M0.000457764 12.0004C0.000457764 16.7579 2.76913 20.8687 6.78308 22.8097V1.19113C2.76913 3.13213 0.000457764 7.24288 0.000457764 12.0004Z"
        fill="#D80027"
      />
      <path
        d="M14.0875 13.5662L16.1745 12.5227L15.131 12.001V10.9575L13.0441 12.001L14.0875 9.91405H13.0441L12.0006 8.34885L10.9571 9.91405H9.9136L10.9571 12.001L8.87011 10.9575V12.001L7.82668 12.5227L9.9136 13.5662L9.39188 14.6097H11.4788V16.1749H12.5223V14.6097H14.6093L14.0875 13.5662Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1750">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544" />
    <path
      d="M18.4212 17.2178L18.7505 17.9063L19.4942 17.7345L19.1612 18.4212L19.7591 18.8954L19.0146 19.0632L19.0167 19.8265L18.4212 19.349L17.8258 19.8265L17.8279 19.0632L17.0834 18.8954L17.6814 18.4212L17.3484 17.7345L18.092 17.9063L18.4212 17.2178Z"
      fill="#FFDA44"
    />
    <path
      d="M15.3579 9.91229L15.6872 10.6008L16.4308 10.4289L16.0978 11.1158L16.6958 11.5899L15.9513 11.7578L15.9533 12.521L15.3579 12.0435L14.7625 12.521L14.7645 11.7578L14.02 11.5899L14.618 11.1158L14.285 10.4289L15.0286 10.6008L15.3579 9.91229Z"
      fill="#FFDA44"
    />
    <path
      d="M18.4213 5.73828L18.7506 6.42683L19.4942 6.25489L19.1613 6.9417L19.7592 7.41594L19.0146 7.5837L19.0167 8.34697L18.4213 7.86945L17.8259 8.34697L17.828 7.5837L17.0835 7.41594L17.6814 6.9417L17.3484 6.25489L18.092 6.42683L18.4213 5.73828Z"
      fill="#FFDA44"
    />
    <path
      d="M21.0972 8.87018L21.4265 9.55872L22.1701 9.38683L21.8371 10.0736L22.4351 10.5478L21.6906 10.7156L21.6926 11.4789L21.0972 11.0014L20.5018 11.4789L20.5038 10.7156L19.7593 10.5478L20.3573 10.0736L20.0242 9.38683L20.7679 9.55872L21.0972 8.87018Z"
      fill="#FFDA44"
    />
    <path
      d="M19.1841 12.5212L19.4432 13.3184H20.2814L19.6032 13.811L19.8623 14.6081L19.1841 14.1155L18.5061 14.6081L18.765 13.811L18.087 13.3184H18.9251L19.1841 12.5212Z"
      fill="#FFDA44"
    />
    <path
      d="M13.3045 15.3914C11.4315 15.3914 9.91317 13.873 9.91317 12.0001C9.91317 10.1272 11.4315 8.6088 13.3045 8.6088C13.8885 8.6088 14.438 8.7565 14.9177 9.01642C14.1652 8.28039 13.136 7.82617 12.0001 7.82617C9.69497 7.82617 7.82625 9.69489 7.82625 12.0001C7.82625 14.3052 9.69497 16.174 12.0001 16.174C13.136 16.174 14.1652 15.7197 14.9177 14.9837C14.438 15.2437 13.8885 15.3914 13.3045 15.3914Z"
      fill="#FFDA44"
    />
    <path d="M7.54688 4.69552C7.18595 4.0719 6.51212 3.65204 5.7398 3.65204C4.96749 3.65204 4.29366 4.0719 3.93272 4.69552H7.54688Z" fill="#FFDA44" />
    <path
      d="M7.55319 4.70746L5.73917 6.52147L3.92516 4.70746C3.75177 5.01172 3.65225 5.36361 3.65225 5.73889C3.65225 6.8915 4.58661 7.82586 5.73922 7.82586C6.89183 7.82586 7.82619 6.89155 7.82619 5.73889C7.82614 5.36361 7.72658 5.01172 7.55319 4.70746Z"
      fill="#FFDA44"
    />
    <path
      d="M5.21735 6.00049V7.76083C5.38408 7.80372 5.55893 7.82655 5.73907 7.82655C5.91921 7.82655 6.09405 7.80367 6.26079 7.76083V6.00049H5.21735Z"
      fill="#A2001D"
    />
  </svg>
));
export const CD1: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2869)">
      <path
        d="M6.50509 22.6698L15.3206 15.3195L22.671 6.50393C21.5282 4.28919 19.7161 2.47611 17.5022 1.33185L8.67971 8.6786L1.33305 17.501C2.47722 19.715 4.2903 21.527 6.50509 22.6698Z"
        fill="#FFDA44"
      />
      <path
        d="M20.4853 20.4851C24.2712 16.6992 24.998 11.0134 22.6671 6.49719L6.49733 22.667C11.0135 24.9978 16.6994 24.271 20.4853 20.4851Z"
        fill="#D80027"
      />
      <path
        d="M3.51433 3.51375C-0.271567 7.29965 -0.998316 12.9855 1.33245 17.5017L17.5023 1.33191C12.9861 -0.998946 7.30023 -0.272103 3.51433 3.51375Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2869">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CD: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1938)">
      <path
        d="M22.6672 6.4984C22.1127 5.42407 21.3859 4.4157 20.4854 3.51514C19.5848 2.61453 18.5763 1.88773 17.502 1.33329L9.04819 9.0492L1.33224 17.5031C1.88672 18.5774 2.61352 19.5858 3.51408 20.4864C4.41464 21.3869 5.42306 22.1137 6.49735 22.6682L14.9512 14.9523L22.6672 6.4984Z"
        fill="#FFDA44"
      />
      <path
        d="M3.51462 20.4854C4.01801 20.9888 4.55515 21.4378 5.11854 21.8331L21.8334 5.11813C21.4382 4.55474 20.9892 4.0176 20.4858 3.51421C19.9824 3.01082 19.4453 2.5619 18.8819 2.16665L2.16705 18.8815C2.56226 19.4448 3.01118 19.9821 3.51462 20.4854Z"
        fill="#D80027"
      />
      <path
        d="M3.5143 3.51439C-0.271656 7.30034 -0.998453 12.9862 1.33245 17.5024L17.5023 1.33259C12.986 -0.99827 7.3002 -0.271379 3.5143 3.51439Z"
        fill="#338AF3"
      />
      <path
        d="M20.4855 20.4851C24.2714 16.6992 24.9982 11.0133 22.6674 6.49716L6.49757 22.6669C11.0137 24.9978 16.6996 24.2711 20.4855 20.4851Z"
        fill="#338AF3"
      />
      <path
        d="M6.39518 3.65116L7.04271 5.64414H9.13821L7.44293 6.87583L8.09046 8.86877L6.39518 7.63703L4.6998 8.86877L5.34743 6.87583L3.65205 5.64414H5.74755L6.39518 3.65116Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1938">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CF: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1777)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M22.5405 6.2603C20.9899 3.41831 18.3235 1.27289 15.13 0.41217L14.6083 6.2603H22.5405Z" fill="#0052B4" />
      <path d="M1.45898 6.26048H9.39117L8.86945 0.412354C5.676 1.27307 3.00966 3.41854 1.45898 6.26048Z" fill="#0052B4" />
      <path d="M14.6083 12.0016V17.7408H22.5405C23.4708 16.0359 23.9996 14.0806 23.9996 12.0016H14.6083Z" fill="#6DA544" />
      <path d="M9.39124 12.0007H-7.62939e-05C-7.62939e-05 14.0796 0.528814 16.035 1.459 17.7399H9.39119V12.0007H9.39124Z" fill="#6DA544" />
      <path d="M1.45908 17.7396C3.00975 20.5816 5.67609 22.727 8.86954 23.5878L9.39126 18.4733L1.45908 17.7396Z" fill="#FFDA44" />
      <path d="M15.13 23.5884C18.3235 22.7276 20.9899 20.5822 22.5405 17.7402L14.6083 18.4738L15.13 23.5884Z" fill="#FFDA44" />
      <path d="M14.6083 18.4738L22.5406 17.7402H14.6083V18.4738Z" fill="#FFDA44" />
      <path d="M9.39131 17.7396H1.45908L9.39131 18.4732V17.7396Z" fill="#FFDA44" />
      <path
        d="M12.0001 0.000366211C10.917 0.000366211 9.8678 0.144741 8.86964 0.413757V23.587C9.8678 23.856 10.917 24.0004 12.0001 24.0004C13.0832 24.0004 14.1324 23.856 15.1305 23.587V0.413757C14.1324 0.144741 13.0832 0.000366211 12.0001 0.000366211Z"
        fill="#D80027"
      />
      <path
        d="M6.45424 2.60913L6.77796 3.60555H7.82576L6.97817 4.2214L7.30193 5.21782L6.45424 4.60202L5.6066 5.21782L5.93046 4.2214L5.08287 3.60555H6.13057L6.45424 2.60913Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1777">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path d="M18.2604 9.91309H14.0865V5.73915H9.9126V9.91309H5.73871V14.087H9.9126V18.2609H14.0865V14.087H18.2604V9.91309Z" fill="#F0F0F0" />
  </svg>
));
export const CK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1857)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
      <path d="M11.9679 12.001H12C12 11.9902 12 11.9797 12 11.9689C11.9893 11.9796 11.9786 11.9903 11.9679 12.001Z" fill="#F0F0F0" />
      <path
        d="M11.9997 6.2619C11.9997 4.15041 11.9997 2.7669 11.9997 0.0010376H11.9977C5.37121 0.0021626 -0.000244141 5.37427 -0.000244141 12.001H6.26061V8.47552L9.78613 12.001H11.9677C11.9784 11.9903 11.9891 11.9797 11.9998 11.9689C11.9998 11.1605 11.9998 10.4391 11.9998 9.78751L8.47419 6.2619H11.9997Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07132 1.56451C4.19449 2.63322 2.63416 4.1935 1.56551 6.07033V11.9993H4.69596V4.69506V4.69497H12.0003C12.0003 3.70764 12.0003 2.76705 12.0003 1.56451H6.07132Z"
        fill="#D80027"
      />
      <path d="M12 10.5235L7.73652 6.26007H6.26089V6.26016L11.9999 11.9992H12C12 11.9992 12 10.9817 12 10.5235Z" fill="#D80027" />
      <path
        d="M16.1738 12L16.3959 12.6833H17.1143L16.5331 13.1055L16.7551 13.7888L16.1738 13.3665L15.5926 13.7888L15.8146 13.1055L15.2335 12.6833H15.9518L16.1738 12Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.2225 13.223L13.8626 13.5491L14.3706 13.0411L14.2582 13.7507L14.8983 14.0769L14.1887 14.1892L14.0764 14.8989L13.7502 14.2587L13.0406 14.3711L13.5487 13.8631L13.2225 13.223Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9995 16.1731L12.6828 15.9511L12.6829 15.2328L13.105 15.8139L13.7883 15.5918L13.366 16.1731L13.7883 16.7544L13.105 16.5324L12.6829 17.1135V16.3952L11.9995 16.1731Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.2225 19.1254L13.5486 18.4853L13.0406 17.9774L13.7502 18.0897L14.0764 17.4496L14.1887 18.1592L14.8983 18.2715L14.2582 18.5977L14.3706 19.3073L13.8626 18.7992L13.2225 19.1254Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.1738 20.3481L15.9518 19.6648H15.2334L15.8146 19.2426L15.5926 18.5593L16.1738 18.9816L16.7551 18.5593L16.5331 19.2426L17.1142 19.6648H16.3959L16.1738 20.3481Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.1248 19.1254L18.4847 18.7994L17.9768 19.3073L18.0891 18.5977L17.449 18.2716L18.1586 18.1592L18.271 17.4496L18.5971 18.0897L19.3067 17.9774L18.7986 18.4853L19.1248 19.1254Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.3478 16.1731L19.6645 16.3952V17.1135L19.2422 16.5323L18.559 16.7544L18.9813 16.1731L18.559 15.5918L19.2422 15.8139L19.6645 15.2328V15.9511L20.3478 16.1731Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.1248 13.223L18.7988 13.8631L19.3067 14.3711L18.5971 14.2587L18.271 14.8988L18.1586 14.1892L17.449 14.0768L18.0891 13.7507L17.9768 13.0411L18.4848 13.5491L19.1248 13.223Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1857">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1798)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M24.0001 12.0002C24.0001 18.6276 18.6275 24.0002 12.0001 24.0002C5.37273 24.0002 0.000106812 18.6276 0.000106812 12.0002C0.000106812 5.37287 12.0001 12.0002 12.0001 12.0002C12.0001 12.0002 21.0827 12.0002 24.0001 12.0002Z"
        fill="#D80027"
      />
      <path d="M0 12C0 5.37262 5.37262 0 12 0C12 4.56352 12 12 12 12C12 12 4.17389 12 0 12Z" fill="#0052B4" />
      <path
        d="M7.14282 4.17346L7.91987 6.56493H10.4344L8.4001 8.0429L9.1771 10.4344L7.14282 8.95635L5.10854 10.4344L5.88554 8.0429L3.85126 6.56493H6.36577L7.14282 4.17346Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1798">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1744)">
      <path
        d="M17.2173 1.19112C15.6397 0.428272 13.8698 0.000396729 12 0.000396729C10.1301 0.000396729 8.36023 0.428272 6.7826 1.19112L5.73912 12.0004L6.7826 22.8097C8.36023 23.5725 10.1301 24.0004 12 24.0004C13.8698 24.0004 15.6397 23.5725 17.2173 22.8097L18.2608 12.0004L17.2173 1.19112Z"
        fill="#D80027"
      />
      <path
        d="M12.0002 7.82538L13.0361 11.0138H16.389L13.6766 12.9846L14.7126 16.1732L12.0002 14.2025L9.28775 16.1732L10.3239 12.9846L7.61154 11.0138H10.9642L12.0002 7.82538Z"
        fill="#FFDA44"
      />
      <path
        d="M6.78296 1.19171C2.76905 3.13262 0.000335693 7.24304 0.000335693 12.0006C0.000335693 16.7581 2.76905 20.8685 6.78296 22.8094V1.19171Z"
        fill="#496E2D"
      />
      <path
        d="M17.2177 1.19171V22.8094C21.2316 20.8685 24.0004 16.7581 24.0004 12.0006C24.0004 7.24309 21.2316 3.13262 17.2177 1.19171Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1744">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M6.56736 7.30145L7.60329 10.489H10.9549L8.24548 12.4624L9.28142 15.6499L6.56736 13.6811L3.85329 15.6499L4.89392 12.4624L2.17986 10.489H5.53142L6.56736 7.30145Z"
      fill="#FFDA44"
    />
    <path
      d="M14.2262 18.5846L13.4341 17.6096L12.2622 18.0643L12.9419 17.0096L12.1497 16.03L13.3637 16.3534L14.0481 15.2987L14.1137 16.555L15.3325 16.8784L14.1559 17.3284L14.2262 18.5846Z"
      fill="#FFDA44"
    />
    <path
      d="M15.8018 15.7253L16.1768 14.5253L15.1502 13.7987L16.4065 13.78L16.7768 12.58L17.1846 13.7706L18.4408 13.7565L17.433 14.5065L17.8361 15.6971L16.8096 14.9706L15.8018 15.7253Z"
      fill="#FFDA44"
    />
    <path
      d="M17.9254 8.80662L17.3722 9.9363L18.2722 10.8129L17.0301 10.6347L16.4769 11.7597L16.2613 10.5222L15.0144 10.3441L16.1301 9.75818L15.9144 8.51599L16.8144 9.39255L17.9254 8.80662Z"
      fill="#FFDA44"
    />
    <path
      d="M14.2592 5.38507L14.1654 6.63664L15.3326 7.11007L14.1092 7.41007L14.0201 8.66632L13.3592 7.59757L12.1357 7.89757L12.9467 6.93664L12.281 5.87257L13.4482 6.34601L14.2592 5.38507Z"
      fill="#FFDA44"
    />
  </svg>
));
export const CO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1839)">
      <path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z" fill="#FFDA44" />
      <path
        d="M1.60587 18.0005C3.68079 21.5871 7.55848 24.0005 12.0001 24.0005C16.4418 24.0005 20.3194 21.5871 22.3944 18.0005L12.0001 17.2178L1.60587 18.0005Z"
        fill="#D80027"
      />
      <path
        d="M22.3938 17.9998C23.4148 16.2348 23.9995 14.1856 23.9995 11.9998H-0.000473022C-0.000473022 14.1856 0.584246 16.2348 1.60528 17.9998H22.3938Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1839">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1876)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.2536 7.82617H0.746375C0.264032 9.12616 -1.52588e-05 10.5322 -1.52588e-05 12.0001C-1.52588e-05 13.4679 0.264032 14.874 0.746375 16.174H23.2536C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617Z"
        fill="#D80027"
      />
      <path
        d="M12.0011 -0.000488281C8.36398 -0.000488281 5.10509 1.61782 2.90445 4.1734H21.0976C18.897 1.61782 15.6381 -0.000488281 12.0011 -0.000488281Z"
        fill="#0052B4"
      />
      <path
        d="M21.0963 19.826H2.90303C5.10367 22.3816 8.36256 23.9999 11.9996 23.9999C15.6367 23.9999 18.8956 22.3816 21.0963 19.826Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1876">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1909)">
      <path d="M0.000161316 2.08685H0.000114441V21.9129H0.000161316V11.9999V2.08685Z" fill="#FF9811" />
      <path
        d="M12 24.0001C18.6274 24.0001 24 18.6275 24 12.0002C24 5.37276 18.6274 0.000198364 12 0.000198364C5.37262 0.000198364 6.10352e-05 5.37276 6.10352e-05 12.0002C6.10352e-05 18.6275 5.37262 24.0001 12 24.0001Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9996 0.000244141C8.0737 0.000244141 4.58835 1.8857 2.39906 4.80024H21.6C19.4108 1.88565 15.9254 0.000244141 11.9996 0.000244141Z"
        fill="#0052B4"
      />
      <path
        d="M11.9996 24.0002C15.9254 24.0002 19.4108 22.1147 21.6001 19.2002H2.39906C4.58831 22.1148 8.0737 24.0002 11.9996 24.0002Z"
        fill="#0052B4"
      />
      <path
        d="M3.8147e-05 12.0002C3.8147e-05 12.8222 0.0829131 13.6248 0.240366 14.4002H23.7597C23.9172 13.6248 24 12.8222 24 12.0002C24 11.1783 23.9171 10.3757 23.7597 9.6002H0.240366C0.0829131 10.3757 3.8147e-05 11.1783 3.8147e-05 12.0002Z"
        fill="#0052B4"
      />
      <path
        d="M3.51479 3.5146C-1.17144 8.20084 -1.17144 15.7989 3.51479 20.4852C5.45134 18.5486 7.31377 16.6862 12.0001 11.9999L3.51479 3.5146Z"
        fill="#D80027"
      />
      <path
        d="M4.85661 8.86957L5.63352 11.2609H8.14817L6.11394 12.739L6.89084 15.1303L4.85661 13.6524L2.82228 15.1303L3.59938 12.739L1.56509 11.2609H4.07956L4.85661 8.86957Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1909">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1919)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M11.9998 24.0007C15.9373 24.0007 19.4318 22.1042 21.62 19.1749H2.37974C4.56786 22.1042 8.06235 24.0007 11.9998 24.0007Z"
        fill="#0052B4"
      />
      <path
        d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.419 0.246984 14.7803 0.699188 16.0439H23.3008C23.753 14.7803 24 13.419 24 12Z"
        fill="#0052B4"
      />
      <path
        d="M8.21368 7.69601L8.86116 9.68876H10.9567L9.26143 10.9205L9.90891 12.9134L8.21368 11.6817L6.51844 12.9134L7.16602 10.9205L5.47079 9.68876H7.56619L8.21368 7.69601Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.61493 5.6095L5.00343 6.80519H6.26076L5.24362 7.54422L5.63212 8.73995L4.61493 8.00092L3.59779 8.73995L3.98634 7.54422L2.96925 6.80519H4.22653L4.61493 5.6095Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1919">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CX: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1813)">
      <path
        d="M20.4857 20.4857C15.7994 25.172 8.20138 25.172 3.51506 20.4857C-1.17126 15.7995 -1.17122 8.20146 3.51506 3.51514C3.88396 3.884 13.1071 10.8936 13.1071 10.8936L20.4857 20.4857Z"
        fill="#0052B4"
      />
      <path d="M3.51508 3.51422C8.20135 -1.17206 15.7994 -1.17206 20.4857 3.51422C25.172 8.20049 25.172 15.7985 20.4857 20.4848" fill="#6DA544" />
      <path
        d="M12.0004 15.131C13.7293 15.131 15.1308 13.7295 15.1308 12.0006C15.1308 10.2717 13.7293 8.87012 12.0004 8.87012C10.2715 8.87012 8.86993 10.2717 8.86993 12.0006C8.86993 13.7295 10.2715 15.131 12.0004 15.131Z"
        fill="#FFDA44"
      />
      <path
        d="M4.46832 17.2175L4.79762 17.9061L5.5412 17.7342L5.2082 18.4209L5.80623 18.8952L5.06166 19.0629L5.06373 19.8262L4.46832 19.3487L3.87292 19.8262L3.87498 19.0629L3.13042 18.8952L3.72845 18.4209L3.3954 17.7342L4.13903 17.9061L4.46832 17.2175Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.31437 11.4769L2.64367 12.1654L3.38725 11.9935L3.05429 12.6803L3.65223 13.1545L2.90772 13.3223L2.90978 14.0856L2.31437 13.6081L1.71902 14.0856L1.72103 13.3223L0.976517 13.1545L1.5745 12.6803L1.2415 11.9935L1.98508 12.1654L2.31437 11.4769Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.46827 6.78186L4.79757 7.47041L5.54115 7.29847L5.20819 7.98528L5.80618 8.45951L5.06162 8.62728L5.06368 9.39054L4.46827 8.91307L3.87287 9.39054L3.87493 8.62728L3.13042 8.45951L3.72835 7.98528L3.39535 7.29847L4.13898 7.47041L4.46827 6.78186Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.14419 10.4346L7.47349 11.1232L8.21711 10.9512L7.88407 11.6381L8.48205 12.1123L7.73754 12.2801L7.73955 13.0433L7.14419 12.5658L6.54879 13.0433L6.55085 12.2801L5.80634 12.1123L6.40427 11.6381L6.07132 10.9512L6.8149 11.1232L7.14419 10.4346Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.23122 13.5646L5.49025 14.3617H6.32837L5.65028 14.8544L5.90931 15.6515L5.23122 15.1589L4.55313 15.6515L4.81216 14.8544L4.13406 14.3617H4.97219L5.23122 13.5646Z"
        fill="#F0F0F0"
      />
      <path
        d="M12 14.0872H13.0434C13.0434 14.0872 13.4956 13.2872 13.0434 12.522L14.0869 11.4785L13.5652 10.435H13.0435C13.0435 10.435 12.7826 11.2176 11.7391 11.2176C10.6957 11.2176 10.4348 10.435 10.4348 10.435H9.91309L10.4348 11.4785L9.91309 12.522L10.4348 13.0437C10.4348 13.0437 10.9565 12.0002 12 12.522C12 12.522 12.4434 13.1741 12 14.0872Z"
        fill="#6DA544"
      />
      <path
        d="M19.7889 6.57258C19.8135 6.44437 19.8266 6.31214 19.8266 6.17677C19.8266 5.24864 19.2206 4.4625 18.3828 4.19128C18.6388 4.7116 18.7831 5.29678 18.7831 5.91591C18.7831 6.12469 18.7663 6.32953 18.7347 6.52945C18.6087 6.32634 18.4467 6.14077 18.2488 5.98331C17.5035 5.39025 16.4849 5.37455 15.7319 5.874C16.3133 6.00094 16.8754 6.25898 17.3726 6.65456C17.7619 6.96431 18.0764 7.38328 18.3172 7.78772L15.1309 8.78545C18.2614 9.30717 20.87 7.22025 20.87 7.22025C20.581 6.64219 20.1321 6.54469 19.7889 6.57258Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1813">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const CY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC" />
    <path
      d="M18.7825 10.4344C18.4173 10.4344 17.9651 10.4344 17.2173 10.4344C17.2173 13.316 14.8814 15.6518 12 15.6518C9.11842 15.6518 6.7826 13.316 6.7826 10.4344C6.27822 10.4344 5.72167 10.4344 5.21739 10.4344C5.21739 13.5383 7.3022 16.1552 10.148 16.9611C9.83599 17.5538 9.88352 18.3 10.3292 18.8562C10.9146 18.387 11.5206 17.9013 12.0348 17.4894C12.5489 17.9014 13.155 18.387 13.7403 18.8562C14.1904 18.2945 14.2347 17.5388 13.9123 16.9432C16.7269 16.1175 18.7825 13.5162 18.7825 10.4344Z"
      fill="#6DA544"
    />
    <path
      d="M7.82621 9.91283C7.82621 9.91283 7.82621 12.5215 10.4349 12.5215L10.9566 13.0432H12.0001C12.0001 13.0432 12.5218 11.478 13.5653 11.478C13.5653 11.478 13.5653 10.4346 14.6088 10.4346C15.6523 10.4346 16.174 10.4346 16.174 10.4346C16.174 10.4346 15.6523 8.34758 18.261 6.78238L17.2175 6.26066C17.2175 6.26066 13.5653 8.86935 10.9566 8.34763V9.39111H9.91313L9.39141 8.8694L7.82621 9.91283Z"
      fill="#FFDA44"
    />
  </svg>
));
export const CZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1933)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M10.9569 11.9993C10.9569 11.9993 3.52213 20.4863 3.5151 20.4846C5.68663 22.6562 8.68668 23.9993 12.0004 23.9993C18.6278 23.9993 24.0004 18.6267 24.0004 11.9993H10.9569Z"
        fill="#D80027"
      />
      <path
        d="M3.51516 3.51461C-1.17112 8.20089 -1.17112 15.7989 3.51516 20.4852C5.45171 18.5487 7.3142 16.6862 12.0005 11.9999L3.51516 3.51461Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1933">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const DE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2130)">
      <path
        d="M0.7463 16.1749C2.44182 20.7445 6.84033 24.001 11.9999 24.001C17.1595 24.001 21.558 20.7445 23.2535 16.1749L11.9999 15.1315L0.7463 16.1749Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 0.000778198C6.84033 0.000778198 2.44182 3.25728 0.7463 7.82689L11.9999 8.87033L23.2535 7.82684C21.558 3.25728 17.1595 0.000778198 11.9999 0.000778198Z"
        fill="black"
      />
      <path
        d="M0.746435 7.82578C0.264091 9.12576 4.3869e-05 10.5318 4.3869e-05 11.9997C4.3869e-05 13.4675 0.264091 14.8736 0.746435 16.1736H23.2537C23.736 14.8736 24 13.4675 24 11.9997C24 10.5318 23.736 9.12576 23.2537 7.82578H0.746435Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2130">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const DJ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1954)">
      <path
        d="M10.9563 13.044C10.9563 13.044 3.52149 3.5136 3.51446 3.51528C5.68599 1.34371 8.68604 0.000549316 11.9998 0.000549316C18.6271 0.000549316 23.9998 5.37318 23.9998 12.0006L10.9563 13.044Z"
        fill="#338AF3"
      />
      <path
        d="M10.9563 11.9993C10.9563 11.9993 3.52149 20.4863 3.51446 20.4846C5.68599 22.6562 8.68604 23.9993 11.9998 23.9993C18.6271 23.9993 23.9998 18.6267 23.9998 11.9993H10.9563Z"
        fill="#6DA544"
      />
      <path
        d="M3.51443 3.5146C-1.17185 8.20088 -1.17185 15.7989 3.51443 20.4852C5.45097 18.5487 7.31346 16.6862 11.9997 11.9999L3.51443 3.5146Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.85631 8.86938L5.63327 11.2608H8.14792L6.11364 12.7388L6.89055 15.1303L4.85631 13.6523L2.82198 15.1303L3.59908 12.7388L1.5648 11.2608H4.07926L4.85631 8.86938Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1954">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const DK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1946)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M9.39195 10.4349H23.899C23.132 4.54709 18.0975 0.00012207 12.0006 0.00012207C11.1046 0.00012207 10.2319 0.099169 9.39191 0.285356V10.4349H9.39195Z"
        fill="#D80027"
      />
      <path d="M6.26144 10.4357V1.46C2.96646 3.25785 0.607611 6.55555 0.102158 10.4357H6.26144V10.4357Z" fill="#D80027" />
      <path d="M6.26095 13.5655H0.101715C0.607169 17.4457 2.96601 20.7434 6.261 22.5412L6.26095 13.5655Z" fill="#D80027" />
      <path
        d="M9.39191 13.5656V23.7151C10.2319 23.9013 11.1046 24.0003 12.0006 24.0003C18.0975 24.0003 23.132 19.4534 23.899 13.5655H9.39191V13.5656Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1946">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const DM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1960)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M14.3481 23.7693C19.092 22.8283 22.8289 19.0913 23.77 14.3475H14.3481V23.7693Z" fill="#496E2D" />
      <path d="M0.230148 14.3475C1.17116 19.0913 4.90813 22.8283 9.65202 23.7693V14.3475H0.230148Z" fill="#496E2D" />
      <path d="M23.77 9.65227C22.8289 4.90842 19.092 1.17145 14.3481 0.230392V9.65227H23.77Z" fill="#496E2D" />
      <path d="M9.65242 0.230453C4.90853 1.17152 1.17156 4.90848 0.230545 9.65233H9.65242V0.230453Z" fill="#496E2D" />
      <path d="M11.2171 14.3481H9.65188V23.77C10.1627 23.8713 10.6852 23.9399 11.2171 23.9742V14.3481Z" fill="#FFDA44" />
      <path d="M11.2176 9.65275V0.0266876C10.6857 0.0609064 10.1631 0.129578 9.6524 0.230875V9.65275H11.2176Z" fill="#FFDA44" />
      <path
        d="M12.7823 0.0266587C12.5235 0.00992432 12.2627 0.000549316 11.9997 0.000549316C11.7367 0.000549316 11.4759 0.00992432 11.2171 0.0266587V9.65277H12.7823V0.0266587H12.7823Z"
        fill="black"
      />
      <path
        d="M11.2171 23.9739C11.4759 23.9906 11.7367 24 11.9997 24C12.2627 24 12.5235 23.9906 12.7823 23.9739V14.3478H11.2171V23.9739H11.2171Z"
        fill="black"
      />
      <path d="M9.65203 11.2178V9.6526H0.230158C0.128814 10.1634 0.0601892 10.6859 0.0259705 11.2178H9.65203Z" fill="#FFDA44" />
      <path d="M14.3478 11.2183H23.9739C23.9397 10.6864 23.871 10.164 23.7697 9.65312H14.3478V11.2183H14.3478Z" fill="#FFDA44" />
      <path
        d="M14.348 12.7831H23.9741C23.9908 12.5243 24.0002 12.2635 24.0002 12.0005C24.0002 11.7375 23.9908 11.4767 23.974 11.2179H14.348V12.7831Z"
        fill="black"
      />
      <path
        d="M0.0260407 11.2179C0.00935321 11.4767 -6.86646e-05 11.7375 -6.86646e-05 12.0005C-6.86646e-05 12.2635 0.00935321 12.5243 0.0260407 12.7831H9.65215V11.2179H0.0260407V11.2179Z"
        fill="black"
      />
      <path
        d="M11.9999 17.7389C15.1695 17.7389 17.739 15.1694 17.739 11.9998C17.739 8.83015 15.1695 6.26065 11.9999 6.26065C8.83022 6.26065 6.26072 8.83015 6.26072 11.9998C6.26072 15.1694 8.83022 17.7389 11.9999 17.7389Z"
        fill="#D80027"
      />
      <path
        d="M13.307 12.6408C12.8801 11.7871 12.3252 10.9218 12.3252 10.9218C12.3252 10.9218 12.339 10.5278 12.339 10.2931C12.339 9.93943 12.0523 9.65274 11.6987 9.65274C11.3637 9.65274 11.0892 9.91013 11.0612 10.2378C10.7977 10.255 10.5893 10.4736 10.5893 10.7413C10.5893 10.936 10.6996 11.1047 10.861 11.189C10.9413 11.0013 11.0984 10.8548 11.2927 10.788C11.3244 10.8139 11.3585 10.8371 11.3948 10.8567L11.4768 10.896C11.4768 10.896 11.1726 11.7534 11.1726 12.214C11.1726 13.5089 12.0264 13.9082 12.0264 13.9082V13.9216L11.5995 14.3484H12.4533V13.4946L12.8802 13.9215C12.8839 13.9135 13.6888 13.4045 13.307 12.6408Z"
        fill="#496E2D"
      />
      <path
        d="M11.9996 7.30444L12.1938 7.90229H12.8224L12.3139 8.2718L12.5082 8.86964L11.9996 8.50018L11.491 8.86964L11.6853 8.2718L11.1768 7.90229H11.8053L11.9996 7.30444Z"
        fill="#496E2D"
      />
      <path
        d="M9.23995 8.20183L9.74845 8.57135L10.257 8.20178L10.0628 8.79972L10.5714 9.16914L9.94275 9.16919L9.7485 9.76704L9.5542 9.16919L8.92561 9.16914L9.43415 8.79963L9.23995 8.20183Z"
        fill="#496E2D"
      />
      <path
        d="M7.53404 10.5492H8.16259L8.35688 9.9514L8.55113 10.5492L9.17977 10.5492L8.67123 10.9188L8.86552 11.5166L8.35688 11.1471L7.84834 11.5166L8.04254 10.9187L7.53404 10.5492Z"
        fill="#496E2D"
      />
      <path
        d="M7.53404 13.4514L8.04254 13.0819L7.84829 12.4841L8.35689 12.8536L8.86548 12.4841L8.67123 13.0819L9.17982 13.4514L8.55114 13.4515L8.35689 14.0493L8.16259 13.4514H7.53404Z"
        fill="#496E2D"
      />
      <path
        d="M9.2399 15.799L9.4341 15.2013L8.92551 14.8318H9.55415L9.74844 14.2339L9.94269 14.8317H10.5713L10.0627 15.2013L10.257 15.7991L9.7484 15.4296L9.2399 15.799Z"
        fill="#496E2D"
      />
      <path
        d="M11.9996 16.6964L11.8053 16.0986H11.1768L11.6853 15.7291L11.491 15.1312L11.9996 15.5007L12.5081 15.1312L12.3139 15.7291L12.8224 16.0986L12.1938 16.0986L11.9996 16.6964Z"
        fill="#496E2D"
      />
      <path
        d="M14.7602 15.799L14.2517 15.4295L13.7432 15.7991L13.9374 15.2013L13.4288 14.8317L14.0574 14.8317L14.2516 14.2339L14.446 14.8317H15.0746L14.566 15.2013L14.7602 15.799Z"
        fill="#496E2D"
      />
      <path
        d="M16.466 13.4515H15.8375L15.6432 14.0494L15.4489 13.4516H14.8202L15.3288 13.082L15.1345 12.4842L15.6432 12.8537L16.1517 12.4842L15.9575 13.0821L16.466 13.4515Z"
        fill="#496E2D"
      />
      <path
        d="M16.466 10.5492L15.9575 10.9187L16.1517 11.5165L15.6432 11.147L15.1346 11.5166L15.3288 10.9187L14.8202 10.5492L15.4489 10.5492L15.6431 9.9514L15.8375 10.5492H16.466Z"
        fill="#496E2D"
      />
      <path
        d="M14.7602 8.20178L14.566 8.79958L15.0746 9.1691H14.446L14.2517 9.76699L14.0574 9.16915L13.4288 9.16919L13.9374 8.79958L13.7431 8.20183L14.2517 8.57125L14.7602 8.20178Z"
        fill="#496E2D"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1960">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const DO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M0.413795 15.131C1.52183 19.2421 4.75887 22.4792 8.87 23.5872V15.131H0.413795Z" fill="#D80027" />
    <path d="M8.86946 0.413391C4.75838 1.52138 1.52129 4.75847 0.413307 8.86955H8.86951V0.413391H8.86946Z" fill="#0052B4" />
    <path d="M23.5867 8.86967C22.4787 4.75859 19.2416 1.5215 15.1305 0.413513V8.86972H23.5867V8.86967Z" fill="#D80027" />
    <path d="M15.1305 23.587C19.2416 22.479 22.4787 19.242 23.5867 15.1308H15.1305V23.587Z" fill="#0052B4" />
    <path
      d="M15.1306 11.9998C15.1306 13.7288 13.7291 15.1303 12.0001 15.1303C10.2712 15.1303 8.86966 13.7288 8.86966 11.9998C8.86966 10.2709 12.0001 8.86938 12.0001 8.86938C12.0001 8.86938 15.1306 10.2709 15.1306 11.9998Z"
      fill="#496E2D"
    />
    <path d="M8.86966 11.9998C8.86966 10.2709 10.2712 8.86938 12.0001 8.86938C13.7291 8.86938 15.1306 10.2709 15.1306 11.9998" fill="#0052B4" />
    <path
      d="M10.2393 10.4344V12.391C10.2393 13.3635 11.0276 14.1518 12.0001 14.1518C12.9726 14.1518 13.761 13.3635 13.761 12.391V10.4344H10.2393Z"
      fill="#D80027"
    />
  </svg>
));
export const DS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3132)">
      <path
        d="M1.19118 6.78262C0.428333 8.36025 0.000457764 10.1301 0.000457764 12C0.000457764 13.8699 0.428333 15.6398 1.19118 17.2174L12.0005 18.2609L22.8097 17.2174C23.5726 15.6398 24.0005 13.8699 24.0005 12C24.0005 10.1301 23.5726 8.36025 22.8097 6.78262L12.0005 5.73914L1.19118 6.78262Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.19099 17.2167C3.1319 21.2306 7.24232 23.9993 11.9999 23.9993C16.7574 23.9993 20.8678 21.2306 22.8087 17.2167H1.19099Z"
        fill="black"
      />
      <path
        d="M1.19099 6.78287H22.8087C20.8678 2.76892 16.7574 0.000244141 11.9999 0.000244141C7.24232 0.000244141 3.1319 2.76892 1.19099 6.78287Z"
        fill="#D80027"
      />
      <path
        d="M3.51517 3.51392C-1.17111 8.2002 -1.17111 15.7982 3.51517 20.4845C5.45172 18.548 7.3142 16.6855 12.0005 11.9992L3.51517 3.51392Z"
        fill="#496E2D"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3132">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const DZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1330)">
      <path
        d="M12.0003 0C18.6277 0 24.0003 5.37262 24.0003 12C24.0003 18.6274 18.6277 24 12.0003 24C12.0003 23.4783 10.4351 12 10.4351 12L12.0003 0Z"
        fill="#F0F0F0"
      />
      <path d="M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0" fill="#496E2D" />
      <path
        d="M14.578 9.6987L13.5934 11.0555L11.9989 10.5384L12.985 11.894L12.0006 13.2508L13.5945 12.7318L14.5807 14.0874L14.5796 12.4111L16.1736 11.8921L14.5791 11.3751L14.578 9.6987Z"
        fill="#D80027"
      />
      <path
        d="M12.9952 15.392C11.1222 15.392 9.60386 13.8736 9.60386 12.0007C9.60386 10.1278 11.1222 8.60938 12.9952 8.60938C13.5791 8.60938 14.1287 8.75703 14.6084 9.017C13.8558 8.28102 12.8266 7.82675 11.6908 7.82675C9.38561 7.82675 7.51694 9.69547 7.51694 12.0006C7.51694 14.3058 9.38566 16.1745 11.6908 16.1745C12.8266 16.1745 13.8558 15.7203 14.6084 14.9843C14.1287 15.2443 13.5791 15.392 12.9952 15.392Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1330">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const EC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2007)">
      <path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z" fill="#FFDA44" />
      <path
        d="M1.60557 18.0009C3.68049 21.5876 7.55818 24.0009 11.9998 24.0009C16.4415 24.0009 20.3191 21.5876 22.3941 18.0009L11.9998 17.2183L1.60557 18.0009Z"
        fill="#D80027"
      />
      <path
        d="M22.3944 18.0002C23.4154 16.2352 24.0001 14.186 24.0001 12.0002H0.000114441C0.000114441 14.186 0.584833 16.2352 1.60586 18.0002H22.3944Z"
        fill="#0052B4"
      />
      <path
        d="M11.9997 16.1744C14.3049 16.1744 16.1736 14.3057 16.1736 12.0005C16.1736 9.69534 14.3049 7.82663 11.9997 7.82663C9.69451 7.82663 7.82579 9.69534 7.82579 12.0005C7.82579 14.3057 9.69451 16.1744 11.9997 16.1744Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0003 14.6092C10.5619 14.6092 9.39165 13.4389 9.39165 12.0005V10.4353C9.39165 8.99686 10.5619 7.82663 12.0003 7.82663C13.4387 7.82663 14.609 8.99691 14.609 10.4353V12.0005C14.609 13.439 13.4388 14.6092 12.0003 14.6092Z"
        fill="#338AF3"
      />
      <path
        d="M16.1737 5.73996H13.0432C13.0432 5.16368 12.576 4.69647 11.9997 4.69647C11.4234 4.69647 10.9562 5.16368 10.9562 5.73996H7.82579C7.82579 6.31629 8.32778 6.78344 8.90401 6.78344H8.86928C8.86928 7.35977 9.33643 7.82693 9.91276 7.82693C9.91276 8.40326 10.3799 8.87041 10.9562 8.87041H13.0432C13.6195 8.87041 14.0867 8.40326 14.0867 7.82693C14.663 7.82693 15.1302 7.35977 15.1302 6.78344H15.0955C15.6717 6.78344 16.1737 6.31624 16.1737 5.73996Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2007">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const EE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2040)">
      <path
        d="M-0.000297546 11.9995C-0.000297546 13.4673 0.263749 14.8734 0.746093 16.1734L11.9997 16.6951L23.2533 16.1734C23.7357 14.8734 23.9997 13.4673 23.9997 11.9995C23.9997 10.5316 23.7357 9.12558 23.2533 7.8256L11.9997 7.30383L0.746093 7.82555C0.263749 9.12558 -0.000297546 10.5316 -0.000297546 11.9995Z"
        fill="black"
      />
      <path
        d="M11.9997 -0.000305176C6.84009 -0.000305176 2.44157 3.25619 0.746056 7.8258H23.2533C21.5578 3.25619 17.1592 -0.000305176 11.9997 -0.000305176Z"
        fill="#0052B4"
      />
      <path
        d="M23.2533 16.1742H0.746056C2.44157 20.7438 6.84009 24.0003 11.9997 24.0003C17.1592 24.0003 21.5578 20.7438 23.2533 16.1742Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2040">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const EG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2015)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0002 -0.000305176C6.84061 -0.000305176 2.4421 3.25619 0.746582 7.8258H23.2538C21.5583 3.25619 17.1598 -0.000305176 12.0002 -0.000305176Z"
        fill="#D80027"
      />
      <path
        d="M12.0002 24.0003C17.1598 24.0003 21.5583 20.7438 23.2538 16.1742H0.746582C2.4421 20.7438 6.84061 24.0003 12.0002 24.0003Z"
        fill="black"
      />
      <path
        d="M16.1739 10.6956H13.0434C13.0434 10.1193 12.5762 9.65213 11.9999 9.65213C11.4237 9.65213 10.9565 10.1193 10.9565 10.6956H7.826C7.826 11.2719 8.32799 11.7391 8.90427 11.7391H8.86949C8.86949 12.3154 9.33664 12.7826 9.91297 12.7826C9.91297 13.3589 10.3801 13.8261 10.9565 13.8261H13.0434C13.6198 13.8261 14.0869 13.3589 14.0869 12.7826C14.6632 12.7826 15.1304 12.3154 15.1304 11.7391H15.0957C15.6719 11.7391 16.1739 11.2719 16.1739 10.6956Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2015">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const EH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1576)">
      <path
        d="M1.1907 6.78189C0.427854 8.35951 -2.09808e-05 10.1294 -2.09808e-05 11.9993C-2.09808e-05 13.8692 0.427854 15.639 1.1907 17.2166L12 18.2601L22.8093 17.2166C23.5721 15.639 24 13.8692 24 11.9993C24 10.1294 23.5721 8.35951 22.8093 6.78189L12 5.7384L1.1907 6.78189Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.19129 17.2178C3.1322 21.2317 7.24267 24.0004 12.0002 24.0004C16.7576 24.0004 20.8681 21.2317 22.809 17.2178H1.19129Z"
        fill="#496E2D"
      />
      <path
        d="M1.19129 6.78226H22.809C20.8681 2.76831 16.7577 -0.000366211 12.0002 -0.000366211C7.24262 -0.000366211 3.1322 2.76831 1.19129 6.78226Z"
        fill="black"
      />
      <path
        d="M3.51469 3.51501C-1.17159 8.2013 -1.17159 15.7993 3.51469 20.4856C5.45124 18.5491 7.31372 16.6866 12 12.0003L3.51469 3.51501Z"
        fill="#D80027"
      />
      <path
        d="M15.1305 12C15.1305 10.2516 16.3593 8.79103 18.0001 8.43272C17.7479 8.37764 17.4862 8.34778 17.2175 8.34778C15.2004 8.34778 13.5653 9.98287 13.5653 12C13.5653 14.017 15.2004 15.6521 17.2175 15.6521C17.4862 15.6521 17.7479 15.6223 18.0001 15.5672C16.3593 15.2089 15.1305 13.7483 15.1305 12Z"
        fill="#D80027"
      />
      <path
        d="M18.1533 9.6521L18.6714 11.2465H20.3477L18.9915 12.2317L19.5095 13.826L18.1533 12.8407L16.7971 13.826L17.3152 12.2317L15.9589 11.2465H17.6352L18.1533 9.6521Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1576">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ER: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2034)">
      <path
        d="M10.9568 10.9566C10.9568 10.9566 3.52205 20.4871 3.51501 20.4854C5.68655 22.6569 8.68659 24.0001 12.0003 24.0001C18.6277 24.0001 24.0003 18.6275 24.0003 12.0001L10.9568 10.9566Z"
        fill="#338AF3"
      />
      <path
        d="M10.9568 11.9997C10.9568 11.9997 3.52205 3.51274 3.51501 3.51443C5.68655 1.34285 8.68659 -0.000305176 12.0003 -0.000305176C18.6277 -0.000305176 24.0003 5.37232 24.0003 11.9997H10.9568Z"
        fill="#6DA544"
      />
      <path
        d="M3.51421 3.5155C-1.17207 8.20178 -1.17207 15.7998 3.51421 20.4861C3.51388 20.4881 23.9995 12.0008 23.9995 12.0008L3.51421 3.5155Z"
        fill="#D80027"
      />
      <path
        d="M6.26048 7.04321C3.95896 7.04321 2.08659 8.91563 2.08659 11.2171V12.7823C2.08659 15.0838 3.95901 16.9562 6.26048 16.9562C8.56195 16.9562 10.4344 15.0838 10.4344 12.7823V11.2171C10.4344 8.91563 8.56199 7.04321 6.26048 7.04321ZM8.86916 12.7824C8.86916 13.9482 8.10032 14.9377 7.04305 15.2709V13.565L8.15043 12.4576L7.04366 11.3508L7.04305 10.9569V10.4346H5.4779V11.9997L4.37127 13.1063L5.4779 14.2129V15.271C4.42063 14.9378 3.65179 13.9483 3.65179 12.7824V11.2172C3.65179 9.77874 4.82207 8.60851 6.26048 8.60851C7.69888 8.60851 8.86916 9.77879 8.86916 11.2172V12.7824Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2034">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ES: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3093)">
      <path
        d="M-1.52588e-05 11.9993C-1.52588e-05 13.4671 0.264032 14.8732 0.746375 16.1732L12 17.2167L23.2536 16.1732C23.7359 14.8732 24 13.4671 24 11.9993C24 10.5315 23.7359 9.12539 23.2536 7.82541L12 6.78192L0.746375 7.82541C0.264032 9.12539 -1.52588e-05 10.5315 -1.52588e-05 11.9993Z"
        fill="#FFDA44"
      />
      <path
        d="M23.2551 7.82574C21.5596 3.25618 17.1611 -0.000366211 12.0015 -0.000366211C6.84191 -0.000366211 2.44339 3.25618 0.747879 7.82574H23.2551Z"
        fill="#D80027"
      />
      <path
        d="M0.746902 16.174C2.44242 20.7435 6.84093 24.0001 12.0005 24.0001C17.1601 24.0001 21.5586 20.7435 23.2541 16.174H0.746902Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3093">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ET: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2045)">
      <path
        d="M-0.000183105 12C-0.000183105 13.4679 0.263864 14.874 0.746254 16.174L11.9998 17.2173L23.2534 16.1739C23.7358 14.874 23.9998 13.4679 23.9998 12C23.9998 10.5522 23.7434 9.1644 23.2735 7.87942L11.9998 6.78259L0.726098 7.87947C0.25627 9.1644 -0.000183105 10.5522 -0.000183105 12Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 24.0003C17.1595 24.0003 21.558 20.7438 23.2535 16.1742H0.746269C2.44178 20.7438 6.8403 24.0003 11.9999 24.0003Z"
        fill="#D80027"
      />
      <path
        d="M12 -0.000305176C6.8404 -0.000305176 2.44188 3.25619 0.746368 7.8258H23.2536C21.5581 3.25619 17.1596 -0.000305176 12 -0.000305176Z"
        fill="#6DA544"
      />
      <path
        d="M11.9997 17.7398C15.1694 17.7398 17.7389 15.1703 17.7389 12.0007C17.7389 8.83103 15.1694 6.26154 11.9997 6.26154C8.83011 6.26154 6.26061 8.83103 6.26061 12.0007C6.26061 15.1703 8.83011 17.7398 11.9997 17.7398Z"
        fill="#0052B4"
      />
      <path
        d="M11.9986 7.55646L13.0346 10.745H16.3926L13.6749 12.7157L14.7191 15.9137L11.9986 13.9336L9.28228 15.91L10.3222 12.7157L7.60701 10.745H10.9626L11.9986 7.55646Z"
        fill="#FFDA44"
      />
      <path
        d="M16.1308 12.7939L12.8441 11.7259L14.8753 8.9303L14.0312 8.31689L11.9999 11.1127L9.96873 8.31694L9.12451 8.93025L11.1557 11.7261L7.86915 12.7939L8.19155 13.7864L11.4782 12.7185V16.1742H12.5217V12.7185L15.8082 13.7864L16.1308 12.7939Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2045">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const FI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2089)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.8986 10.4347H9.39153H9.39148V0.285156C8.28251 0.531062 7.23115 0.929641 6.26103 1.459V10.4346V10.4347H0.101746C0.0349491 10.9471 0.000167847 11.4694 0.000167847 11.9999C0.000167847 12.5304 0.0349491 13.0528 0.101746 13.5651H6.26098H6.26103V22.5408C7.23115 23.0701 8.28251 23.4688 9.39148 23.7146V13.5653V13.5652H23.8986C23.9653 13.0528 24.0002 12.5304 24.0002 11.9999C24.0002 11.4694 23.9653 10.9471 23.8986 10.4347Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2089">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const FJ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2074)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#338AF3" />
      <path d="M11.9994 5.7403V9.78762L7.82547 5.7403H11.9994Z" fill="#0052B4" />
      <path d="M6.26051 12.0019H9.78607L6.26051 7.30621L5.73879 10.9584L6.26051 12.0019Z" fill="#0052B4" />
      <path
        d="M11.9674 12.0001H11.9995C11.9995 11.9893 11.9995 11.9788 11.9995 11.968C11.9888 11.9787 11.9781 11.9894 11.9674 12.0001Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9998 6.26153C11.9998 4.15005 11.9998 2.76653 11.9998 0.000671387H11.9977C5.37126 0.00179639 -0.000236511 5.37391 -0.000236511 12.0007H6.26062V8.47516L9.78618 12.0007H11.9677C11.9784 11.99 11.9891 11.9793 11.9999 11.9686C11.9999 11.1601 11.9999 10.4387 11.9999 9.78714L8.4742 6.26153H11.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07081 1.56586C4.19398 2.63456 2.6337 4.19484 1.56499 6.07167V12.0007H4.69545V4.69641V4.69631H11.9998C11.9998 3.70898 11.9998 2.76839 11.9998 1.56586H6.07081Z"
        fill="#D80027"
      />
      <path
        d="M11.9998 10.525L7.73642 6.2616H6.26075V6.26169L11.9998 12.0007H11.9998C11.9998 12.0007 11.9998 10.9832 11.9998 10.525Z"
        fill="#D80027"
      />
      <path
        d="M13.5655 7.82718V12.001C13.5655 14.7966 17.2177 15.6532 17.2177 15.6532C17.2177 15.6532 20.8699 14.7966 20.8699 12.001V7.82718L17.2177 6.78369L13.5655 7.82718Z"
        fill="#F3F3F3"
      />
      <path
        d="M20.8699 7.82625V6.26105H13.5655V7.82625H16.6959V10.9567H13.5655V12.0001C13.5655 12.0002 13.5655 12.0002 13.5655 12.0002L16.6959 12.0003V15.4923C17.0108 15.6037 17.2177 15.6524 17.2177 15.6524C17.2177 15.6524 17.4245 15.6038 17.7394 15.4923V12.0002H20.8699V12.0001V10.9567H17.7394V7.8262H20.8699V7.82625Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2074">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const FK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2054)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
      <path
        d="M11.9672 12.0003H11.9994C11.9994 11.9895 11.9994 11.979 11.9994 11.9681C11.9887 11.9789 11.978 11.9896 11.9672 12.0003Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9997 6.26074C11.9997 4.14925 11.9997 2.76574 11.9997 -0.00012207H11.9977C5.37118 0.00100293 -0.000312805 5.37311 -0.000312805 11.9999H6.26054V8.47436L9.7861 11.9999H11.9676C11.9783 11.9892 11.989 11.9785 11.9997 11.9678C11.9997 11.1593 11.9997 10.438 11.9997 9.78635L8.47412 6.26074H11.9997Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07064 1.56494C4.19381 2.63364 2.63353 4.19393 1.56483 6.07075V11.9997H4.69528V4.69549V4.69539H11.9996C11.9996 3.70807 11.9996 2.76747 11.9996 1.56494H6.07064Z"
        fill="#D80027"
      />
      <path d="M11.9997 10.5243L7.73628 6.26093H6.26061V6.26102L11.9996 12H11.9997C11.9997 12 11.9997 10.9825 11.9997 10.5243Z" fill="#D80027" />
      <path d="M19.3046 14.0864V14.6081H15.1307V14.0864H13.5655V16.1733H14.609V16.6951H19.8264V16.1733H20.8698V14.0864H19.3046Z" fill="#FFDA44" />
      <path
        d="M13.5655 6.26154V12.0007C13.5655 14.7963 17.2176 15.6528 17.2176 15.6528C17.2176 15.6528 20.8698 14.7963 20.8698 12.0007V6.26154H13.5655Z"
        fill="#338AF3"
      />
      <path
        d="M17.2179 10.5428C16.3049 10.5428 16.3049 11.3776 15.392 11.3776C14.479 11.3776 14.479 10.5428 13.566 10.5428V12.0037C14.479 12.0037 14.479 12.8385 15.392 12.8385C16.3049 12.8385 16.3049 12.0037 17.2179 12.0037C18.131 12.0037 18.131 12.8385 19.0441 12.8385C19.9573 12.8385 19.9572 12.0037 20.8703 12.0037V10.5428C19.9573 10.5428 19.9573 11.3776 19.0441 11.3776C18.131 11.3776 18.131 10.5428 17.2179 10.5428Z"
        fill="#F3F3F3"
      />
      <path
        d="M17.2176 7.6181C16.3046 7.6181 16.3046 8.4529 15.3916 8.4529C14.4787 8.4529 14.4787 7.6181 13.5657 7.6181V9.07896C14.4787 9.07896 14.4787 9.91376 15.3916 9.91376C16.3046 9.91376 16.3046 9.07896 17.2176 9.07896C18.1307 9.07896 18.1307 9.91376 19.0438 9.91376C19.9569 9.91376 19.9569 9.07896 20.87 9.07896V7.6181C19.9569 7.6181 19.9569 8.4529 19.0438 8.4529C18.1307 8.4529 18.1307 7.6181 17.2176 7.6181Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2054">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const FM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3" />
    <path
      d="M12.0002 5.21744L12.5182 6.81175H14.1946L12.8385 7.79711L13.3564 9.39138L12.0002 8.40606L10.644 9.39138L11.1621 7.79711L9.80587 6.81175H11.4823L12.0002 5.21744Z"
      fill="#F0F0F0"
    />
    <path
      d="M5.21735 11.9997L6.81166 11.4816V9.80518L7.79702 11.1615L9.39128 10.6435L8.40597 11.9997L9.39128 13.3558L7.79702 12.8377L6.81166 14.194V12.5176L5.21735 11.9997Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.0003 18.783L11.4823 17.1887H9.80587L11.1622 16.2033L10.6441 14.6091L12.0003 15.5944L13.3565 14.6091L12.8384 16.2033L14.1946 17.1887H12.5183L12.0003 18.783Z"
      fill="#F0F0F0"
    />
    <path
      d="M18.7829 11.9995L17.1886 12.5176V14.194L16.2032 12.8377L14.609 13.3557L15.5943 11.9995L14.609 10.6434L16.2032 11.1615L17.1886 9.80518V11.4816L18.7829 11.9995Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const FO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M23.4782 12L23.8982 10.4348C23.8284 9.90131 23.7238 9.37875 23.5866 8.86959H10.9565V0.0456543C10.424 0.0914981 9.90156 0.172545 9.39128 0.285701L7.30431 1.5652L6.26082 1.45987C5.71168 1.7595 5.18851 2.10075 4.69562 2.47945V8.86954H0.413355C0.276152 9.3787 0.171527 9.90126 0.101777 10.4347L0.521683 12L0.10173 13.5652C0.17148 14.0987 0.276105 14.6213 0.413308 15.1304H4.69557V21.5205C5.18846 21.8993 5.71168 22.2405 6.26078 22.5401L7.82598 22.4347L9.39118 23.7142C9.90151 23.8274 10.4239 23.9084 10.9564 23.9543V15.1305H23.5865C23.7237 14.6213 23.8283 14.0987 23.8981 13.5652L23.4782 12Z"
      fill="#0052B4"
    />
    <path
      d="M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 11.9999C0 12.5304 0.034875 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z"
      fill="#D80027"
    />
  </svg>
));
export const FR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z"
      fill="#D80027"
    />
    <path
      d="M0.000434875 12.0007C0.000434875 17.1603 3.25698 21.5588 7.82654 23.2544V0.747131C3.25698 2.44265 0.000434875 6.84116 0.000434875 12.0007Z"
      fill="#0052B4"
    />
  </svg>
));
export const GA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2110)">
      <path
        d="M23.2532 16.175C23.7356 14.875 23.9996 13.4689 23.9996 12.0011C23.9996 10.5332 23.7356 9.12721 23.2532 7.82718L11.9996 6.78369L0.745979 7.82718C0.263635 9.12721 -0.000411987 10.5332 -0.000411987 12.0011C-0.000411987 13.4689 0.263635 14.875 0.745979 16.175L11.9996 17.2184L23.2532 16.175Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0004 23.9997C17.1599 23.9997 21.5585 20.7432 23.2539 16.1736H0.746727C2.44229 20.7432 6.84076 23.9997 12.0004 23.9997Z"
        fill="#0052B4"
      />
      <path
        d="M12.0004 0.000732422C6.84076 0.000732422 2.44229 3.25723 0.746727 7.82684H23.254C21.5585 3.25723 17.1599 0.000732422 12.0004 0.000732422Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2110">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GB2: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4694 23.9651 10.9471 23.8984 10.4348Z"
      fill="#D80027"
    />
  </svg>
));
export const GB: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M2.48069 4.69299C1.53808 5.91938 0.827311 7.3329 0.413452 8.86848H6.65617L2.48069 4.69299Z" fill="#0052B4" />
    <path d="M23.587 8.86861C23.1732 7.33308 22.4624 5.91957 21.5198 4.69318L17.3444 8.86861H23.587Z" fill="#0052B4" />
    <path d="M0.413452 15.1302C0.827359 16.6657 1.53812 18.0792 2.48069 19.3056L6.65603 15.1302H0.413452Z" fill="#0052B4" />
    <path d="M19.3055 2.47976C18.0791 1.53715 16.6657 0.826382 15.1301 0.412476V6.65515L19.3055 2.47976Z" fill="#0052B4" />
    <path d="M4.69394 21.5177C5.92033 22.4603 7.33385 23.1711 8.86938 23.585V17.3423L4.69394 21.5177Z" fill="#0052B4" />
    <path d="M8.86933 0.412476C7.3338 0.826382 5.92028 1.53715 4.69394 2.47971L8.86933 6.6551V0.412476Z" fill="#0052B4" />
    <path d="M15.1301 23.585C16.6656 23.1711 18.0791 22.4603 19.3055 21.5177L15.1301 17.3423V23.585Z" fill="#0052B4" />
    <path d="M17.3444 15.1302L21.5198 19.3056C22.4624 18.0793 23.1732 16.6657 23.587 15.1302H17.3444Z" fill="#0052B4" />
    <path
      d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
      fill="#D80027"
    />
    <path d="M15.1304 15.1313L20.4852 20.4861C20.7315 20.2399 20.9665 19.9825 21.1906 19.7157L16.6062 15.1312H15.1304V15.1313Z" fill="#D80027" />
    <path d="M8.86954 15.1312H8.86944L3.51468 20.486C3.76087 20.7323 4.01826 20.9672 4.28507 21.1914L8.86954 16.6068V15.1312Z" fill="#D80027" />
    <path
      d="M8.86936 8.86911V8.86902L3.51455 3.51416C3.26827 3.76035 3.03333 4.01774 2.80917 4.28455L7.39369 8.86907H8.86936V8.86911Z"
      fill="#D80027"
    />
    <path d="M15.1304 8.87017L20.4853 3.51526C20.2391 3.26898 19.9817 3.03405 19.7149 2.80994L15.1304 7.39445V8.87017Z" fill="#D80027" />
  </svg>
));
export const GD: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2163)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M5.23633 2.08688C7.16219 0.770346 9.49085 -9.15527e-05 11.9998 -9.15527e-05C14.5087 -9.15527e-05 16.8374 0.770346 18.7632 2.08688L11.9998 2.6086L5.23633 2.08688Z"
        fill="#A2001D"
      />
      <path d="M12.0004 11.9995L11.2345 11.2336L11.0312 11.5979L12.0004 11.9995Z" fill="#0052B4" />
      <path
        d="M3.51517 3.51514C-1.17112 8.20142 -1.17112 15.7994 3.51517 20.4858C5.45171 18.5492 7.3142 16.6867 12.0005 12.0004L3.51517 3.51514Z"
        fill="#496E2D"
      />
      <path
        d="M20.4858 3.51592C25.1721 8.2022 25.1721 15.8002 20.4858 20.4865C18.5492 18.55 16.6868 16.6875 12.0005 12.0012L20.4858 3.51592Z"
        fill="#496E2D"
      />
      <path
        d="M12.0001 16.174C14.3053 16.174 16.174 14.3053 16.174 12.0002C16.174 9.69498 14.3053 7.82626 12.0001 7.82626C9.69494 7.82626 7.82622 9.69498 7.82622 12.0002C7.82622 14.3053 9.69494 16.174 12.0001 16.174Z"
        fill="#A2001D"
      />
      <path
        d="M11.9996 7.82637L12.9352 10.7059H15.9632L13.5136 12.4858L14.4492 15.3655L11.9996 13.5858L9.54993 15.3655L10.4857 12.4858L8.0361 10.7059H11.0639L11.9996 7.82637Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0043 -9.15527e-05H11.9963C8.6844 0.000986572 5.68622 1.34363 3.51558 3.51403H20.4849C18.3143 1.34363 15.3161 0.000986572 12.0043 -9.15527e-05Z"
        fill="#A2001D"
      />
      <path
        d="M3.51603 20.4857C5.68756 22.6569 8.68728 23.9998 12.0006 23.9998C15.314 23.9998 18.3137 22.6569 20.4852 20.4857H3.51603Z"
        fill="#A2001D"
      />
      <path
        d="M12.0004 1.30418L12.1947 1.90203H12.8233L12.3147 2.27154L12.509 2.86939L12.0004 2.49992L11.4918 2.86939L11.6861 2.27154L11.1775 1.90203H11.8061L12.0004 1.30418Z"
        fill="#FFDA44"
      />
      <path
        d="M9.09075 1.30418L9.28505 1.90203H9.91364L9.4051 2.27154L9.59939 2.86939L9.09075 2.49992L8.58225 2.86939L8.7765 2.27154L8.26786 1.90203H8.89646L9.09075 1.30418Z"
        fill="#FFDA44"
      />
      <path
        d="M14.91 1.30418L15.1043 1.90203H15.7329L15.2243 2.27154L15.4186 2.86939L14.91 2.49992L14.4015 2.86939L14.5958 2.27154L14.0871 1.90203H14.7157L14.91 1.30418Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0004 21.1297L12.1947 21.7276H12.8233L12.3147 22.0971L12.509 22.6949L12.0004 22.3254L11.4918 22.6949L11.6861 22.0971L11.1775 21.7276H11.8061L12.0004 21.1297Z"
        fill="#FFDA44"
      />
      <path
        d="M9.09075 21.1297L9.28505 21.7276H9.91364L9.4051 22.0971L9.59939 22.6949L9.09075 22.3254L8.58225 22.6949L8.7765 22.0971L8.26786 21.7276H8.89646L9.09075 21.1297Z"
        fill="#FFDA44"
      />
      <path
        d="M14.91 21.1297L15.1043 21.7276H15.7329L15.2243 22.0971L15.4186 22.6949L14.91 22.3254L14.4015 22.6949L14.5958 22.0971L14.0871 21.7276H14.7157L14.91 21.1297Z"
        fill="#FFDA44"
      />
      <path
        d="M3.65673 11.802C3.96493 12.2889 3.82009 12.9335 3.3331 13.2418C2.84616 13.55 2.20154 13.4052 1.89329 12.9182C1.33524 12.0366 1.65882 10.5967 1.65882 10.5967C1.65882 10.5967 3.09863 10.9203 3.65673 11.802Z"
        fill="#FFDA44"
      />
      <path
        d="M3.05355 13.3225C3.34169 13.3225 3.57527 13.0889 3.57527 12.8007C3.57527 12.5126 3.34169 12.279 3.05355 12.279C2.76541 12.279 2.53183 12.5126 2.53183 12.8007C2.53183 13.0889 2.76541 13.3225 3.05355 13.3225Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2163">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
      fill="#D80027"
    />
    <path d="M7.30428 5.73983V4.17458H5.73908V5.73983H4.17383V7.30503H5.73908V8.87023H7.30428V7.30503H8.86948V5.73983H7.30428Z" fill="#D80027" />
    <path d="M18.2608 5.73983V4.17458H16.6956V5.73983H15.1304V7.30503H16.6956V8.87023H18.2608V7.30503H19.8261V5.73983H18.2608Z" fill="#D80027" />
    <path d="M7.30428 16.6967V15.1315H5.73908V16.6967H4.17383V18.2619H5.73908V19.8271H7.30428V18.2619H8.86948V16.6967H7.30428Z" fill="#D80027" />
    <path d="M18.2608 16.6967V15.1315H16.6956V16.6967H15.1304V18.2619H16.6956V19.8271H18.2608V18.2619H19.8261V16.6967H18.2608Z" fill="#D80027" />
  </svg>
));
export const GG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
      fill="#D80027"
    />
    <path
      d="M15.3917 12.5219L16.1742 13.0436V10.9567L15.3917 11.4784H12.5221V8.60884L13.0438 7.82626H10.9569L11.4786 8.60884V11.4784H8.60905L7.82647 10.9567V13.0436L8.60905 12.5219H11.4786V15.3915L10.9569 16.174H13.0438L12.5221 15.3915V12.5219H15.3917Z"
      fill="#FFDA44"
    />
  </svg>
));
export const GH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2135)">
      <path
        d="M0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 16.6948L23.2536 16.1731C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12522 23.2536 7.82523L12 7.30347L0.746391 7.82519C0.264047 9.12522 0 10.5313 0 11.9991Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9998 -0.000946045C6.84021 -0.000946045 2.4417 3.25555 0.746181 7.82516H23.2534C21.5579 3.25555 17.1594 -0.000946045 11.9998 -0.000946045Z"
        fill="#D80027"
      />
      <path
        d="M23.2536 16.1741H0.746351C2.44187 20.7436 6.84038 24.0002 12 24.0002C17.1595 24.0002 21.5581 20.7436 23.2536 16.1741Z"
        fill="#496E2D"
      />
      <path
        d="M11.9998 7.82626L13.0358 11.0147H16.3886L13.6763 12.9855L14.7122 16.174L11.9998 14.2034L9.28739 16.174L10.3235 12.9855L7.61119 11.0147H10.9639L11.9998 7.82626Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2135">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2141)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F9F9F9" />
      <path
        d="M11.9999 24.0007C17.1594 24.0007 21.558 20.7442 23.2534 16.1746H0.746204C2.44177 20.7442 6.84024 24.0007 11.9999 24.0007Z"
        fill="#D80027"
      />
      <path
        d="M16.6955 9.91358V8.34837H17.2173V7.30489H16.1738V7.82665H15.1303V7.30489H14.0869V8.34837H14.6086V9.91358H13.5651V6.2615H14.0869V5.21806H13.0434V5.73968H12.5216V5.21806H11.4782V5.73968H10.9564V5.21806H9.91292V6.2615H10.4347V9.91358H9.3912V8.34837H9.91292V7.30489H8.86943V7.82665H7.82599V7.30489H6.78251V8.34837H7.30423V9.91358H6.26074V14.0875H17.739V9.91358H16.6955Z"
        fill="#D80027"
      />
      <path
        d="M11.9998 13.5651C11.1354 13.5651 10.4346 14.2659 10.4346 15.1303C10.4346 15.8117 10.8703 16.3913 11.4781 16.6062V18.7826H9.91288V20.8695H12.5216V16.6062C13.1294 16.3913 13.5651 15.8118 13.5651 15.1304C13.565 14.266 12.8642 13.5651 11.9998 13.5651ZM11.9998 15.6521C11.7117 15.6521 11.4781 15.4185 11.4781 15.1304C11.4781 14.8422 11.7117 14.6087 11.9998 14.6087C12.2879 14.6087 12.5215 14.8422 12.5215 15.1304C12.5215 15.4185 12.2879 15.6521 11.9998 15.6521Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2141">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2157)">
      <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#F0F0F0" />
      <path
        d="M24.0003 12.0005C24.0003 18.6278 18.6277 24.0005 12.0003 24.0005C5.37297 24.0005 0.000341415 18.6278 0.000341415 12.0005"
        fill="#D80027"
      />
      <path
        d="M8.34752 17.7397C11.5172 17.7397 14.0867 15.1702 14.0867 12.0005C14.0867 8.83088 11.5172 6.26138 8.34752 6.26138C5.17788 6.26138 2.60838 8.83088 2.60838 12.0005C2.60838 15.1702 5.17788 17.7397 8.34752 17.7397Z"
        fill="#F0F0F0"
      />
      <path d="M2.60838 12.0005C2.60838 8.83098 5.17788 6.26138 8.34752 6.26138C11.5172 6.26138 14.0867 8.83093 14.0867 12.0005" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_5_2157">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2115)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0004 0.000762939C7.03939 0.000762939 2.78183 3.01136 0.954216 7.30511H23.0466C21.219 3.01136 16.9614 0.000762939 12.0004 0.000762939Z"
        fill="#A2001D"
      />
      <path
        d="M12.0004 24.0007C16.9614 24.0007 21.219 20.9901 23.0466 16.6964H0.954216C2.78183 20.9901 7.03939 24.0007 12.0004 24.0007Z"
        fill="#496E2D"
      />
      <path
        d="M23.5864 8.8696H0.413208C0.144192 9.86771 -0.000183105 10.9169 -0.000183105 12.0001C-0.000183105 13.0832 0.144192 14.1324 0.413208 15.1305H23.5865C23.8554 14.1324 23.9998 13.0832 23.9998 12.0001C23.9998 10.9169 23.8554 9.86771 23.5864 8.8696Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2115">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2220)">
      <path
        d="M16.1744 0.746346C14.8743 0.263955 13.4682 -9.15527e-05 12.0003 -9.15527e-05C10.5325 -9.15527e-05 9.12648 0.263955 7.82654 0.746252L7.30478 11.9999L7.82649 23.2536C9.12648 23.7359 10.5325 23.9999 12.0003 23.9999C13.4683 23.9999 14.8743 23.7359 16.1744 23.2535L16.6961 11.9999L16.1744 0.746346Z"
        fill="#FFDA44"
      />
      <path
        d="M4.3869e-05 12.0003C4.3869e-05 17.1598 3.25654 21.5584 7.82615 23.2539V0.746643C3.25654 2.44221 4.3869e-05 6.84067 4.3869e-05 12.0003Z"
        fill="#D80027"
      />
      <path
        d="M23.9996 12.0003C23.9996 6.84067 20.7431 2.44221 16.1735 0.746643V23.2539C20.7431 21.5584 23.9996 17.1598 23.9996 12.0003Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2220">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GQ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2025)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M7.30462 7.8258H23.2538C21.5584 3.25619 17.1598 -0.000305176 12.0003 -0.000305176C8.6865 -0.000305176 5.68683 1.34309 3.51539 3.5148L7.30462 7.8258Z"
        fill="#6DA544"
      />
      <path
        d="M7.30462 16.1742H23.2538C21.5584 20.7438 17.1598 24.0003 12.0003 24.0003C8.6865 24.0003 5.68683 22.6569 3.51539 20.4852L7.30462 16.1742Z"
        fill="#D80027"
      />
      <path
        d="M3.51516 3.5155C-1.17112 8.20178 -1.17112 15.7998 3.51516 20.4861C5.45171 18.5496 7.3142 16.6871 12.0005 12.0008L3.51516 3.5155Z"
        fill="#0052B4"
      />
      <path
        d="M14.087 9.91272V12.5214C14.087 14.1189 16.174 14.6084 16.174 14.6084C16.174 14.6084 18.261 14.1189 18.261 12.5214V9.91272H14.087Z"
        fill="#DEDDE0"
      />
      <path d="M16.6954 12.0523H15.6519V13.5653H16.6954V12.0523Z" fill="#786145" />
      <path
        d="M17.2175 11.4789C17.2175 10.9025 16.7504 10.4354 16.174 10.4354C15.5977 10.4354 15.1306 10.9025 15.1306 11.4789C14.8424 11.4789 14.6088 11.7124 14.6088 12.0006C14.6088 12.2887 14.8424 12.5223 15.1306 12.5223C15.3017 12.5223 17.0464 12.5223 17.2175 12.5223C17.5057 12.5223 17.7392 12.2887 17.7392 12.0006C17.7392 11.7124 17.5057 11.4789 17.2175 11.4789Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2025">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2148)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M11.9997 8.87001H23.5863C23.2854 7.75373 22.8281 6.70181 22.2384 5.73956H11.9997V8.87001Z" fill="#338AF3" />
      <path
        d="M4.53062 21.3914H19.4703C20.5654 20.5192 21.5046 19.4597 22.2392 18.261H1.76176C2.49634 19.4596 3.43553 20.5192 4.53062 21.3914Z"
        fill="#338AF3"
      />
      <path d="M4.17437 2.90378C3.23096 3.71617 2.41539 4.67284 1.76176 5.73953H4.17437V2.90378Z" fill="#338AF3" />
      <path
        d="M12.0001 12C12.0001 10.7777 12.0001 9.75471 12.0001 8.86952H7.30449V12H4.17404V8.86952H0.413537C0.144522 9.86768 0.000146866 10.9168 0.000146866 12C0.000146866 13.0831 0.144522 14.1323 0.413537 15.1304H23.5868C23.8558 14.1323 24.0001 13.0831 24.0001 12H12.0001Z"
        fill="#338AF3"
      />
      <path
        d="M12.0005 0.000689983C10.3342 0.000689983 8.74722 0.340674 7.30488 0.954502V5.73983H12.0005C12.0005 4.64708 12.0005 3.71769 12.0005 2.60938H19.4704C17.4205 0.976815 14.8247 0.000689983 12.0005 0.000689983Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2148">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2199)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.9991 12.0003C23.9991 7.24276 21.2305 3.13201 17.2165 1.19101V22.8095C21.2305 20.8686 23.9991 16.7578 23.9991 12.0003Z"
        fill="#338AF3"
      />
      <path
        d="M-0.000392914 12.0001C-0.000392914 16.7576 2.76828 20.8684 6.78223 22.8094V1.19084C2.76828 3.13184 -0.000392914 7.24259 -0.000392914 12.0001Z"
        fill="#338AF3"
      />
      <path
        d="M15.1355 14.0284L13.1065 11.9994L15.0378 10.0679L14.9503 9.04781L14.3974 8.49478L11.9996 10.8925L9.6019 8.49478L9.04896 9.04781L8.96144 10.0679L10.8928 11.9994L8.86375 14.0284L9.97057 15.1351L11.9996 13.1062L14.0287 15.1351L15.1355 14.0284Z"
        fill="#ACABB1"
      />
      <path
        d="M14.9515 9.049L13.8448 10.1558C14.3168 10.6278 14.6089 11.28 14.6089 12.0004C14.6089 13.4411 13.4409 14.6091 12.0002 14.6091C10.5595 14.6091 9.39146 13.4411 9.39146 12.0004C9.39146 11.28 9.68349 10.6278 10.1556 10.1558L9.0488 9.049C8.29341 9.80425 7.82626 10.8477 7.82626 12.0004C7.82626 14.3056 9.69497 16.1743 12.0001 16.1743C14.3053 16.1743 16.174 14.3056 16.174 12.0004C16.174 10.8478 15.7069 9.80429 14.9515 9.049Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2199">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2187)">
      <path
        d="M5.23631 21.9123C7.16213 23.2288 9.49088 23.9993 11.9998 23.9993C14.5087 23.9993 16.8374 23.2288 18.7632 21.9123L11.9998 20.8688L5.23631 21.9123Z"
        fill="#D80027"
      />
      <path
        d="M18.7641 2.08688C16.8382 0.770392 14.5095 -9.15527e-05 12.0006 -9.15527e-05C9.49175 -9.15527e-05 7.163 0.770392 5.23719 2.08688L12.0006 3.13036L18.7641 2.08688Z"
        fill="#D80027"
      />
      <path
        d="M23.9996 12.0004C23.9996 8.02965 21.6223 4.042 18.763 2.0874H5.23614C2.07475 4.24853 -0.00041008 7.882 -0.00041008 12.0004C-0.00041008 16.119 2.07475 19.7523 5.23614 21.9135H18.763C21.9245 19.7523 23.9996 16.119 23.9996 12.0004Z"
        fill="#0052B4"
      />
      <path
        d="M11.3208 19.5749C11.1568 19.4342 7.30422 16.0851 7.30422 12C7.30422 7.91491 11.1568 4.56574 11.3208 4.42516L11.9999 3.84306L12.679 4.42511C12.8429 4.56574 16.6955 7.91486 16.6955 12C16.6955 16.0852 12.843 19.4343 12.679 19.5749L11.9999 20.157L11.3208 19.5749Z"
        fill="#D80027"
      />
      <path
        d="M15.6524 12C15.6524 8.3478 12.0002 5.21735 12.0002 5.21735C12.0002 5.21735 8.34806 8.34789 8.34806 12C8.34806 13.1172 8.69011 14.1855 9.16458 15.1304H14.8359C15.3104 14.1855 15.6524 13.1172 15.6524 12Z"
        fill="#338AF3"
      />
      <path
        d="M15.6524 12.0005C15.6524 13.1177 15.3104 14.186 14.8359 15.1309L12.0002 15.6526L9.16458 15.1309C8.69011 14.186 8.34806 13.1177 8.34806 12.0005H15.6524Z"
        fill="#0052B4"
      />
      <path
        d="M12.0001 18.7824C12.0001 18.7824 13.7592 17.2741 14.8357 15.1302H9.16444C10.241 17.2741 12.0001 18.7824 12.0001 18.7824Z"
        fill="#FFDA44"
      />
      <path d="M9.65165 9.91258H14.3473L11.9995 12.2604L9.65165 9.91258Z" fill="#6DA544" />
      <path d="M12.7827 11.4773H11.2175V16.1729H12.7827V11.4773Z" fill="#A2001D" />
    </g>
    <defs>
      <clipPath id="clip0_5_2187">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2212)">
      <path
        d="M11.9996 -9.15527e-05C10.9165 -9.15527e-05 9.86725 0.144283 8.86914 0.413299L7.8257 11.9999L8.86919 23.5865C9.86725 23.8555 10.9165 23.9999 11.9996 23.9999C18.627 23.9999 23.9996 18.6273 23.9996 11.9999C23.9996 5.37253 18.627 -9.15527e-05 11.9996 -9.15527e-05Z"
        fill="#FFDA44"
      />
      <path
        d="M7.8257 12.0005L8.86919 23.5871C9.86725 23.8561 10.9165 24.0005 11.9996 24.0005C18.627 24.0005 23.9996 18.6278 23.9996 12.0005H7.8257Z"
        fill="#6DA544"
      />
      <path
        d="M0.000104904 11.9995C0.000104904 16.5481 2.53089 20.5052 6.26096 22.5405V1.45862C2.53089 3.49384 0.000104904 7.45102 0.000104904 11.9995Z"
        fill="#D80027"
      />
      <path
        d="M0.000173569 11.9995C0.000173569 17.5438 3.76053 22.2091 8.86972 23.5861V0.412903C3.76053 1.7899 0.000173569 6.45518 0.000173569 11.9995Z"
        fill="#D80027"
      />
      <path
        d="M4.53455 8.86835L5.31151 11.2597H7.82616L5.79188 12.7378L6.56879 15.1293L4.53455 13.6512L2.50023 15.1293L3.27732 12.7378L1.24304 11.2597H3.75755L4.53455 8.86835Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2212">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const GY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2225)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12 -0.000946045C9.8784 -0.000946045 7.88583 0.550398 6.15652 1.51649V22.4816C7.88588 23.4477 9.8784 23.9991 12 23.9991C18.6274 23.9991 24 18.6264 24 11.9991C24 5.37168 18.6274 -0.000946045 12 -0.000946045Z"
        fill="#6DA544"
      />
      <path
        d="M6.19195 1.4982C5.43703 1.91656 4.73212 2.41381 4.08811 2.97912C4.15322 2.92203 4.21898 2.86559 4.28527 2.8099L13.4758 12.0005L4.28522 21.1911C4.21889 21.1354 4.15317 21.079 4.08806 21.0219C4.73208 21.5872 5.43703 22.0844 6.19191 22.5028L24.0001 12.0005L6.19195 1.4982Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.1782 2.12692C4.81225 2.38033 4.46078 2.653 4.12586 2.94442L11.9999 11.9996L4.12581 21.0549C4.46073 21.3463 4.8122 21.619 5.17815 21.8724L21.9458 11.9996L5.1782 2.12692Z"
        fill="#FFDA44"
      />
      <path
        d="M4.28494 2.80988C4.01817 3.03403 3.76073 3.26902 3.51455 3.51516L10.9564 12.0005L3.51455 20.4858C3.76073 20.732 4.01812 20.967 4.28494 21.1911L13.4755 12.0005L4.28494 2.80988Z"
        fill="black"
      />
      <path
        d="M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31375 16.6859 12 11.9996L3.51471 3.51428Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2225">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const HK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M13.2391 9.07758C12.9664 10.2119 12.4819 9.99558 12.2441 10.9848C10.8433 10.648 9.98061 9.23944 10.3174 7.83858C10.6541 6.43781 12.0628 5.57512 13.4636 5.91192C12.988 7.89037 13.4831 8.06306 13.2391 9.07758Z"
      fill="#F0F0F0"
    />
    <path
      d="M9.60422 9.91761C10.5988 10.5275 10.2433 10.9215 11.1105 11.4534C10.3574 12.6816 8.75119 13.0667 7.52297 12.3135C6.2948 11.5604 5.90963 9.95412 6.66281 8.72595C8.39747 9.78964 8.71458 9.37212 9.60422 9.91761Z"
      fill="#F0F0F0"
    />
    <path
      d="M9.28002 13.635C10.1674 12.8776 10.4322 13.3374 11.2061 12.6769C12.1415 13.7727 12.0113 15.4194 10.9156 16.3548C9.81973 17.2901 8.17311 17.1599 7.23786 16.0642C8.78539 14.7431 8.48628 14.3124 9.28002 13.635Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.7152 15.0916C12.2689 14.0136 12.7881 13.9037 12.3991 12.9637C13.7303 12.4128 15.2562 13.0453 15.8072 14.3765C16.3581 15.7077 15.7255 17.2336 14.3943 17.7845C13.6163 15.9044 13.1143 16.0558 12.7152 15.0916Z"
      fill="#F0F0F0"
    />
    <path
      d="M15.1621 12.274C13.999 12.3653 14.0548 11.8375 13.0406 11.917C12.928 10.4808 14.0012 9.22501 15.4375 9.11228C16.8737 8.99982 18.1295 10.0729 18.2421 11.5092C16.2135 11.6683 16.2023 12.1925 15.1621 12.274Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const HN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2243)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0002 23.9987C16.7577 23.9987 20.8685 21.23 22.8095 17.2161H1.19089C3.13189 21.23 7.24264 23.9987 12.0002 23.9987Z"
        fill="#338AF3"
      />
      <path
        d="M12.0009 -0.000976562C7.24333 -0.000976562 3.13258 2.7677 1.19158 6.78165H22.8101C20.8691 2.7677 16.7583 -0.000976562 12.0009 -0.000976562Z"
        fill="#338AF3"
      />
      <path
        d="M7.3855 7.8244L7.774 9.02014H9.03124L8.01414 9.75907L8.40269 10.9548L7.3855 10.2158L6.36832 10.9548L6.75686 9.75907L5.73972 9.02014H6.99696L7.3855 7.8244Z"
        fill="#338AF3"
      />
      <path
        d="M7.3855 13.0425L7.774 14.2383H9.03124L8.01414 14.9772L8.40269 16.1729L7.3855 15.4339L6.36832 16.1729L6.75686 14.9772L5.73972 14.2383H6.99696L7.3855 13.0425Z"
        fill="#338AF3"
      />
      <path
        d="M16.6151 7.8244L17.0037 9.02014H18.2609L17.2438 9.75907L17.6323 10.9548L16.6151 10.2158L15.5979 10.9548L15.9865 9.75907L14.9693 9.02014H16.2266L16.6151 7.8244Z"
        fill="#338AF3"
      />
      <path
        d="M16.6151 13.0425L17.0037 14.2383H18.2609L17.2438 14.9772L17.6323 16.1729L16.6151 15.4339L15.5979 16.1729L15.9865 14.9772L14.9693 14.2383H16.2266L16.6151 13.0425Z"
        fill="#338AF3"
      />
      <path
        d="M12 10.4333L12.3885 11.6291H13.6457L12.6286 12.3681L13.0172 13.5638L12 12.8248L10.9828 13.5638L11.3713 12.3681L10.3542 11.6291H11.6114L12 10.4333Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2243">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const HR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M24 11.9999C24 10.5321 23.736 9.12599 23.2536 7.82606L12 7.30429L0.746391 7.82601C0.264047 9.12599 0 10.5321 0 11.9999C0 13.4678 0.264047 14.8739 0.746391 16.1738L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 11.9999Z"
      fill="#F0F0F0"
    />
    <path d="M12 23.9994C17.1595 23.9994 21.5581 20.7429 23.2536 16.1733H0.746353C2.44187 20.7429 6.84038 23.9994 12 23.9994Z" fill="#0052B4" />
    <path
      d="M0.746185 7.82669H23.2534C21.5579 3.25708 17.1594 0.000579834 11.9998 0.000579834C6.84022 0.000579834 2.4417 3.25708 0.746185 7.82669Z"
      fill="#D80027"
    />
    <path d="M15.1301 8.34753H13.0431L13.391 5.7388L14.7823 4.69531L16.1735 5.7388V7.82576L15.1301 8.34753Z" fill="#338AF3" />
    <path d="M8.86921 8.34805H10.9562L10.6083 5.73932L9.21702 4.69583L7.82578 5.73932V7.82628L8.86921 8.34805Z" fill="#338AF3" />
    <path d="M13.3909 8.34781H10.6082V5.73907L11.9995 4.69559L13.3909 5.73907V8.34781Z" fill="#0052B4" />
    <path
      d="M7.82578 7.82574V13.5648C7.82578 14.9314 8.48587 16.1467 9.504 16.9085L10.2344 16.7258L11.1562 17.653C11.4288 17.7092 11.7108 17.7388 11.9997 17.7388C12.2871 17.7388 12.5677 17.7096 12.8388 17.654L13.891 16.7779L14.4953 16.9068C15.513 16.145 16.1736 14.931 16.1736 13.5648V7.82574H7.82578Z"
      fill="#F0F0F0"
    />
    <path d="M9.49557 7.8259H7.82602V9.49545H9.49557V7.8259Z" fill="#D80027" />
    <path d="M12.8347 7.8259H11.1652V9.49545H12.8347V7.8259Z" fill="#D80027" />
    <path d="M16.1741 7.8259H14.5046V9.49545H16.1741V7.8259Z" fill="#D80027" />
    <path d="M11.1648 9.49493H9.49526V11.1645H11.1648V9.49493Z" fill="#D80027" />
    <path d="M14.504 9.49493H12.8344V11.1645H14.504V9.49493Z" fill="#D80027" />
    <path d="M9.49557 11.1638H7.82602V12.8333H9.49557V11.1638Z" fill="#D80027" />
    <path d="M11.1648 12.8346H9.49526V14.5041H11.1648V12.8346Z" fill="#D80027" />
    <path d="M12.8347 11.1638H11.1652V12.8333H12.8347V11.1638Z" fill="#D80027" />
    <path d="M16.1741 11.1638H14.5046V12.8333H16.1741V11.1638Z" fill="#D80027" />
    <path d="M14.504 12.8346H12.8344V14.5041H14.504V12.8346Z" fill="#D80027" />
    <path d="M12.8347 14.5038H11.1652V16.1734H12.8347V14.5038Z" fill="#D80027" />
    <path d="M9.49543 14.5038H7.9336C8.07685 15.1245 8.35848 15.6924 8.74463 16.1734H9.49543V14.5038Z" fill="#D80027" />
    <path d="M14.5046 16.1736H15.2553C15.6416 15.6926 15.9231 15.1246 16.0663 14.5041H14.5046V16.1736Z" fill="#D80027" />
    <path d="M9.49526 16.1731V16.9016C9.98084 17.267 10.5483 17.529 11.1648 17.6547V16.1731H9.49526Z" fill="#D80027" />
    <path d="M12.8344 16.1731V17.6547C13.451 17.5291 14.0184 17.267 14.504 16.9016V16.1731H12.8344Z" fill="#D80027" />
  </svg>
));
export const HT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 5.37262 12 0 12 0C12 0 24 5.37262 24 12Z" fill="#A2001D" />
    <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#0052B4" />
    <path d="M16.1736 15.1305L11.9997 14.6088L7.82579 15.1305V8.86963H16.1736V15.1305Z" fill="#F0F0F0" />
    <path
      d="M11.9998 14.6083C13.1524 14.6083 14.0867 13.6739 14.0867 12.5213C14.0867 11.3687 13.1524 10.4343 11.9998 10.4343C10.8472 10.4343 9.91279 11.3687 9.91279 12.5213C9.91279 13.6739 10.8472 14.6083 11.9998 14.6083Z"
      fill="#0052B4"
    />
    <path
      d="M12.0003 13.5651C12.5766 13.5651 13.0438 13.0979 13.0438 12.5216C13.0438 11.9453 12.5766 11.4781 12.0003 11.4781C11.424 11.4781 10.9568 11.9453 10.9568 12.5216C10.9568 13.0979 11.424 13.5651 12.0003 13.5651Z"
      fill="#A2001D"
    />
    <path d="M10.4348 9.91327H13.5652L12 11.4785L10.4348 9.91327Z" fill="#6DA544" />
    <path d="M12.5221 10.9556H11.4786V14.086H12.5221V10.9556Z" fill="#FFDA44" />
    <path d="M13.6692 13.7745H10.33L7.82579 15.1311H16.1736L13.6692 13.7745Z" fill="#6DA544" />
  </svg>
));
export const HU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2263)">
      <path
        d="M0.745981 7.82522C0.263637 9.12525 -0.00041008 10.5313 -0.00041008 11.9991C-0.00041008 13.467 0.263637 14.8731 0.745981 16.173L11.9996 17.2165L23.2532 16.173C23.7355 14.8731 23.9996 13.467 23.9996 11.9991C23.9996 10.5313 23.7355 9.12525 23.2532 7.82522L11.9996 6.78174L0.745981 7.82522Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0004 -0.000976562C6.84085 -0.000976562 2.44229 3.25552 0.746822 7.82513H23.2541C21.5585 3.25552 17.16 -0.000976562 12.0004 -0.000976562Z"
        fill="#D80027"
      />
      <path
        d="M12.0004 23.9993C17.16 23.9993 21.5585 20.7428 23.254 16.1732H0.746822C2.44229 20.7428 6.84085 23.9993 12.0004 23.9993Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2263">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ID: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#A2001D" />
  </svg>
));
export const IE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2304)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.9996 11.9991C23.9996 6.83958 20.7431 2.44101 16.1735 0.745544V23.2528C20.7431 21.5572 23.9996 17.1587 23.9996 11.9991Z"
        fill="#FF9811"
      />
      <path
        d="M-3.24249e-05 11.9997C-3.24249e-05 17.1593 3.25647 21.5578 7.82608 23.2533V0.746094C3.25647 2.44156 -3.24249e-05 6.84013 -3.24249e-05 11.9997Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2304">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const IL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M16.518 9.39204H13.5056L11.9995 6.78336L10.4935 9.39204H7.48111L8.9874 12.0007L7.48111 14.6094H10.4935L11.9995 17.2181L13.5056 14.6094H16.518L15.0117 12.0007L16.518 9.39204ZM13.8499 12.0007L12.9248 13.6033H11.0744L10.1491 12.0007L11.0744 10.3982H12.9248L13.8499 12.0007ZM11.9995 8.79556L12.3439 9.39199H11.6553L11.9995 8.79556ZM9.22388 10.3982H9.91257L9.56823 10.9946L9.22388 10.3982ZM9.22388 13.6033L9.56827 13.0069L9.91262 13.6033H9.22388ZM11.9995 15.2059L11.6552 14.6094H12.3439L11.9995 15.2059ZM14.7752 13.6033H14.0865L14.4309 13.0069L14.7752 13.6033ZM14.0865 10.3982H14.7752L14.4309 10.9946L14.0865 10.3982Z"
      fill="#0052B4"
    />
    <path
      d="M19.4696 2.60904H4.52988C3.43474 3.48129 2.49555 4.54076 1.76102 5.73949H22.2385C21.5039 4.5408 20.5647 3.48129 19.4696 2.60904Z"
      fill="#0052B4"
    />
    <path
      d="M4.52993 21.3914H19.4696C20.5647 20.5191 21.5039 19.4596 22.2385 18.2609H1.76107C2.49564 19.4596 3.43483 20.5191 4.52993 21.3914Z"
      fill="#0052B4"
    />
  </svg>
));
export const IM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M16.4435 8.04392L15.5953 11.0707L13.0505 10.6008L11.4124 7.22412L6.98703 8.79448L6.63805 7.81104L5.48024 7.6684L6.35263 10.1269L9.39805 9.34812L10.2635 11.787L8.15825 14.8939L11.7309 17.9411L11.0538 18.735L11.5091 19.8091L13.2021 17.8242L11.0049 15.5763L12.6843 13.6074L16.4277 13.8771L17.2803 9.25943L18.3064 9.44895L19.009 8.51754L16.4435 8.04392Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const IN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2277)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12 -0.000976562C7.24249 -0.000976562 3.13174 2.7677 1.19074 6.78165H22.8093C20.8683 2.7677 16.7575 -0.000976562 12 -0.000976562Z"
        fill="#FF9811"
      />
      <path d="M12 23.9997C16.7575 23.9997 20.8683 21.231 22.8093 17.217H1.19074C3.13174 21.231 7.24249 23.9997 12 23.9997Z" fill="#6DA544" />
      <path
        d="M12.0004 16.1732C14.3055 16.1732 16.1742 14.3044 16.1742 11.9993C16.1742 9.69409 14.3055 7.82538 12.0004 7.82538C9.69518 7.82538 7.82647 9.69409 7.82647 11.9993C7.82647 14.3044 9.69518 16.1732 12.0004 16.1732Z"
        fill="#0052B4"
      />
      <path
        d="M12.0001 14.6081C13.4409 14.6081 14.6088 13.4401 14.6088 11.9994C14.6088 10.5586 13.4409 9.39069 12.0001 9.39069C10.5594 9.39069 9.39145 10.5586 9.39145 11.9994C9.39145 13.4401 10.5594 14.6081 12.0001 14.6081Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0004 8.78088L12.8052 10.6061L14.7882 10.3904L13.6099 12L14.7882 13.6095L12.8052 13.3939L12.0004 15.2191L11.1956 13.3939L9.21256 13.6095L10.3908 12L9.21256 10.3904L11.1956 10.6061L12.0004 8.78088Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2277">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const IO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1646)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M21.9999 13.4358C20.9999 13.4358 20.9999 12.5214 19.9999 12.5214C18.9999 12.5214 18.9999 13.4358 18 13.4358C17 13.4358 17 12.5214 16 12.5214C15 12.5214 15 13.4358 14 13.4358C13 13.4358 12.9999 12.5214 11.9999 12.5214C10.9999 12.5214 10.9999 13.4358 9.99994 13.4358C9.00009 13.4358 9.00009 12.5214 8.00011 12.5214C7.00003 12.5214 7.00003 13.4358 5.99995 13.4358C4.99987 13.4358 4.99987 12.5214 3.9998 12.5214C2.99995 12.5214 2.99995 13.4358 1.99997 13.4358C1.00537 13.4358 0.999609 12.5315 0.0156555 12.5218C0.0433586 13.0707 0.10889 13.6096 0.207984 14.1366C1.00505 14.2537 1.07484 15.0357 2.00006 15.0357C3.00005 15.0357 3.00005 14.1215 3.99989 14.1215C4.99997 14.1215 4.99997 15.0357 6.00005 15.0357C7.00012 15.0357 7.00012 14.1215 8.0002 14.1215C9.00019 14.1215 9.00019 15.0357 10 15.0357C11 15.0357 11 14.1215 12 14.1215C13 14.1215 13 15.0357 14.0001 15.0357C15.0002 15.0357 15.0002 14.1215 16.0001 14.1215C17.0001 14.1215 17.0001 15.0357 18 15.0357C19 15.0357 19 14.1215 20 14.1215C21 14.1215 21 15.0357 22 15.0357C22.9253 15.0357 22.995 14.2537 23.7922 14.1366C23.8913 13.6096 23.9567 13.0708 23.9846 12.5218C23.0004 12.5316 22.9945 13.4358 21.9999 13.4358Z"
        fill="#0052B4"
      />
      <path
        d="M20 15.6514C19 15.6514 19 16.5657 18 16.5657C17.0001 16.5657 17 15.6514 16.0001 15.6514C15.0001 15.6514 15.0001 16.5657 14.0001 16.5657C13 16.5657 13 15.6514 11.9999 15.6514C11 15.6514 11 16.5657 10 16.5657C9.00017 16.5657 9.00017 15.6514 8.00019 15.6514C7.00011 15.6514 7.00011 16.5657 6.00003 16.5657C4.99995 16.5657 4.99995 15.6514 3.99987 15.6514C3.00003 15.6514 3.00003 16.5657 2.00005 16.5657C1.26341 16.5657 1.06892 16.0699 0.617844 15.8087C0.891031 16.6252 1.24986 17.4024 1.68322 18.1301C1.77706 18.1527 1.88141 18.1657 2 18.1657C2.99998 18.1657 2.99998 17.2515 3.99983 17.2515C4.99991 17.2515 4.99991 18.1657 5.99998 18.1657C7.00006 18.1657 7.00006 17.2515 8.00014 17.2515C9.00012 17.2515 9.00012 18.1657 9.99997 18.1657C11 18.1657 11 17.2515 11.9999 17.2515C13 17.2515 13 18.1657 14 18.1657C15.0001 18.1657 15.0001 17.2515 16.0001 17.2515C17 17.2515 17 18.1657 18 18.1657C18.9999 18.1657 19 17.2515 19.9999 17.2515C21 17.2515 21 18.1657 21.9999 18.1657C22.1186 18.1657 22.223 18.1527 22.3169 18.13C22.7503 17.4024 23.1091 16.6252 23.3823 15.8087C22.9312 16.0699 22.7367 16.5658 21.9999 16.5658C21 16.5657 21 15.6514 20 15.6514Z"
        fill="#0052B4"
      />
      <path
        d="M23.721 9.41947C22.99 9.5712 22.8968 10.306 22 10.306C21 10.306 21 9.39167 20 9.39167C19 9.39167 19 10.306 18.0001 10.306C17.0001 10.306 17.0001 9.39167 16.0002 9.39167C15.0002 9.39167 15.0002 10.306 14.0001 10.306C13.0001 10.306 13.0001 9.39167 12 9.39167C11.4597 9.39167 11.2112 9.65858 10.9393 9.90401V11.504C11.2112 11.2586 11.4596 10.9917 12 10.9917C13.0001 10.9917 13.0001 11.906 14.0001 11.906C15.0002 11.906 15.0002 10.9917 16.0002 10.9917C17.0001 10.9917 17.0001 11.906 18.0001 11.906C19 11.906 19.0001 10.9917 20 10.9917C21.0001 10.9917 21.0001 11.906 22 11.906C22.9253 11.906 22.9951 11.124 23.7922 11.0069C23.8433 11.0069 23.9004 11.0064 23.9588 11.0057C23.9145 10.466 23.8344 9.93654 23.721 9.41947Z"
        fill="#0052B4"
      />
      <path
        d="M22.8444 6.85724C22.6372 7.03129 22.3976 7.17585 22 7.17585C21 7.17585 21 6.26151 20 6.26151C19 6.26151 19 7.17585 18.0001 7.17585C17.0001 7.17585 17.0001 6.26151 16.0002 6.26151C15.0002 6.26151 15.0002 7.17585 14.0001 7.17585C13.0001 7.17585 13.0001 6.26151 12 6.26151C11.4597 6.26151 11.2112 6.52842 10.9393 6.77385V8.37384C11.2112 8.12845 11.4596 7.86159 12 7.86159C13.0001 7.86159 13.0001 8.77584 14.0001 8.77584C15.0001 8.77584 15.0001 7.86159 16.0001 7.86159C17.0001 7.86159 17.0001 8.77584 18 8.77584C19 8.77584 19 7.86159 20 7.86159C21 7.86159 21 8.77584 22 8.77584C22.7095 8.77584 22.9162 8.31623 23.3334 8.04895C23.1912 7.64128 23.0279 7.24354 22.8444 6.85724Z"
        fill="#0052B4"
      />
      <path
        d="M20.0854 3.13263C20.0576 3.13113 20.0293 3.13019 20 3.13019C19 3.13019 19 4.04454 18 4.04454C17 4.04454 17 3.13019 16.0001 3.13019C15.0001 3.13019 15.0001 4.04454 14 4.04454C13 4.04454 13 3.13019 11.9999 3.13019C11.4596 3.13019 11.2111 3.3971 10.9392 3.64254V5.24252C11.2111 4.99713 11.4595 4.73027 11.9999 4.73027C13 4.73027 13 5.64452 14 5.64452C15.0001 5.64452 15.0001 4.73027 16.0001 4.73027C17 4.73027 17 5.64452 18 5.64452C18.9999 5.64452 19 4.73027 19.9999 4.73027C21 4.73027 21 5.64452 21.9999 5.64452C22.0615 5.64452 22.119 5.64087 22.1735 5.63435C21.5927 4.70791 20.8894 3.86618 20.0854 3.13263Z"
        fill="#0052B4"
      />
      <path
        d="M15.0671 0.396227C14.7926 0.643165 14.5446 0.914383 13.9999 0.914383C12.9999 0.914383 12.9999 0.000133327 11.9998 3.95775e-05H11.9996C11.4825 8.64525e-05 11.2329 0.244633 10.9739 0.480836V2.08087C11.2328 1.84466 11.4826 1.60007 11.9998 1.60007C12.9999 1.60007 12.9999 2.51432 14 2.51432C15 2.51432 15 1.60007 16 1.60007C17 1.60007 17 2.51432 17.9999 2.51432C18.4195 2.51432 18.6629 2.35326 18.8781 2.16641C17.7374 1.36696 16.4512 0.761055 15.0671 0.396227Z"
        fill="#0052B4"
      />
      <path
        d="M14.0004 22.8273C13.0003 22.8273 13.0003 21.9129 12.0003 21.9129C11.0003 21.9129 11.0003 22.8273 10.0003 22.8273C9.00049 22.8273 9.00049 21.9129 8.00051 21.9129C7.23452 21.9129 7.05485 22.4489 6.5636 22.7C7.91829 23.3898 9.42143 23.8294 11.0124 23.9591C11.2584 23.7343 11.5084 23.5129 12.0003 23.5129C12.4923 23.5129 12.7422 23.7343 12.9883 23.9591C14.5793 23.8295 16.0826 23.3898 17.4373 22.7001C16.9459 22.449 16.7663 21.9129 16.0004 21.9129C15.0005 21.9129 15.0005 22.8273 14.0004 22.8273Z"
        fill="#0052B4"
      />
      <path
        d="M18.0002 19.6976C17.0002 19.6976 17.0002 18.7833 16.0003 18.7833C15.0003 18.7833 15.0003 19.6976 14.0003 19.6976C13.0002 19.6976 13.0002 18.7833 12.0001 18.7833C11.0001 18.7833 11.0001 19.6976 10.0002 19.6976C9.00035 19.6976 9.00035 18.7833 8.00036 18.7833C7.00028 18.7833 7.00028 19.6976 6.00021 19.6976C5.00013 19.6976 5.00013 18.7833 4.00005 18.7833C3.28094 18.7833 3.079 19.2563 2.65033 19.5218C2.91902 19.8555 3.20467 20.1749 3.50697 20.4777C3.64239 20.4198 3.8013 20.3833 4 20.3833C5.00008 20.3833 5.00008 21.2976 6.00016 21.2976C7.00024 21.2976 7.00024 20.3833 8.00031 20.3833C9.0003 20.3833 9.0003 21.2976 10.0001 21.2976C11.0001 21.2976 11.0001 20.3833 12.0001 20.3833C13.0001 20.3833 13.0001 21.2976 14.0002 21.2976C15.0003 21.2976 15.0003 20.3833 16.0002 20.3833C17.0002 20.3833 17.0002 21.2976 18.0002 21.2976C19.0001 21.2976 19.0001 20.3833 20.0001 20.3833C20.199 20.3833 20.3579 20.4198 20.4934 20.4778C20.7958 20.1749 21.0814 19.8555 21.3501 19.5219C20.9214 19.2564 20.7195 18.7833 20.0001 18.7833C19.0001 18.7833 19.0001 19.6976 18.0002 19.6976Z"
        fill="#0052B4"
      />
      <path
        d="M11.9675 11.9991H11.9997C11.9997 11.9883 11.9997 11.9778 11.9997 11.9669C11.9889 11.9777 11.9782 11.9884 11.9675 11.9991Z"
        fill="#F0F0F0"
      />
      <path d="M11.9996 6.26152V9.78713L7.82573 5.7398L11.9996 6.26152Z" fill="#0052B4" />
      <path d="M6.2606 12.0005H9.78606L6.26055 7.30488L5.73883 10.957L6.2606 12.0005Z" fill="#0052B4" />
      <path
        d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.2609V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07127 1.56418C4.19444 2.63288 2.63416 4.19316 1.56546 6.06999V11.999H4.69591V4.69473V4.69463H12.0003C12.0003 3.7073 12.0003 2.76671 12.0003 1.56418H6.07127Z"
        fill="#D80027"
      />
      <path
        d="M11.9999 10.5234L7.73643 6.25999H6.2608V6.26009L11.9999 11.9991H11.9999C11.9999 11.9991 11.9999 10.9816 11.9999 10.5234Z"
        fill="#D80027"
      />
      <path d="M15.652 6.26096H20.3477L17.9999 8.6088L15.652 6.26096Z" fill="#6DA544" />
      <path d="M18.5222 8.08646H17.4787V10.956H18.5222V8.08646Z" fill="#A2001D" />
      <path d="M18.5212 15.6519H17.4777V18.5215H18.5212V15.6519Z" fill="#A2001D" />
      <path
        d="M21.1304 14.0873C21.1304 13.2229 20.4297 12.5221 19.5652 12.5221C19.1643 12.5221 18.7987 12.6731 18.5218 12.921V12.0004H19.0435V10.9569H18.5218V10.4352H17.4783V10.9569H16.9566V12.0004H17.4783V12.921C17.2013 12.6731 16.8358 12.5221 16.4348 12.5221C15.5704 12.5221 14.8696 13.2229 14.8696 14.0873C14.8696 14.5508 15.0712 14.967 15.3913 15.2537V16.1743H20.6087V15.2537C20.9288 14.967 21.1304 14.5508 21.1304 14.0873Z"
        fill="#FFDA44"
      />
      <path
        d="M19.5648 13.5649C19.4002 13.5649 19.285 13.6372 19.2172 13.6978L18.5213 14.3208H17.4778L16.7819 13.6978C16.7142 13.6372 16.5989 13.5649 16.4344 13.5649C16.1467 13.5649 15.9126 13.799 15.9126 14.0866C15.9126 14.2893 16.0219 14.4173 16.087 14.4757L16.4344 14.7867V15.1301H19.5649V14.7867L19.9122 14.4757C19.9774 14.4173 20.0866 14.2893 20.0866 14.0866C20.0865 13.799 19.8525 13.5649 19.5648 13.5649Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1646">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const IQ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2295)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.9998 -0.000671387C6.84021 -0.000671387 2.4417 3.25583 0.746181 7.82544H23.2534C21.5579 3.25583 17.1594 -0.000671387 11.9998 -0.000671387Z"
        fill="#A2001D"
      />
      <path d="M12 24.0006C17.1595 24.0006 21.5581 20.7441 23.2536 16.1745H0.746351C2.44187 20.7441 6.84038 24.0006 12 24.0006Z" fill="black" />
      <path
        d="M9.13046 11.2186C9.12389 11.2186 9.11747 11.219 9.11091 11.2191V11.2186H6.81699C6.93328 10.7692 7.341 10.4359 7.82611 10.4359V8.87073C6.38766 8.87073 5.21743 10.041 5.21743 11.4794V12.7577V12.7838H9.11091C9.11972 12.7838 9.12666 12.7838 9.13046 12.7838C9.27432 12.7838 9.39132 12.9009 9.39132 13.0447V13.5664H4.17389V15.1316H10.9565V13.0446C10.9565 12.0377 10.1373 11.2186 9.13046 11.2186Z"
        fill="#496E2D"
      />
      <path d="M13.0438 13.5657V8.87H11.4786V15.1309H14.0872V13.5657H13.0438Z" fill="#496E2D" />
      <path d="M18.2607 13.5657V8.87H16.6955V13.5657H16.1737V12.0005H14.6085V15.1309H19.3042V13.5657H18.2607Z" fill="#496E2D" />
    </g>
    <defs>
      <clipPath id="clip0_5_2295">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const IR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2289)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M15.8978 8.86968H14.3277C14.3407 9.04222 14.3481 9.21632 14.3481 9.39139C14.3481 10.5522 14.0579 11.6774 13.5521 12.4783C13.396 12.7253 13.1338 13.0741 12.7828 13.3094V8.86963H11.2176V13.3094C10.8667 13.0741 10.6044 12.7253 10.4483 12.4783C9.94247 11.6774 9.65237 10.5522 9.65237 9.39139C9.65237 9.21632 9.65977 9.04218 9.67271 8.86968H8.10268C8.0926 9.04138 8.08712 9.21529 8.08712 9.39139C8.08712 12.6096 9.80593 15.1305 12.0001 15.1305C14.1944 15.1305 15.9132 12.6096 15.9132 9.39139C15.9133 9.21529 15.9078 9.04138 15.8978 8.86968Z"
        fill="#D80027"
      />
      <path
        d="M4.95686 5.73816H6.52207V6.78165H8.08727V5.73816H9.65247V6.78165H11.2177V5.73816H12.7829V6.78165H14.3481V5.73816H15.9133V6.78165H17.4785V5.73816H19.0437V6.78165H22.8095C20.8686 2.7677 16.7578 -0.000976562 12.0003 -0.000976562C7.24286 -0.000976562 3.13207 2.7677 1.19107 6.78165H4.95686V5.73816Z"
        fill="#6DA544"
      />
      <path
        d="M19.0438 17.217V18.2605H17.4786V17.217H15.9134V18.2605H14.3482V17.217H12.783V18.2605H11.2178V17.217H9.65261V18.2605H8.08741V17.217H6.52207V18.2605H4.95686V17.217H1.19107C3.13207 21.231 7.24282 23.9997 12.0003 23.9997C16.7579 23.9997 20.8686 21.231 22.8096 17.217H19.0438Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2289">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const IS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2268)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M0.413286 15.1301C1.1076 17.7063 2.63783 19.9391 4.69555 21.5202V15.1301H0.413286Z" fill="#0052B4" />
      <path
        d="M10.9562 23.954C11.3002 23.9836 11.6481 23.9996 11.9997 23.9996C17.5441 23.9996 22.2093 20.2393 23.5863 15.1301H10.9562V23.954Z"
        fill="#0052B4"
      />
      <path
        d="M23.5863 8.86912C22.2093 3.75993 17.5441 -0.000427246 11.9997 -0.000427246C11.6481 -0.000427246 11.3002 0.015604 10.9562 0.045229V8.86912H23.5863Z"
        fill="#0052B4"
      />
      <path d="M4.69555 2.47937C2.63783 4.06046 1.1076 6.29326 0.413286 8.86946H4.69555V2.47937Z" fill="#0052B4" />
      <path
        d="M23.8981 10.4351H9.39106H9.39102V0.285583C8.28205 0.53149 7.23069 0.930068 6.26056 1.45943V10.4351H0.101282C0.0344856 10.9475 -0.000295639 11.4699 -0.000295639 12.0003C-0.000295639 12.5308 0.0344856 13.0532 0.101282 13.5656H6.26052H6.26056V22.5412C7.23069 23.0705 8.28205 23.4692 9.39102 23.7151V13.5657V13.5656H23.8981C23.9648 13.0532 23.9997 12.5308 23.9997 12.0003C23.9997 11.4699 23.9648 10.9475 23.8981 10.4351Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2268">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const IT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2320)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.9999 11.9991C23.9999 6.83955 20.7434 2.44103 16.1738 0.745514V23.2528C20.7434 21.5572 23.9999 17.1587 23.9999 11.9991Z"
        fill="#D80027"
      />
      <path
        d="M-0.000131607 11.9997C-0.000131607 17.1593 3.25637 21.5578 7.82598 23.2533V0.746078C3.25637 2.44159 -0.000131607 6.84011 -0.000131607 11.9997Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2320">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const JE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M21.5204 19.3072L14.2138 12.0006H14.2138L21.5204 4.69384C21.2053 4.28434 20.8606 3.89035 20.4855 3.51521C20.1104 3.14012 19.7165 2.79535 19.3069 2.4803L12.0003 9.78694L12.0002 9.78699L4.69358 2.4803C4.28413 2.7954 3.8901 3.14007 3.51496 3.51521C3.13982 3.89035 2.7951 4.28434 2.48005 4.69384L9.78669 12.0004L9.78674 12.0005L2.48 19.3072C2.79514 19.7167 3.13986 20.1107 3.51491 20.4858C3.89005 20.8609 4.28399 21.2057 4.69353 21.5207L12.0002 14.2141L12.0003 14.2141L19.3069 21.5207C19.7164 21.2056 20.1104 20.8609 20.4855 20.4858C20.8607 20.1106 21.2053 19.7167 21.5204 19.3072Z"
      fill="#D80027"
    />
    <path
      d="M9.91261 3.65286L11.9996 4.17458L14.0865 3.65286V1.87897L13.2517 2.29635L11.9996 1.04417L10.7474 2.29635L9.91261 1.87897V3.65286Z"
      fill="#FFDA44"
    />
    <path
      d="M9.91261 3.65289V4.95733C9.91261 6.55483 11.9996 7.0443 11.9996 7.0443C11.9996 7.0443 14.0865 6.55478 14.0865 4.95733V3.65289H9.91261Z"
      fill="#D80027"
    />
  </svg>
));
export const JM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2325)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M19.3056 2.48076C17.2821 0.925403 14.7493 0.000137329 11.9999 0.000137329C9.25045 0.000137329 6.71751 0.92545 4.69406 2.48076L11.9999 9.78651L19.3056 2.48076Z"
        fill="#6DA544"
      />
      <path
        d="M2.48028 4.69362C0.925017 6.71707 -0.000295639 9.24996 -0.000295639 11.9994C-0.000295639 14.7488 0.925017 17.2817 2.48033 19.3052L9.78613 11.9994L2.48028 4.69362Z"
        fill="black"
      />
      <path
        d="M4.69406 21.5188C6.71756 23.0741 9.25045 23.9994 11.9999 23.9994C14.7493 23.9994 17.2821 23.0741 19.3056 21.5188L11.9999 14.213L4.69406 21.5188Z"
        fill="#6DA544"
      />
      <path
        d="M21.5193 19.3051C23.0746 17.2817 23.9999 14.7488 23.9999 11.9994C23.9999 9.24996 23.0746 6.71707 21.5193 4.69362L14.2135 11.9994L21.5193 19.3051Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2325">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const JO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2342)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M7.30431 7.82625H23.2535C21.5581 3.25664 17.1595 0.000138283 12 0.000138283C8.68619 0.000138283 5.68652 1.34353 3.51508 3.51525L7.30431 7.82625Z"
        fill="black"
      />
      <path
        d="M7.30431 16.1745H23.2535C21.5581 20.7441 17.1595 24.0006 12 24.0006C8.68619 24.0006 5.68652 22.6572 3.51508 20.4855L7.30431 16.1745Z"
        fill="#6DA544"
      />
      <path
        d="M3.51476 3.51381C-1.17153 8.20009 -1.17153 15.7981 3.51476 20.4844C5.45131 18.5479 7.31379 16.6854 12.0001 11.9991L3.51476 3.51381Z"
        fill="#D80027"
      />
      <path
        d="M4.76281 9.39177L5.42135 10.7689L6.90865 10.4252L6.24256 11.7987L7.43857 12.7471L5.94949 13.0827L5.95362 14.6091L4.76281 13.6542L3.57195 14.6091L3.57612 13.0827L2.08704 12.7471L3.28301 11.7987L2.61701 10.4252L4.10421 10.7689L4.76281 9.39177Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2342">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const JP: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M12 17.2178C14.8815 17.2178 17.2174 14.8819 17.2174 12.0004C17.2174 9.11894 14.8815 6.78304 12 6.78304C9.11853 6.78304 6.78263 9.11894 6.78263 12.0004C6.78263 14.8819 9.11853 17.2178 12 17.2178Z"
      fill="#D80027"
    />
  </svg>
));
export const KE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2355)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0003 -0.000724792C7.24279 -0.000724792 3.13204 2.76795 1.19104 6.7819H22.8096C20.8686 2.76795 16.7578 -0.000724792 12.0003 -0.000724792Z"
        fill="black"
      />
      <path
        d="M12.0003 24.0001C7.24279 24.0001 3.13204 21.2314 1.19104 17.2175H22.8096C20.8686 21.2314 16.7578 24.0001 12.0003 24.0001Z"
        fill="#496E2D"
      />
      <path
        d="M23.4334 8.34706H0.566786C0.199193 9.49873 0.000114441 10.7257 0.000114441 11.9992C0.000114441 13.2728 0.199193 14.4997 0.566786 15.6514H23.4334C23.801 14.4997 24.0001 13.2728 24.0001 11.9992C24.0001 10.7257 23.801 9.49873 23.4334 8.34706Z"
        fill="#A2001D"
      />
      <path
        d="M15.7368 5.54511L14.3157 4.88919L12.0002 10.1322L9.68464 4.88919L8.26353 5.54511L11.1383 11.9998L8.26353 18.4544L9.68464 19.1103L12.0002 13.8673L14.3157 19.1103L15.7368 18.4544L12.8621 11.9998L15.7368 5.54511Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.9654 6.16324C12.4152 5.56244 12.0002 5.21706 12.0002 5.21706C12.0002 5.21706 11.5851 5.56239 11.0349 6.16324V17.836C11.5851 18.4369 12.0002 18.7823 12.0002 18.7823C12.0002 18.7823 12.4152 18.437 12.9654 17.8361V6.16324Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.39165 8.40226V15.5981C9.97299 16.6282 10.6845 17.4725 11.2178 18.0323V5.96814C10.6845 6.52787 9.97294 7.37223 9.39165 8.40226Z"
        fill="#A2001D"
      />
      <path
        d="M14.6088 8.40284C14.0274 7.37276 13.3159 6.52845 12.7827 5.96871V18.0329C13.3159 17.4731 14.0274 16.6288 14.6088 15.5987V8.40284Z"
        fill="#A2001D"
      />
      <path
        d="M14.6087 8.40091V15.5968C15.1972 14.5539 15.6522 13.3206 15.6522 11.9989C15.6522 10.6772 15.1972 9.44388 14.6087 8.40091Z"
        fill="black"
      />
      <path
        d="M9.39129 8.40091V15.5968C8.80277 14.5539 8.34781 13.3206 8.34781 11.9989C8.34781 10.6772 8.80277 9.44388 9.39129 8.40091Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2355">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M17.8682 12L15.4703 13.1279L16.7472 15.4504L14.1432 14.9522L13.8133 17.5826L11.9995 15.6481L10.1858 17.5826L9.85587 14.9522L7.25206 15.4503L8.52894 13.1278L6.13095 12L8.52894 10.8722L7.25206 8.54959L9.85578 9.04787L10.1859 6.41739L11.9995 8.35197L13.8134 6.41739L14.1432 9.04787L16.7473 8.54959L15.4703 10.8723L17.8682 12Z"
      fill="#FFDA44"
    />
    <path
      d="M12.0002 15.6514C14.0173 15.6514 15.6524 14.0163 15.6524 11.9992C15.6524 9.98221 14.0173 8.34708 12.0002 8.34708C9.98319 8.34708 8.34806 9.98221 8.34806 11.9992C8.34806 14.0163 9.98319 15.6514 12.0002 15.6514Z"
      fill="#D80027"
    />
    <path
      d="M10.1742 12.0005C10.0862 12.0005 9.99933 12.005 9.9136 12.0135C9.91674 12.5193 10.0997 12.9823 10.402 13.342C10.5632 12.908 10.804 12.5124 11.1076 12.1738C10.8176 12.0622 10.5031 12.0005 10.1742 12.0005Z"
      fill="#FFDA44"
    />
    <path
      d="M11.2984 13.9671C11.5178 14.0455 11.754 14.0884 12.0004 14.0884C12.2468 14.0884 12.483 14.0455 12.7023 13.9671C12.5828 13.4978 12.3359 13.0788 12.0004 12.7495C11.6649 13.0787 11.418 13.4978 11.2984 13.9671Z"
      fill="#FFDA44"
    />
    <path
      d="M13.8078 10.9573C13.447 10.3336 12.7731 9.91351 12.0006 9.91351C11.2281 9.91351 10.5541 10.3336 10.1933 10.9573C10.8511 10.9607 11.468 11.1395 12.0006 11.4484C12.5331 11.1395 13.1499 10.9607 13.8078 10.9573Z"
      fill="#FFDA44"
    />
    <path
      d="M12.8927 12.1739C13.1963 12.5125 13.437 12.9082 13.5983 13.3422C13.9005 12.9825 14.0835 12.5195 14.0867 12.0137C14.0009 12.0051 13.914 12.0006 13.8261 12.0006C13.4973 12.0006 13.1827 12.0624 12.8927 12.1739Z"
      fill="#FFDA44"
    />
  </svg>
));
export const KH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1737)">
      <path
        d="M0.000228882 12.0009C0.000228882 14.0798 0.52912 16.0351 1.45931 17.74L12.0002 18.7835L22.5411 17.74C23.4713 16.0351 24.0002 14.0798 24.0002 12.0009C24.0002 9.92195 23.4713 7.96661 22.5411 6.26172L12.0002 5.21823L1.45931 6.26172C0.52912 7.96661 0.000228882 9.92195 0.000228882 12.0009Z"
        fill="#D80027"
      />
      <path
        d="M1.45906 6.26126H22.5409C20.5056 2.53113 16.5485 0.000396729 12 0.000396729C7.45147 0.000396729 3.49433 2.53113 1.45906 6.26126Z"
        fill="#0052B4"
      />
      <path d="M12 24.0008C16.5485 24.0008 20.5057 21.4701 22.5409 17.74H1.45909C3.49436 21.4701 7.4515 24.0008 12 24.0008Z" fill="#0052B4" />
      <path
        d="M16.1743 14.3474V12.7822H15.1309V10.6952L14.0874 9.65173L13.0439 10.6952V8.60824L12.0004 7.56476L10.9569 8.60824V10.6952L9.91344 9.65173L8.86996 10.6952V12.7822H7.82652V14.3474H6.78304V15.9126H17.2178V14.3474H16.1743Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1737">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2369)">
      <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027" />
      <path
        d="M16.1734 11.1601L14.4679 11.9622L15.3761 13.6141L13.5241 13.2597L13.2895 15.1306L11.9995 13.7546L10.7095 15.1306L10.4749 13.2597L8.62293 13.614L9.53113 11.9622L7.82563 11.1601L9.53113 10.3577L8.62293 8.70611L10.4749 9.0603L10.7096 7.18951L11.9995 8.56544L13.2895 7.18951L13.5241 9.0603L15.3762 8.70611L14.468 10.3579L16.1734 11.1601Z"
        fill="#FFDA44"
      />
      <path
        d="M15.1305 3.91304H12.7826C12.7826 3.4809 12.4322 3.13042 12 3.13042C11.5678 3.13042 11.2174 3.48085 11.2174 3.91304H8.86957C8.86957 4.34523 9.24607 4.69567 9.67826 4.69567H9.65215C9.65215 5.12785 10.0025 5.47829 10.4348 5.47829C10.4348 5.91048 10.7851 6.26091 11.2174 6.26091H12.7826C13.2147 6.26091 13.5652 5.91052 13.5652 5.47829C13.9974 5.47829 14.3478 5.1279 14.3478 4.69567H14.3217C14.754 4.69567 15.1305 4.34528 15.1305 3.91304Z"
        fill="#FFDA44"
      />
      <path
        d="M24.0002 11.9996C24.0002 18.627 18.6276 23.9996 12.0002 23.9996C5.37285 23.9996 0.000225067 18.627 0.000225067 11.9996C0.521944 11.9996 24.0002 11.9996 24.0002 11.9996Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0005 24.0005C15.7515 24.0005 19.1 22.279 21.3006 19.5835C20.9048 19.3137 20.6911 18.8775 20.0003 18.8775C19.0003 18.8775 19.0003 19.7918 18.0004 19.7918C17.0005 19.7918 17.0004 18.8775 16.0005 18.8775C15.0005 18.8775 15.0005 19.7918 14.0005 19.7918C13.0004 19.7918 13.0004 18.8775 12.0003 18.8775C11.0003 18.8775 11.0003 19.7918 10.0004 19.7918C9.00053 19.7918 9.00053 18.8775 8.00055 18.8775C7.00047 18.8775 7.00047 19.7918 6.00039 19.7918C5.00032 19.7918 5.00032 18.8775 4.00024 18.8775C3.30958 18.8775 3.09588 19.3136 2.70025 19.5834C4.90075 22.279 8.24941 24.0005 12.0005 24.0005Z"
        fill="#0052B4"
      />
      <path
        d="M22 13.5312C21 13.5312 21 12.6168 20 12.6168C19 12.6168 19 13.5312 18 13.5312C17.0001 13.5312 17 12.6168 16.0001 12.6168C15.0001 12.6168 15.0001 13.5312 14.0001 13.5312C13.0001 13.5312 13 12.6168 11.9999 12.6168C11 12.6168 11 13.5312 10 13.5312C9.00017 13.5312 9.00017 12.6168 8.00019 12.6168C7.00011 12.6168 7.00011 13.5312 6.00003 13.5312C4.99995 13.5312 4.99995 12.6168 3.99988 12.6168C3.00003 12.6168 3.00003 13.5312 2.00005 13.5312C1.00545 13.5312 0.999689 12.6269 0.0157356 12.6173C0.0434387 13.1662 0.10897 13.705 0.208064 14.232C1.00513 14.3491 1.07492 15.1312 2.00009 15.1312C3.00008 15.1312 3.00008 14.2169 3.99992 14.2169C5 14.2169 5 15.1312 6.00008 15.1312C7.00016 15.1312 7.00016 14.2169 8.00024 14.2169C9.00022 14.2169 9.00022 15.1312 10.0001 15.1312C11 15.1312 11 14.2169 12 14.2169C13.0001 14.2169 13.0001 15.1312 14.0001 15.1312C15.0002 15.1312 15.0002 14.2169 16.0002 14.2169C17.0001 14.2169 17.0001 15.1312 18.0001 15.1312C19 15.1312 19.0001 14.2169 20 14.2169C21.0001 14.2169 21.0001 15.1312 22 15.1312C22.9253 15.1312 22.9951 14.3492 23.7922 14.232C23.8913 13.705 23.9568 13.1662 23.9846 12.6173C23.0005 12.627 22.9946 13.5312 22 13.5312Z"
        fill="#0052B4"
      />
      <path
        d="M20.0002 15.7477C19.0002 15.7477 19.0002 16.662 18.0003 16.662C17.0003 16.662 17.0003 15.7477 16.0003 15.7477C15.0003 15.7477 15.0003 16.662 14.0003 16.662C13.0002 16.662 13.0002 15.7477 12.0002 15.7477C11.0002 15.7477 11.0002 16.662 10.0002 16.662C9.00039 16.662 9.00039 15.7477 8.00041 15.7477C7.00033 15.7477 7.00033 16.662 6.00025 16.662C5.00017 16.662 5.00017 15.7477 4.0001 15.7477C3.00025 15.7477 3.00025 16.662 2.00027 16.662C1.28575 16.662 1.08166 16.1954 0.658611 15.9287C0.940236 16.7424 1.30661 17.5165 1.74785 18.24C1.82458 18.2542 1.90811 18.262 2.00027 18.262C3.00025 18.262 3.00025 17.3478 4.0001 17.3478C5.00017 17.3478 5.00017 18.262 6.00025 18.262C7.00033 18.262 7.00033 17.3478 8.00041 17.3478C9.00039 17.3478 9.00039 18.262 10.0002 18.262C11.0002 18.262 11.0002 17.3478 12.0002 17.3478C13.0002 17.3478 13.0002 18.262 14.0003 18.262C15.0004 18.262 15.0004 17.3478 16.0003 17.3478C17.0003 17.3478 17.0003 18.262 18.0003 18.262C19.0002 18.262 19.0002 17.3478 20.0002 17.3478C21.0003 17.3478 21.0003 18.262 22.0002 18.262C22.0924 18.262 22.176 18.2542 22.2527 18.24C22.6939 17.5165 23.0603 16.7424 23.342 15.9288C22.9189 16.1953 22.7148 16.662 22.0002 16.662C21.0003 16.662 21.0003 15.7477 20.0002 15.7477Z"
        fill="#0052B4"
      />
      <path
        d="M23.963 11.051C23.0007 11.0738 22.9874 11.9643 22.0001 11.9643C21.0001 11.9643 21.0001 11.05 20.0001 11.05C19.0001 11.05 19.0001 11.9643 18.0001 11.9643C17.0002 11.9643 17.0001 11.05 16.0002 11.05C15.0002 11.05 15.0002 11.9643 14.0002 11.9643C13.0002 11.9643 13.0001 11.05 12 11.05C11.0001 11.05 11.0001 11.9643 10.0001 11.9643C9.00027 11.9643 9.00027 11.05 8.00029 11.05C7.00021 11.05 7.00021 11.9643 6.00013 11.9643C5.00005 11.9643 5.00005 11.05 3.99998 11.05C3.00013 11.05 3.00013 11.9643 2.00015 11.9643C1.01301 11.9643 0.999647 11.0739 0.0373969 11.051C0.0129751 11.3639 0.000225067 11.68 0.000225067 11.9991C0.000225067 12.2177 0.00641257 12.4348 0.0180844 12.6505C0.999788 12.6615 1.0063 13.5643 2.00019 13.5643C3.00018 13.5643 3.00018 12.65 4.00002 12.65C5.0001 12.65 5.0001 13.5643 6.00018 13.5643C7.00026 13.5643 7.00026 12.65 8.00033 12.65C9.00032 12.65 9.00032 13.5643 10.0002 13.5643C11.0001 13.5643 11.0001 12.65 12.0001 12.65C13.0002 12.65 13.0002 13.5643 14.0002 13.5643C15.0003 13.5643 15.0003 12.65 16.0003 12.65C17.0002 12.65 17.0002 13.5643 18.0002 13.5643C19.0001 13.5643 19.0002 12.65 20.0001 12.65C21.0002 12.65 21.0002 13.5643 22.0001 13.5643C22.9941 13.5643 23.0006 12.6615 23.9825 12.6505C23.994 12.4348 24.0002 12.2177 24.0002 11.9991C24.0002 11.68 23.9875 11.3639 23.963 11.051Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2369">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1844)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.9994 11.9653H10.9911C8.40847 14.548 6.84669 16.5419 5.252 18.1366L12.0346 18.7478L22.5597 17.7044C23.4782 16.0077 23.9998 14.0648 23.9998 12C23.9998 11.9884 23.9994 11.9769 23.9994 11.9653Z"
        fill="#D80027"
      />
      <path
        d="M5.25263 6.22558H22.5219C20.4811 2.51458 16.5347 -0.000549316 12.0004 -0.000549316C8.6955 -0.000549316 5.70319 1.3359 3.53311 3.49745L5.25263 6.22558Z"
        fill="#FFDA44"
      />
      <path
        d="M5.77341 17.704C4.69463 18.7828 4.27772 19.6866 3.49721 20.4671C5.6701 22.649 8.6769 23.9996 11.9995 23.9996C16.5621 23.9996 20.5298 21.4531 22.5593 17.704H5.77341Z"
        fill="#0052B4"
      />
      <path
        d="M3.51425 3.48035C-1.17203 8.16663 -1.17203 15.7646 3.51425 20.451C5.4508 18.5144 7.31328 16.6519 11.9996 11.9657L3.51425 3.48035Z"
        fill="#6DA544"
      />
      <path
        d="M3.16536 11.9647C3.16536 10.2163 4.3941 8.75575 6.03491 8.39744C5.78272 8.34236 5.52106 8.3125 5.25228 8.3125C3.23521 8.3125 1.60011 9.9476 1.60011 11.9647C1.60011 13.9818 3.23521 15.6169 5.25228 15.6169C5.52102 15.6169 5.78267 15.587 6.03491 15.5319C4.3941 15.1736 3.16536 13.713 3.16536 11.9647Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.99481 8.83466L6.18911 9.4325H6.8177L6.30911 9.80201L6.5034 10.3999L5.99481 10.0304L5.48622 10.3999L5.68051 9.80201L5.17192 9.4325H5.80051L5.99481 8.83466Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.99481 10.3998L6.18911 10.9977H6.8177L6.30911 11.3671L6.5034 11.965L5.99481 11.5955L5.48622 11.965L5.68051 11.3671L5.17192 10.9977H5.80051L5.99481 10.3998Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.99481 11.9647L6.18911 12.5625H6.8177L6.30911 12.932L6.5034 13.5299L5.99481 13.1603L5.48622 13.5299L5.68051 12.932L5.17192 12.5625H5.80051L5.99481 11.9647Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.99481 13.5297L6.18911 14.1276H6.8177L6.30911 14.4971L6.5034 15.0949L5.99481 14.7255L5.48622 15.0949L5.68051 14.4971L5.17192 14.1276H5.80051L5.99481 13.5297Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1844">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z" fill="#FFDA44" />
    <path
      d="M3.51501 20.4852C4.0184 20.9885 4.55554 21.4375 5.11894 21.8327L21.8331 5.11856C21.4379 4.55512 20.989 4.01802 20.4855 3.51463C19.9821 3.01124 19.445 2.56241 18.8816 2.16711L2.16759 18.8813C2.56274 19.4447 3.01162 19.9818 3.51501 20.4852Z"
      fill="black"
    />
    <path
      d="M3.51436 3.51475C-0.271418 7.30053 -0.998216 12.9861 1.3326 17.5021L17.5017 1.33309C12.9857 -0.997679 7.29999 -0.27088 3.51436 3.51475Z"
      fill="#6DA544"
    />
    <path
      d="M20.4853 20.4847C24.271 16.699 24.9978 11.0134 22.6671 6.49731L6.49785 22.6665C11.0139 24.9972 16.6995 24.2705 20.4853 20.4847Z"
      fill="#D80027"
    />
    <path
      d="M7.62979 14.1578L8.75001 14.7286L9.63904 13.8396L9.44235 15.0813L10.5625 15.6521L9.32076 15.8488L9.12407 17.0905L8.55332 15.9703L7.3116 16.167L8.20059 15.278L7.62979 14.1578Z"
      fill="#F0F0F0"
    />
    <path
      d="M14.1561 7.63057L15.2763 8.20136L16.1653 7.31238L15.9687 8.55405L17.0888 9.1249L15.8471 9.32158L15.6504 10.5633L15.0796 9.44313L13.8379 9.63977L14.7269 8.75079L14.1561 7.63057Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const KP: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2723)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.9999 -0.000274658C8.36281 -0.000274658 5.10392 1.61804 2.90327 4.17362H21.0964C18.8959 1.61804 15.637 -0.000274658 11.9999 -0.000274658Z"
        fill="#0052B4"
      />
      <path
        d="M21.0962 19.8269H2.90295C5.1036 22.3825 8.36249 24.0008 11.9996 24.0008C15.6366 24.0008 18.8955 22.3825 21.0962 19.8269Z"
        fill="#0052B4"
      />
      <path
        d="M22.2388 5.7386H1.76133C0.644343 7.56134 4.57764e-05 9.70507 4.57764e-05 11.9995C4.57764e-05 14.2939 0.644343 16.4376 1.76133 18.2603H22.2388C23.3557 16.4376 24 14.2939 24 11.9995C24 9.70507 23.3557 7.56134 22.2388 5.7386Z"
        fill="#D80027"
      />
      <path
        d="M7.38269 16.6182C9.9328 16.6182 12.0001 14.551 12.0001 12.0008C12.0001 9.45074 9.9328 7.38347 7.38269 7.38347C4.83259 7.38347 2.76532 9.45074 2.76532 12.0008C2.76532 14.551 4.83259 16.6182 7.38269 16.6182Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.38239 7.38347L8.41838 10.572H11.7764L9.05874 12.5427L10.1028 15.7407L7.38239 13.7606L4.66608 15.737L5.70605 12.5427L2.99081 10.572H6.34636L7.38239 7.38347Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2723">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M16.1741 11.9996C16.1741 13.0431 14.3054 15.6518 12.0002 15.6518C9.69501 15.6518 7.82629 13.0431 7.82629 11.9996C7.82629 9.69442 9.69501 7.82574 12.0002 7.82574C14.3054 7.82574 16.1741 9.69442 16.1741 11.9996Z"
      fill="#D80027"
    />
    <path d="M16.1741 11.9995C16.1741 14.3047 14.3054 16.1734 12.0002 16.1734C9.69501 16.1734 7.82629 14.3047 7.82629 11.9995" fill="#0052B4" />
    <path d="M17.5336 14.5826L16.4268 15.6893L17.1647 16.4272L18.2714 15.3204L17.5336 14.5826Z" fill="black" />
    <path d="M15.6884 16.4268L14.5817 17.5336L15.3195 18.2714L16.4263 17.1647L15.6884 16.4268Z" fill="black" />
    <path d="M19.7471 16.7947L18.6403 17.9015L19.3782 18.6393L20.4849 17.5326L19.7471 16.7947Z" fill="black" />
    <path d="M17.903 18.6409L16.7963 19.7477L17.5341 20.4855L18.6409 19.3788L17.903 18.6409Z" fill="black" />
    <path d="M18.6406 15.6896L17.5339 16.7964L18.2717 17.5342L19.3785 16.4275L18.6406 15.6896Z" fill="black" />
    <path d="M16.796 17.5339L15.6892 18.6406L16.4271 19.3785L17.5338 18.2717L16.796 17.5339Z" fill="black" />
    <path d="M15.6893 5.35815L18.6407 8.30951L19.3785 7.57166L16.4272 4.62031L15.6893 5.35815Z" fill="black" />
    <path d="M14.5828 6.46618L15.6895 7.57294L16.4273 6.83512L15.3206 5.72837L14.5828 6.46618Z" fill="black" />
    <path d="M16.4274 8.31L17.5341 9.41675L18.272 8.67893L17.1652 7.57218L16.4274 8.31Z" fill="black" />
    <path d="M16.7951 4.25225L17.9019 5.35901L18.6397 4.62116L17.5329 3.5144L16.7951 4.25225Z" fill="black" />
    <path d="M18.6409 6.09765L19.7477 7.20441L20.4855 6.46656L19.3787 5.3598L18.6409 6.09765Z" fill="black" />
    <path d="M7.20342 19.7479L4.25206 16.7966L3.51421 17.5344L6.46557 20.4858L7.20342 19.7479Z" fill="black" />
    <path d="M8.31067 18.64L7.20392 17.5332L6.4661 18.271L7.57286 19.3778L8.31067 18.64Z" fill="black" />
    <path d="M6.46587 16.7959L5.35912 15.6891L4.62127 16.427L5.72802 17.5337L6.46587 16.7959Z" fill="black" />
    <path d="M9.41751 17.5337L6.46616 14.5823L5.72831 15.3202L8.67967 18.2715L9.41751 17.5337Z" fill="black" />
    <path d="M4.25265 7.20471L7.20401 4.25336L6.46616 3.51551L3.5148 6.46687L4.25265 7.20471Z" fill="black" />
    <path d="M5.35862 8.30982L8.30998 5.35846L7.57213 4.62061L4.62077 7.57197L5.35862 8.30982Z" fill="black" />
    <path d="M6.46635 9.41706L9.41771 6.4657L8.67989 5.72788L5.72854 8.67924L6.46635 9.41706Z" fill="black" />
  </svg>
));
export const KW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2381)">
      <path
        d="M23.2541 16.1731C23.7364 14.8731 24.0005 13.467 24.0005 11.9992C24.0005 10.5313 23.7364 9.12527 23.2541 7.82528L12.0005 6.7818L0.746845 7.82528C0.264501 9.12527 0.000453949 10.5313 0.000453949 11.9992C0.000453949 13.467 0.264501 14.8731 0.746845 16.1731L12.0005 17.2166L23.2541 16.1731Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0003 23.9995C17.1598 23.9995 21.5584 20.743 23.2538 16.1734H0.746609C2.44217 20.743 6.84064 23.9995 12.0003 23.9995Z"
        fill="#D80027"
      />
      <path
        d="M12.0002 -0.000518799C6.84059 -0.000518799 2.44213 3.25598 0.746563 7.82559H23.2538C21.5583 3.25598 17.1597 -0.000518799 12.0002 -0.000518799Z"
        fill="#6DA544"
      />
      <path
        d="M3.51516 3.5145C-1.17112 8.20078 -1.17112 15.7988 3.51516 20.4851C4.73837 19.2619 5.93227 18.068 7.82654 16.1737V7.82592L3.51516 3.5145Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2381">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1757)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
      <path
        d="M11.9686 12.0004H12.0008C12.0008 11.9896 12.0008 11.9791 12.0008 11.9683C11.9901 11.979 11.9794 11.9897 11.9686 12.0004Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0003 6.2604C12.0003 4.14892 12.0003 2.7654 12.0003 -0.000457764H11.9982C5.37171 0.000667236 0.000259399 5.37278 0.000259399 11.9995H6.26112V8.47403L9.78663 11.9995H11.9682C11.9789 11.9889 11.9896 11.9782 12.0003 11.9674C12.0003 11.159 12.0003 10.4376 12.0003 9.78601L8.4747 6.2604H12.0003Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.2173 8.86919C18.3699 8.86919 19.3043 7.93482 19.3043 6.78222C19.3043 5.62962 18.3699 4.69525 17.2173 4.69525C16.0647 4.69525 15.1303 5.62962 15.1303 6.78222C15.1303 7.93482 16.0647 8.86919 17.2173 8.86919Z"
        fill="#6DA544"
      />
      <path
        d="M6.0706 1.56528C4.19377 2.63398 2.63345 4.19426 1.56479 6.07109V12.0001H4.69524V4.69582V4.69573H11.9996C11.9996 3.7084 11.9996 2.76781 11.9996 1.56528H6.0706Z"
        fill="#D80027"
      />
      <path
        d="M11.9993 10.5239L7.73577 6.26044H6.26015V6.26053L11.9992 11.9995H11.9993C11.9993 11.9995 11.9993 10.982 11.9993 10.5239Z"
        fill="#D80027"
      />
      <path d="M20.8691 6.26044H13.5648V9.39089H20.8691V6.26044Z" fill="#D80027" />
      <path
        d="M13.5652 14.0869V16.1738H14.6632C15.3216 16.819 16.2228 17.2173 17.2174 17.2173C18.212 17.2173 19.1132 16.819 19.7716 16.1738H19.8261H20.8696V14.0869H13.5652Z"
        fill="#FFDA44"
      />
      <path
        d="M13.5652 8.86902V11.9995C13.5652 14.7951 17.2174 15.6516 17.2174 15.6516C17.2174 15.6516 20.8696 14.7951 20.8696 11.9995V8.86902H13.5652Z"
        fill="#338AF3"
      />
      <path
        d="M17.2173 10.5403C16.3043 10.5403 16.3043 11.3751 15.3913 11.3751C14.4783 11.3751 14.4783 10.5403 13.5653 10.5403V12.0012C14.4783 12.0012 14.4783 12.836 15.3913 12.836C16.3043 12.836 16.3043 12.0012 17.2173 12.0012C18.1303 12.0012 18.1303 12.836 19.0435 12.836C19.9566 12.836 19.9565 12.0012 20.8697 12.0012V10.5403C19.9566 10.5403 19.9566 11.3751 19.0435 11.3751C18.1303 11.3751 18.1303 10.5403 17.2173 10.5403Z"
        fill="#F3F3F3"
      />
      <path
        d="M17.2172 7.61664C16.3042 7.61664 16.3042 8.45144 15.3912 8.45144C14.4782 8.45144 14.4782 7.61664 13.5652 7.61664V9.0775C14.4782 9.0775 14.4782 9.91229 15.3912 9.91229C16.3042 9.91229 16.3042 9.0775 17.2172 9.0775C18.1303 9.0775 18.1303 9.91229 19.0434 9.91229C19.9565 9.91229 19.9565 9.0775 20.8696 9.0775V7.61664C19.9565 7.61664 19.9565 8.45144 19.0434 8.45144C18.1303 8.45144 18.1303 7.61664 17.2172 7.61664Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1757">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const KZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3" />
    <path
      d="M18.783 12.1301H5.21774C5.21774 13.0666 6.03341 13.8258 6.96983 13.8258H6.91339C6.91339 14.7623 7.67253 15.5214 8.60905 15.5214C8.60905 16.458 9.36819 17.2171 10.3047 17.2171H13.696C14.6325 17.2171 15.3917 16.458 15.3917 15.5214C16.3282 15.5214 17.0873 14.7623 17.0873 13.8258H17.0309C17.9672 13.8258 18.783 13.0666 18.783 12.1301Z"
      fill="#FFDA44"
    />
    <path d="M16.696 9.91351C16.696 12.5068 14.5937 14.6092 12.0004 14.6092C9.40702 14.6092 7.30473 12.5068 7.30473 9.91351" fill="#338AF3" />
    <path
      d="M15.5865 9.9124L14.121 10.6018L14.9014 12.0212L13.31 11.7167L13.1083 13.3243L11.9999 12.1419L10.8914 13.3243L10.6898 11.7167L9.09836 12.0211L9.87874 10.6017L8.41324 9.9124L9.87879 9.22305L9.09836 7.80372L10.6897 8.10813L10.8914 6.5005L11.9999 7.68293L13.1084 6.5005L13.31 8.10813L14.9014 7.80372L14.121 9.2231L15.5865 9.9124Z"
      fill="#FFDA44"
    />
  </svg>
));
export const LA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2397)">
      <path
        d="M22.8093 6.78189C20.8683 2.76794 16.7576 -0.000732422 12 -0.000732422C7.24251 -0.000732422 3.13176 2.76794 1.19076 6.78189L12 7.82538L22.8093 6.78189Z"
        fill="#D80027"
      />
      <path
        d="M1.1905 17.2162C3.1315 21.2301 7.24225 23.9988 11.9998 23.9988C16.7573 23.9988 20.8681 21.2301 22.8091 17.2162L11.9998 16.1727L1.1905 17.2162Z"
        fill="#D80027"
      />
      <path
        d="M22.809 6.7818H1.19042C0.427579 8.35938 -0.000295639 10.1293 -0.000295639 11.9992C-0.000295639 13.8691 0.427579 15.639 1.19042 17.2166H22.8089C23.5719 15.639 23.9997 13.8691 23.9997 11.9992C23.9997 10.1293 23.5719 8.35938 22.809 6.7818Z"
        fill="#0052B4"
      />
      <path
        d="M12.0001 16.1736C14.3053 16.1736 16.174 14.3049 16.174 11.9997C16.174 9.69455 14.3053 7.82584 12.0001 7.82584C9.69497 7.82584 7.82626 9.69455 7.82626 11.9997C7.82626 14.3049 9.69497 16.1736 12.0001 16.1736Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2397">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LB: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2410)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0001 -0.000732422C7.24261 -0.000732422 3.13186 2.76794 1.19086 6.78189H22.8094C20.8684 2.76794 16.7576 -0.000732422 12.0001 -0.000732422Z"
        fill="#D80027"
      />
      <path
        d="M12.0003 23.9994C16.7578 23.9994 20.8686 21.2307 22.8096 17.2167H1.19105C3.13205 21.2307 7.2428 23.9994 12.0003 23.9994Z"
        fill="#D80027"
      />
      <path d="M15.1305 14.0862L12.0001 8.34708L8.86964 14.0862H11.2175V15.6514H12.7827V14.0862H15.1305Z" fill="#6DA544" />
    </g>
    <defs>
      <clipPath id="clip0_5_2410">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3" />
    <path d="M7.56528 16.1739H16.4349L12.0001 5.73914L7.56528 16.1739Z" fill="#F3F3F3" />
    <path d="M9.10655 15.1303L12.0001 8.54858L14.8937 15.1303H9.10655Z" fill="#333333" />
    <path d="M7.56528 16.1745H16.4349L12.0001 12.0006L7.56528 16.1745Z" fill="#FFDA44" />
  </svg>
));
export const LI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2449)">
      <path
        d="M24.0002 11.9995C24.0002 18.6269 18.6276 23.9995 12.0002 23.9995C5.37285 23.9995 0.000225067 18.6269 0.000225067 11.9995C0.521944 11.9995 12.0002 10.4343 12.0002 10.4343L24.0002 11.9995Z"
        fill="#D80027"
      />
      <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#0052B4" />
      <path
        d="M8.8699 8.34736C8.8699 7.48294 8.16912 6.78216 7.3047 6.78216C6.90369 6.78216 6.5382 6.9331 6.26122 7.18102V6.26039H6.78294V5.21691H6.26122V4.69519H5.21773V5.21691H4.69601V6.26039H5.21773V7.18102C4.94075 6.9331 4.57526 6.78216 4.17425 6.78216C3.30983 6.78216 2.60905 7.48294 2.60905 8.34736C2.60905 8.81082 2.81066 9.22707 3.13077 9.51371V10.4343H8.34814V9.51371C8.66834 9.22707 8.8699 8.81082 8.8699 8.34736Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2449">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M4.68751e-05 2.08618H0V21.9122H4.68751e-05V11.9993V2.08618Z" fill="#FF9811" />
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z" fill="#FFDA44" />
    <path
      d="M9.39104 2.08618H5.23626C5.05214 2.21204 4.87195 2.34306 4.69537 2.47867L3.65189 11.9992L4.69537 21.5197C4.87195 21.6554 5.05214 21.7864 5.23626 21.9122H9.39104V2.08618Z"
      fill="#FF9811"
    />
    <path d="M0 12.0006C0 15.8793 1.84069 19.3275 4.69567 21.5211V2.48004C1.84069 4.6737 0 8.12193 0 12.0006Z" fill="#6DA544" />
    <path d="M19.3043 7.31537V7.61588L19.3155 7.61757L19.3043 7.31537Z" fill="#FFDA44" />
    <path
      d="M23.0435 15.1296H20.7826L19.8261 16.1731V18.2601H17.7391V17.2166H18.7826V15.1296H14.0869V16.434H13.0435V13.9482C12.7233 13.6616 12.5217 13.2453 12.5217 12.7818V5.99922C12.5217 5.1348 13.2225 4.43401 14.0869 4.43401V14.0862H16.1739L16.89 13.4894C16.7649 13.1915 16.6956 12.8644 16.6956 12.521V10.9558H15.1304V7.82538H18.2608C18.2608 7.30366 19.0435 6.78189 19.0435 6.78189C19.0435 6.78189 19.8261 7.30361 19.8261 7.82538V8.60801V10.9558C20.4065 10.9627 21.3288 10.9477 22.3251 10.9558C22.0633 10.4983 21.913 9.95548 21.913 9.39063C21.913 8.46996 22.3105 7.64224 22.9432 7.06943C22.0312 5.04841 20.5759 3.32518 18.7634 2.08618H10.9565V21.9123H18.7635C20.9675 20.4057 22.6432 18.1833 23.4562 15.5799L23.0435 15.1296Z"
      fill="#A2001D"
    />
  </svg>
));
export const LR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2423)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M2.74293 4.36307H21.2571C20.5732 3.53502 19.7801 2.80073 18.9003 2.18127H5.09967C4.21987 2.80063 3.42679 3.53498 2.74293 4.36307Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 12.0005C0 12.3684 0.0174844 12.732 0.049875 13.0915H23.9501C23.9825 12.732 24 12.3684 24 12.0005C24 11.6327 23.9825 11.2691 23.9501 10.9097H0.049875C0.0174844 11.2691 0 11.6327 0 12.0005Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.30887 17.4546H22.6917C23.0451 16.7634 23.3333 16.0335 23.5484 15.2729H0.452183C0.667292 16.0335 0.955573 16.7635 1.30887 17.4546Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.09967 21.8181H18.9003C19.7801 21.1986 20.5732 20.4643 21.257 19.6363H2.74293C3.42679 20.4642 4.21987 21.1986 5.09967 21.8181Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.452084 8.72788H23.5484C23.3333 7.96719 23.045 7.23725 22.6917 6.54608H1.30882C0.955521 7.23725 0.66724 7.96719 0.452084 8.72788Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.73849 2.18186H18.8997C16.9478 0.807577 14.568 6.10352e-05 11.9993 6.10352e-05C10.4341 6.10352e-05 7.69036 0.807577 5.73849 2.18186Z"
        fill="#D80027"
      />
      <path d="M11.4782 6.54526H22.6914C22.2923 5.76465 21.8104 5.03345 21.257 4.36346H11.4782V6.54526Z" fill="#D80027" />
      <path d="M11.4782 10.9085H23.9501C23.8826 10.1593 23.7469 9.42976 23.5481 8.72668H11.4782V10.9085Z" fill="#D80027" />
      <path
        d="M0.451458 15.2736H23.5477C23.7466 14.5706 23.8822 13.841 23.9497 13.0919H0.0494576C0.116958 13.841 0.252614 14.5706 0.451458 15.2736Z"
        fill="#D80027"
      />
      <path
        d="M2.74264 19.6369H21.2568C21.8101 18.9668 22.2921 18.2356 22.6911 17.4551H1.30827C1.70732 18.2357 2.18929 18.9669 2.74264 19.6369Z"
        fill="#D80027"
      />
      <path
        d="M11.9993 24.0005C14.5679 24.0005 16.9477 23.193 18.8996 21.8187H5.09894C7.05081 23.193 9.43066 24.0005 11.9993 24.0005Z"
        fill="#D80027"
      />
      <path
        d="M0.451864 8.72685C0.253021 9.42998 0.117411 10.1595 0.0499115 10.9087H12V-0.000427246C6.50722 -0.000427246 1.87649 3.69014 0.451864 8.72685Z"
        fill="#0052B4"
      />
      <path
        d="M7.14364 3.13049L7.92059 5.52182H10.4352L8.40097 6.99989L9.17787 9.39136L7.14364 7.91339L5.10931 9.39136L5.8864 6.99989L3.85212 5.52182H6.36664L7.14364 3.13049Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2423">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2417)">
      <path
        d="M4.57764e-05 11.9999C4.57764e-05 13.8697 0.427874 15.6396 1.19076 17.2173L12 17.739L22.8093 17.2173C23.5722 15.6396 24 13.8697 24 11.9999C24 10.13 23.5722 8.36013 22.8093 6.78251L12 6.26074L1.19076 6.78246C0.427874 8.36013 4.57764e-05 10.13 4.57764e-05 11.9999Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0003 24.0001C16.7578 24.0001 20.8686 21.2314 22.8096 17.2175H1.19107C3.13207 21.2314 7.24282 24.0001 12.0003 24.0001Z"
        fill="#6DA544"
      />
      <path
        d="M12.0003 -0.000732422C7.24282 -0.000732422 3.13207 2.76794 1.19107 6.78189H22.8096C20.8686 2.76794 16.7578 -0.000732422 12.0003 -0.000732422Z"
        fill="#0052B4"
      />
      <path
        d="M12.7831 11.7392V8.86969H11.2179V11.7392L9.3274 13.6298C9.8772 14.5298 10.8686 15.1306 12.0005 15.1306C13.1323 15.1306 14.1237 14.5298 14.6736 13.6298L12.7831 11.7392Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2417">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2454)">
      <path
        d="M23.2539 16.1743C23.7363 14.8744 24.0003 13.4683 24.0003 12.0005C24.0003 10.5326 23.7363 9.1265 23.2539 7.82656L12.0003 6.78308L0.74673 7.82656C0.26434 9.1265 0.000339508 10.5326 0.000339508 12.0005C0.000339508 13.4683 0.26434 14.8744 0.74673 16.1743L12.0003 17.2178L23.2539 16.1743Z"
        fill="#6DA544"
      />
      <path
        d="M23.2538 7.82568C21.5582 3.25607 17.1597 -0.000427246 12.0001 -0.000427246C6.84056 -0.000427246 2.44205 3.25607 0.746532 7.82568H23.2538Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0003 24.0008C17.1599 24.0008 21.5584 20.7443 23.2539 16.1747H0.746693C2.44221 20.7443 6.84072 24.0008 12.0003 24.0008Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2454">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2459)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0002 -0.000366211C6.84059 -0.000366211 2.44208 3.25613 0.746563 7.82574H23.2538C21.5583 3.25613 17.1597 -0.000366211 12.0002 -0.000366211Z"
        fill="#D80027"
      />
      <path
        d="M12.0002 24.0008C17.1598 24.0008 21.5583 20.7443 23.2538 16.1747H0.746609C2.44212 20.7443 6.84064 24.0008 12.0002 24.0008Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2459">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LV: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2404)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0006 -0.000732422C6.45626 -0.000732422 1.79097 3.75963 0.413975 8.86881H23.5872C22.2102 3.75963 17.5449 -0.000732422 12.0006 -0.000732422Z"
        fill="#A2001D"
      />
      <path
        d="M12.0003 23.9986C17.5446 23.9986 22.2099 20.2382 23.5869 15.129H0.413681C1.79068 20.2382 6.45596 23.9986 12.0003 23.9986Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2404">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const LY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2441)">
      <path
        d="M1.19083 6.78274C0.427989 8.36037 0.000114441 10.1302 0.000114441 12.0001C0.000114441 13.87 0.427989 15.6399 1.19083 17.2175L12.0001 18.261L22.8094 17.2175C23.5722 15.6399 24.0001 13.87 24.0001 12.0001C24.0001 10.1302 23.5722 8.36037 22.8094 6.78274L12.0001 5.73926L1.19083 6.78274Z"
        fill="black"
      />
      <path
        d="M1.19143 17.2168C3.13234 21.2307 7.24276 23.9994 12.0003 23.9994C16.7578 23.9994 20.8682 21.2307 22.8091 17.2168H1.19143Z"
        fill="#496E2D"
      />
      <path
        d="M1.19143 6.78299H22.8091C20.8682 2.76904 16.7578 0.000366211 12.0003 0.000366211C7.24276 0.000366211 3.13234 2.76904 1.19143 6.78299Z"
        fill="#D80027"
      />
      <path
        d="M14.7934 9.80475L15.7779 11.1615L17.3725 10.6445L16.3863 12.0001L17.3708 13.3569L15.7769 12.8379L14.7907 14.1935L14.7917 12.5172L13.1977 11.9982L14.7923 11.4812L14.7934 9.80475Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.1065 15.3904C10.2335 15.3904 8.71515 13.872 8.71515 11.9991C8.71515 10.1261 10.2335 8.60776 12.1065 8.60776C12.6904 8.60776 13.2399 8.75542 13.7197 9.01539C12.967 8.2794 11.9379 7.82513 10.8021 7.82513C8.4969 7.82513 6.62823 9.69385 6.62823 11.999C6.62823 14.3042 8.49695 16.1729 10.8021 16.1729C11.9379 16.1729 12.9671 15.7187 13.7197 14.9827C13.2399 15.2427 12.6905 15.3904 12.1065 15.3904Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2441">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M19.092 9.84775H13.6744L12.0003 4.69543L10.3262 9.84775H4.90871L9.29157 13.0321L7.61743 18.1845L12.0003 15.0002L16.3832 18.1846L14.7091 13.0321L19.092 9.84775ZM10.5182 12.6335L11.0844 10.8912H12.9163L13.4824 12.6335V12.6335L12.0003 13.7103L10.5183 12.6335L10.5182 12.6335ZM12.5773 9.84775H11.4234L12.0003 8.07212L12.5773 9.84775ZM14.37 11.9886L14.0134 10.8912H15.8804L14.37 11.9886ZM9.9872 10.8912L9.63062 11.9886L8.12017 10.8912H9.9872ZM9.60226 15.4526L10.1792 13.6771L11.1127 14.3552L9.60226 15.4526ZM12.888 14.3553L13.8215 13.6771L14.3984 15.4527L12.888 14.3553Z"
      fill="#FFDA44"
    />
  </svg>
));
export const MC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027" />
  </svg>
));
export const MD: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2562)">
      <path
        d="M17.2171 1.19131C15.6395 0.42847 13.8696 0.000595093 11.9997 0.000595093C10.1299 0.000595093 8.35998 0.42847 6.78235 1.19131L5.73887 12.0006L6.78235 22.8099C8.35998 23.5727 10.1299 24.0006 11.9997 24.0006C13.8696 24.0006 15.6395 23.5727 17.2171 22.8099L18.2606 12.0006L17.2171 1.19131Z"
        fill="#FFDA44"
      />
      <path d="M6.78262 1.19211C2.76872 3.13306 0 7.24348 0 12.001C0 16.7585 2.76872 20.8689 6.78262 22.8098V1.19211Z" fill="#0052B4" />
      <path d="M17.2174 1.19211V22.8098C21.2313 20.8689 24 16.7585 24 12.001C24 7.24348 21.2313 3.13306 17.2174 1.19211Z" fill="#D80027" />
      <path
        d="M16.1736 9.44224H13.304C13.304 8.72186 12.72 8.13789 11.9997 8.13789C11.2793 8.13789 10.6953 8.72186 10.6953 9.44224H7.82578C7.82578 10.1515 8.44363 10.7264 9.15281 10.7264H9.11006C9.11006 11.4357 9.68503 12.0108 10.3943 12.0108C10.3943 12.6387 10.8454 13.1605 11.4411 13.2721L10.429 15.5569C10.9139 15.754 11.4439 15.8636 11.9997 15.8636C12.5554 15.8636 13.0854 15.754 13.5703 15.5569L12.5583 13.2721C13.154 13.1605 13.605 12.6387 13.605 12.0108C14.3143 12.0108 14.8893 11.4357 14.8893 10.7264H14.8465C15.5557 10.7264 16.1736 10.1515 16.1736 9.44224Z"
        fill="#FF9811"
      />
      <path d="M12 11.2177L10.3044 12.0004V13.5656L12 14.609L13.6957 13.5656V12.0004L12 11.2177Z" fill="#0052B4" />
      <path d="M13.6957 10.4341H10.3044V11.9993H13.6957V10.4341Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_5_2562">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ME: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2588)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M24.0003 11.9997C24.0003 7.88125 21.9252 4.24778 18.7638 2.0867H5.23689C2.0755 4.24778 0.000343323 7.88125 0.000343323 11.9997C0.000343323 16.1183 2.0755 19.7517 5.23689 21.9128H18.7638C21.9252 19.7517 24.0003 16.1183 24.0003 11.9997Z"
        fill="#A2001D"
      />
      <path d="M9.39182 8.87012H14.6092V6.7832L13.5657 7.30492L12.0005 5.73972L10.4353 7.30492L9.39182 6.7832V8.87012Z" fill="#FFDA44" />
      <path
        d="M16.6962 12.0002H14.0885C14.1908 11.8233 14.2502 11.6186 14.2502 11.3996C14.2502 10.7346 13.7111 10.1956 13.0462 10.1956C12.5868 10.1956 12.1878 10.453 11.9848 10.8313C11.7818 10.453 11.3828 10.1956 10.9233 10.1956C10.2584 10.1956 9.7193 10.7346 9.7193 11.3996C9.7193 11.6187 9.77883 11.8234 9.88102 12.0002H7.30482C7.30482 12.7982 7.99983 13.445 8.79774 13.445H8.74965C8.74965 14.0995 9.18497 14.6522 9.78183 14.8297L8.60916 16.0025L9.71593 17.1092L11.2859 15.5392C11.3474 15.5618 11.411 15.5798 11.4768 15.5922L10.5281 17.7341C10.9827 17.919 11.4796 18.0216 12.0006 18.0216C12.5215 18.0216 13.0184 17.919 13.473 17.7341L12.5243 15.5922C12.5901 15.5798 12.6537 15.5618 12.7151 15.5392L14.2851 17.1092L15.3918 16.0025L14.2191 14.8297C14.8159 14.6521 15.2513 14.0996 15.2513 13.4451H15.2032C16.0012 13.445 16.6962 12.7982 16.6962 12.0002Z"
        fill="#FFDA44"
      />
      <path d="M12.0005 12.7828L10.3048 13.5654V15.1306L12.0005 16.1741L13.6961 15.1306V13.5654L12.0005 12.7828Z" fill="#6DA544" />
      <path d="M13.6961 11.9992H10.3048V14.0861H13.6961V11.9992Z" fill="#0052B4" />
    </g>
    <defs>
      <clipPath id="clip0_5_2588">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2477)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M7.82626 11.9995V23.2531C9.12619 23.7355 10.5323 23.9995 12.0001 23.9995C18.6275 23.9995 24.0001 18.6268 24.0001 11.9995C24.0001 5.37208 7.82626 11.9995 7.82626 11.9995Z"
        fill="#6DA544"
      />
      <path
        d="M12.0001 0.000366211C10.5323 0.000366211 9.12619 0.264413 7.82626 0.746757V12.0004C7.82626 12.0004 18.4697 12.0004 24.0001 12.0004C24.0001 5.37299 18.6275 0.000366211 12.0001 0.000366211Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2477">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 9.98611 23.5031 8.08847 22.6265 6.42188L11.9859 12.0141L17.5781 1.37353C15.9115 0.496875 14.0139 0 12 0C5.37262 0 0 5.37262 0 12C0 15.3137 1.34316 18.3137 3.51469 20.4853C5.68627 22.6569 8.68627 24 12 24Z"
      fill="#0052B4"
    />
    <path
      d="M22.6141 6.43437C22.0648 5.38887 21.3507 4.40726 20.4716 3.52817C19.5924 2.64907 18.611 1.93493 17.5654 1.3857L3.50094 20.4987L22.6141 6.43437Z"
      fill="#F0F0F0"
    />
    <path d="M3.50094 20.4994L22.6141 6.43498C22.0648 5.38948 21.3507 4.40787 20.4716 3.52878L3.50094 20.4994Z" fill="#FF9811" />
    <path
      d="M10.4204 7.03689L8.95493 7.72624L9.73535 9.14561L8.14394 8.84116L7.94229 10.4488L6.83379 9.26636L5.72529 10.4488L5.52372 8.84116L3.93232 9.14552L4.71265 7.72619L3.24715 7.03689L4.71269 6.3475L3.93232 4.92822L5.52363 5.23258L5.72533 3.62495L6.83379 4.80738L7.94229 3.62495L8.14394 5.23258L9.7354 4.92822L8.95497 6.34755L10.4204 7.03689Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const MK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
    <path d="M13.8251 23.8624C15.7768 23.5646 17.5733 22.796 19.0965 21.6771L12.0001 12.0003L13.8251 23.8624Z" fill="#D80027" />
    <path d="M10.1754 0.137695C8.22373 0.435445 6.4272 1.20401 4.90395 2.32287L12.0004 11.9997L10.1754 0.137695Z" fill="#D80027" />
    <path d="M4.90395 21.6771C6.4271 22.796 8.22363 23.5646 10.1753 23.8624L12.0004 12.0003L4.90395 21.6771Z" fill="#D80027" />
    <path d="M2.32346 4.90234C1.20456 6.42559 0.436087 8.22208 0.13829 10.1738L12.0003 11.9988L2.32346 4.90234Z" fill="#D80027" />
    <path d="M0.13829 13.8252C0.43604 15.7769 1.2046 17.5735 2.32351 19.0966L12.0003 12.0003L0.13829 13.8252Z" fill="#D80027" />
    <path d="M23.8622 10.174C23.5644 8.22233 22.7959 6.42579 21.677 4.90259L12.0001 11.999L23.8622 10.174Z" fill="#D80027" />
    <path d="M19.0965 2.32282C17.5732 1.20396 15.7768 0.435445 13.8251 0.137695L12.0001 11.9997L19.0965 2.32282Z" fill="#D80027" />
    <path d="M21.6771 19.0967C22.7959 17.5735 23.5644 15.7769 23.8623 13.8253L12.0001 12.0003L21.6771 19.0967Z" fill="#D80027" />
    <path
      d="M12.0002 16.1743C14.3054 16.1743 16.1741 14.3056 16.1741 12.0004C16.1741 9.69525 14.3054 7.82654 12.0002 7.82654C9.69505 7.82654 7.82634 9.69525 7.82634 12.0004C7.82634 14.3056 9.69505 16.1743 12.0002 16.1743Z"
      fill="#D80027"
    />
    <path
      d="M12.0001 15.1297C13.729 15.1297 15.1306 13.7281 15.1306 11.9992C15.1306 10.2703 13.729 8.86877 12.0001 8.86877C10.2712 8.86877 8.86966 10.2703 8.86966 11.9992C8.86966 13.7281 10.2712 15.1297 12.0001 15.1297Z"
      fill="#FFDA44"
    />
  </svg>
));
export const ML: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2505)">
      <path
        d="M16.1742 0.745902C14.8742 0.263559 13.4681 -0.000488281 12.0003 -0.000488281C10.5325 -0.000488281 9.12639 0.263559 7.82641 0.745902L6.78292 11.9995L7.82641 23.2531C9.12639 23.7355 10.5325 23.9995 12.0003 23.9995C13.4681 23.9995 14.8742 23.7355 16.1742 23.2531L17.2177 11.9995L16.1742 0.745902Z"
        fill="#FFDA44"
      />
      <path
        d="M23.9996 12.0002C23.9996 6.84067 20.7431 2.44211 16.1735 0.746643V23.2539C20.7431 21.5583 23.9996 17.1598 23.9996 12.0002Z"
        fill="#D80027"
      />
      <path
        d="M0.000144958 11.9994C0.000144958 17.159 3.25664 21.5575 7.82625 23.2531V0.74585C3.25664 2.44132 0.000144958 6.83988 0.000144958 11.9994Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2505">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2624)">
      <path
        d="M23.2534 16.1744C23.7358 14.8744 23.9998 13.4683 23.9998 12.0005C23.9998 10.5326 23.7358 9.1265 23.2534 7.82657L11.9998 6.78308L0.746208 7.82657C0.263864 9.1265 -0.000183105 10.5326 -0.000183105 12.0005C-0.000183105 13.4683 0.263864 14.8744 0.746208 16.1744L11.9998 17.2178L23.2534 16.1744Z"
        fill="#6DA544"
      />
      <path
        d="M23.2535 7.82605C21.558 3.25644 17.1595 -6.10352e-05 11.9999 -6.10352e-05C6.84034 -6.10352e-05 2.44182 3.25644 0.746307 7.82605H23.2535Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 23.9991C17.1595 23.9991 21.558 20.7426 23.2535 16.173H0.746269C2.44178 20.7426 6.8403 23.9991 11.9999 23.9991Z"
        fill="#D80027"
      />
      <path
        d="M20.2292 10.153H13.9429L12.0003 4.17438L10.0577 10.153H3.77147L8.85717 13.8479L6.91458 19.8266L12.0003 16.1744L17.0861 19.8265L15.1435 13.8479L20.2292 10.153Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2624">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2574)">
      <path
        d="M11.9996 24.0006C13.4675 24.0006 14.8736 23.7366 16.1735 23.2542L16.6953 12.0006L16.1736 0.74697C14.8736 0.264627 13.4675 0.000579834 11.9996 0.000579834C10.5318 0.000579834 9.12569 0.264627 7.82575 0.74697L7.30399 12.0006L7.8257 23.2542C9.12569 23.7366 10.5318 24.0006 11.9996 24.0006Z"
        fill="#0052B4"
      />
      <path
        d="M-0.000213623 12C-0.000213623 17.1596 3.25629 21.5581 7.8259 23.2536V0.746429C3.25629 2.44195 -0.000213623 6.84046 -0.000213623 12Z"
        fill="#A2001D"
      />
      <path
        d="M16.1736 0.745972V23.2532C20.7432 21.5577 23.9997 17.1592 23.9997 11.9996C23.9997 6.84 20.7432 2.44149 16.1736 0.745972Z"
        fill="#A2001D"
      />
      <path d="M6.78254 11.9989H5.73906V16.1728H6.78254V11.9989Z" fill="#FFDA44" />
      <path d="M2.60865 11.9989H1.56516V16.1728H2.60865V11.9989Z" fill="#FFDA44" />
      <path
        d="M4.17363 14.6085C4.74993 14.6085 5.21711 14.1413 5.21711 13.565C5.21711 12.9887 4.74993 12.5215 4.17363 12.5215C3.59733 12.5215 3.13014 12.9887 3.13014 13.565C3.13014 14.1413 3.59733 14.6085 4.17363 14.6085Z"
        fill="#FFDA44"
      />
      <path
        d="M4.17378 10.4336C4.46192 10.4336 4.6955 10.2001 4.6955 9.91192C4.6955 9.62378 4.46192 9.3902 4.17378 9.3902C3.88564 9.3902 3.65206 9.62378 3.65206 9.91192C3.65206 10.2001 3.88564 10.4336 4.17378 10.4336Z"
        fill="#FFDA44"
      />
      <path d="M5.21721 15.1289H3.13024V16.1724H5.21721V15.1289Z" fill="#FFDA44" />
      <path d="M5.21721 10.9551H3.13024V11.9986H5.21721V10.9551Z" fill="#FFDA44" />
      <path
        d="M4.1743 6.26004L4.54387 7.39723H5.73955L4.77229 8.10007L5.14157 9.23726L4.1743 8.53442L3.20708 9.23726L3.57637 8.10007L2.6091 7.39723H3.80479L4.1743 6.26004Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2574">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D" />
    <path
      d="M14.0868 11.5003C13.7923 11.5003 13.5126 11.559 13.2529 11.6525C13.3952 11.3354 13.4906 10.9826 13.4906 10.6059C13.4906 9.11521 11.9999 7.99719 11.9999 7.99719C11.9999 7.99719 10.5093 9.11521 10.5093 10.6059C10.5093 10.9826 10.6046 11.3354 10.7469 11.6525C10.4872 11.5591 10.2075 11.5003 9.913 11.5003C8.42233 11.5003 7.30432 12.9909 7.30432 12.9909C7.30432 12.9909 8.42233 14.4816 9.913 14.4816C10.787 14.4816 11.5324 13.9694 12 13.5454C12.4676 13.9693 13.213 14.4816 14.0869 14.4816C15.5776 14.4816 16.6956 12.9909 16.6956 12.9909C16.6956 12.9909 15.5775 11.5003 14.0868 11.5003Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.0006 4.69458L12.3085 5.64221H13.3049L12.4989 6.22796L12.8066 7.17558L12.0006 6.58983L11.1946 7.17558L11.5023 6.22796L10.6962 5.64221H11.6927L12.0006 4.69458Z"
      fill="#FFDA44"
    />
    <path
      d="M8.21112 6.35156L8.80353 6.88491L9.49385 6.48637L9.16967 7.21458L9.76203 7.74802L8.96928 7.66467L8.64509 8.39288L8.47925 7.6132L7.68654 7.52986L8.37682 7.13123L8.21112 6.35156Z"
      fill="#FFDA44"
    />
    <path
      d="M5.43764 9.12594L6.21736 9.29164L6.61593 8.60132L6.69928 9.39402L7.4789 9.55986L6.75075 9.8841L6.83409 10.6768L6.30061 10.0845L5.57245 10.4087L5.97103 9.7183L5.43764 9.12594Z"
      fill="#FFDA44"
    />
    <path
      d="M15.7896 6.35156L15.1973 6.88491L14.5069 6.48637L14.8311 7.21458L14.2388 7.74802L15.0315 7.66467L15.3557 8.39288L15.5216 7.6132L16.3143 7.52986L15.624 7.13123L15.7896 6.35156Z"
      fill="#FFDA44"
    />
    <path
      d="M18.5632 9.12594L17.7835 9.29164L17.3849 8.60132L17.3015 9.39402L16.5219 9.55986L17.2501 9.8841L17.1667 10.6768L17.7002 10.0845L18.4284 10.4087L18.0298 9.7183L18.5632 9.12594Z"
      fill="#FFDA44"
    />
    <path
      d="M11.9997 18.6554C13.1839 18.6554 14.2753 18.2604 15.1508 17.5956H8.84871C9.72424 18.2603 10.8156 18.6554 11.9997 18.6554Z"
      fill="#F0F0F0"
    />
    <path
      d="M7.21722 15.5244C7.38283 15.9034 7.59283 16.2584 7.83949 16.5842H16.1606C16.4073 16.2584 16.6173 15.9034 16.7829 15.5244H7.21722Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const MP: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3" />
    <path
      d="M11.6213 19.5561C11.2978 19.5405 11.0302 19.3302 10.9253 19.0448C10.7401 19.2864 10.4218 19.408 10.1083 19.3271C9.79415 19.2462 9.57454 18.9864 9.52912 18.6848C9.29849 18.8841 8.96249 18.9383 8.67192 18.796C8.38078 18.653 8.21803 18.354 8.23471 18.0498C7.96917 18.199 7.62899 18.1844 7.37282 17.9861C7.11717 17.7879 7.01751 17.4628 7.09471 17.168C6.8046 17.2609 6.47488 17.1785 6.26357 16.9327C6.05226 16.6875 6.01987 16.3489 6.15454 16.076C5.85192 16.1083 5.54517 15.9612 5.38757 15.6785C5.22946 15.3957 5.26603 15.0571 5.45329 14.8165C5.15015 14.7873 4.87884 14.5812 4.78181 14.2723C4.68426 13.9635 4.7886 13.639 5.02078 13.4412C4.72963 13.3514 4.50632 13.0947 4.47346 12.7728C4.4406 12.451 4.60757 12.1551 4.87415 12.008C4.60753 11.8619 4.43953 11.5661 4.47135 11.2447C4.47135 11.2447 4.47135 11.2447 4.47187 11.2447C4.5037 10.9222 4.72701 10.6651 5.01759 10.5742C4.78542 10.377 4.68004 10.053 4.77656 9.74411C4.87307 9.43474 5.14382 9.22811 5.44701 9.19783C5.2597 8.95783 5.22215 8.61916 5.37918 8.33594C5.53621 8.05315 5.84301 7.90549 6.14615 7.93732C6.01049 7.66446 6.04232 7.32583 6.25312 7.0796C6.4634 6.83388 6.79312 6.75091 7.08374 6.84274C7.00546 6.54846 7.1046 6.22291 7.36026 6.02416C7.6154 5.82532 7.95557 5.81018 8.22112 5.95835C8.20392 5.65422 8.36615 5.35521 8.65678 5.21172C8.94688 5.06875 9.2834 5.122 9.51449 5.32127C9.55884 5.01977 9.77849 4.75891 10.092 4.67744C10.4051 4.59607 10.7234 4.71658 10.9091 4.95761C11.0139 4.67224 11.2811 4.46144 11.6046 4.44527C11.9275 4.42863 12.2144 4.61013 12.348 4.88308C12.5077 4.62429 12.8114 4.47091 13.1312 4.51943C13.4515 4.56743 13.6973 4.80321 13.7735 5.09805C13.9822 4.87572 14.3108 4.7876 14.6145 4.89921C14.9187 5.01138 15.1117 5.29207 15.1263 5.59675C15.3752 5.42149 15.7154 5.4011 15.9903 5.57224C16.2653 5.74286 16.3973 6.05641 16.3503 6.35744C16.6295 6.2359 16.9665 6.28441 17.2013 6.50664C17.4361 6.72944 17.5028 7.06282 17.3964 7.34819C17.6943 7.28505 18.0147 7.39985 18.2004 7.66539C18.3862 7.93043 18.3846 8.2706 18.2234 8.52888C18.5276 8.52677 18.8182 8.70419 18.9471 9.00105C19.0754 9.29843 19.0049 9.63185 18.7947 9.85254C19.0937 9.91202 19.3425 10.1442 19.4083 10.4614C19.4735 10.7786 19.3373 11.0901 19.0874 11.2638C19.3671 11.3823 19.5643 11.6593 19.5648 11.9828C19.5648 11.9864 19.5648 11.9896 19.5648 11.9933C19.5648 11.9954 19.5648 11.998 19.5648 12.0001C19.5648 12.3235 19.3686 12.6011 19.0889 12.7206C19.3394 12.8933 19.4766 13.2048 19.4114 13.522C19.3467 13.8392 19.0984 14.0719 18.7994 14.1324C19.0102 14.3526 19.0817 14.6854 18.9539 14.9834C18.826 15.2808 18.5354 15.4587 18.2307 15.4571C18.3924 15.7154 18.3951 16.0556 18.2099 16.3211C18.0246 16.5867 17.7048 16.7025 17.4069 16.6399C17.5139 16.9248 17.4476 17.2587 17.2133 17.482C16.9785 17.7048 16.642 17.7538 16.3629 17.6333C16.4104 17.9338 16.2789 18.2479 16.0044 18.4196C15.73 18.5913 15.3898 18.5714 15.1404 18.3966C15.1263 18.7013 14.9343 18.9826 14.6307 19.0953C14.6307 19.0953 14.6307 19.0953 14.6302 19.0953C14.3265 19.2074 13.9979 19.1198 13.7887 18.8981C13.7135 19.1934 13.4683 19.4297 13.148 19.4788C12.8281 19.5273 12.524 19.375 12.3638 19.1162C12.2365 19.3786 11.9673 19.557 11.6605 19.557C11.6474 19.5572 11.6344 19.5567 11.6213 19.5561Z"
      fill="#F3F3F3"
    />
    <path
      d="M12.0003 17.2183C14.8818 17.2183 17.2177 14.8824 17.2177 12.0009C17.2177 9.11944 14.8818 6.78354 12.0003 6.78354C9.11883 6.78354 6.78293 9.11944 6.78293 12.0009C6.78293 14.8824 9.11883 17.2183 12.0003 17.2183Z"
      fill="#338AF3"
    />
    <path
      d="M13.1418 10.2289C13.3981 10.0388 13.565 9.73489 13.565 9.39121V8.86949C13.565 8.29316 13.0979 7.826 12.5215 7.826H11.4781C10.9018 7.826 10.4346 8.29316 10.4346 8.86949V9.39121C10.4346 9.73489 10.6015 10.0388 10.8578 10.2289L9.91289 19.826C9.91289 19.826 10.4346 20.3478 11.9999 20.3478C13.5651 20.3478 14.0868 19.826 14.0868 19.826L13.1418 10.2289Z"
      fill="#BDBCC1"
    />
    <path
      d="M12.0001 7.826L12.9066 10.6159H15.8403L13.467 12.3403L14.3734 15.1303L12.0001 13.4061L9.62677 15.1303L10.5334 12.3403L8.16005 10.6159H11.0936L12.0001 7.826Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const MQ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M23.8969 10.4354C23.5659 7.90477 22.4291 5.45949 20.485 3.51535C18.5409 1.57121 16.0955 0.43444 13.5649 0.103409L13.565 10.4354H23.8969Z"
      fill="#0052B4"
    />
    <path
      d="M10.4347 0.10405C7.90406 0.435081 5.45873 1.5718 3.51459 3.51594C1.5705 5.46013 0.433731 7.90546 0.102699 10.4361L10.4347 10.436L10.4347 0.10405Z"
      fill="#0052B4"
    />
    <path
      d="M0.103004 13.5664C0.434036 16.097 1.5708 18.5424 3.5149 20.4865C5.45904 22.4306 7.90432 23.5673 10.435 23.8984L10.435 13.5665L0.103004 13.5664Z"
      fill="#0052B4"
    />
    <path
      d="M13.5649 23.8983C16.0955 23.5673 18.5408 22.4306 20.485 20.4864C22.4291 18.5423 23.5658 16.097 23.8968 13.5664H13.5649V23.8983Z"
      fill="#0052B4"
    />
    <path
      d="M16.0964 7.61471C16.0964 7.45515 16.2261 7.32545 16.3857 7.32545H17.0056C17.9855 7.32545 18.7827 6.52829 18.7827 5.54846C18.7827 4.56863 17.9855 3.77143 17.0056 3.77143H16.4169C16.2248 3.6271 15.967 3.53809 15.6827 3.53809C15.0896 3.53809 14.6088 3.9227 14.6088 4.39716C14.6088 4.86704 15.0804 5.24823 15.6656 5.25563L15.6653 5.25906H17.0056C17.1652 5.25906 17.2949 5.38881 17.2949 5.54837C17.2949 5.70793 17.1652 5.83763 17.0056 5.83763H16.3857C15.4058 5.83763 14.6087 6.63479 14.6087 7.61462C14.6087 8.59445 15.4058 9.39165 16.3857 9.39165H18.7826V7.90393H16.3857C16.2261 7.90398 16.0964 7.77428 16.0964 7.61471Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.70493 7.61484C6.70493 7.45527 6.83464 7.32557 6.99425 7.32557H7.61412C8.594 7.32557 9.3912 6.52841 9.3912 5.54858C9.3912 4.56876 8.59404 3.77155 7.61412 3.77155H7.02546C6.83332 3.62722 6.57556 3.53821 6.29121 3.53821C5.69811 3.53821 5.21731 3.92282 5.21731 4.39729C5.21731 4.86716 5.68892 5.24835 6.2741 5.25576L6.27382 5.25918H7.61417C7.77378 5.25918 7.90348 5.38893 7.90348 5.54849C7.90348 5.70805 7.77378 5.83776 7.61417 5.83776H6.99429C6.01442 5.83776 5.21731 6.63491 5.21731 7.61474C5.21731 8.59457 6.01437 9.39177 6.99429 9.39177H9.39115V7.90406H6.99425C6.83464 7.9041 6.70493 7.7744 6.70493 7.61484Z"
      fill="#F0F0F0"
    />
    <path
      d="M16.0964 18.6859C16.0964 18.5264 16.2262 18.3967 16.3858 18.3967H17.0056C17.9855 18.3967 18.7827 17.5995 18.7827 16.6197C18.7827 15.6398 17.9856 14.8426 17.0056 14.8426H16.417C16.2248 14.6983 15.9671 14.6093 15.6827 14.6093C15.0896 14.6093 14.6088 14.994 14.6088 15.4684C14.6088 15.9383 15.0804 16.3194 15.6656 16.3268L15.6653 16.3303H17.0056C17.1652 16.3303 17.2949 16.46 17.2949 16.6196C17.2949 16.7791 17.1652 16.9088 17.0056 16.9088H16.3857C15.4058 16.9088 14.6087 17.706 14.6087 18.6858C14.6087 19.6657 15.4058 20.4629 16.3857 20.4629H18.7827V18.9752H16.3858C16.2262 18.9752 16.0964 18.8454 16.0964 18.6859Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.70486 18.6859C6.70486 18.5264 6.83457 18.3967 6.99418 18.3967H7.61405C8.59393 18.3967 9.39113 17.5995 9.39113 16.6197C9.39113 15.6398 8.59397 14.8426 7.61405 14.8426H7.0254C6.83326 14.6983 6.57549 14.6093 6.29115 14.6093C5.69799 14.6093 5.21719 14.994 5.21719 15.4684C5.21719 15.9383 5.6888 16.3194 6.27399 16.3268L6.27371 16.3303H7.61405C7.77366 16.3303 7.90336 16.46 7.90336 16.6196C7.90336 16.7791 7.77366 16.9088 7.61405 16.9088H6.99418C6.0143 16.9088 5.21719 17.706 5.21719 18.6858C5.21719 19.6657 6.01426 20.4629 6.99418 20.4629H9.39108V18.9752H6.99418C6.83457 18.9752 6.70486 18.8454 6.70486 18.6859Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const MR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D" />
    <path
      d="M11.9997 13.8637C10.0016 13.8637 8.33234 12.4594 7.92279 10.5842C7.85988 10.8725 7.82576 11.1714 7.82576 11.4786C7.82576 13.7839 9.69443 15.6525 11.9997 15.6525C14.3049 15.6525 16.1735 13.7838 16.1735 11.4786C16.1735 11.1714 16.1394 10.8725 16.0765 10.5841C15.667 12.4595 13.9977 13.8637 11.9997 13.8637Z"
      fill="#FFDA44"
    />
    <path
      d="M11.9998 8.3478L12.3883 9.54354H13.6457L12.6285 10.2825L13.017 11.4783L11.9998 10.7392L10.9827 11.4783L11.3713 10.2825L10.3541 9.54354H11.6113L11.9998 8.3478Z"
      fill="#FFDA44"
    />
  </svg>
));
export const MS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
    <path
      d="M11.9684 11.9998H12.0005C12.0005 11.989 12.0005 11.9784 12.0005 11.9676C11.9898 11.9783 11.9791 11.9891 11.9684 11.9998Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.0004 6.26126C12.0004 4.14977 12.0004 2.76626 12.0004 0.000396729H11.9984C5.3719 0.00152173 0.000450134 5.37363 0.000450134 12.0004H6.26131V8.47488L9.78682 12.0004H11.9684C11.9791 11.9897 11.9898 11.979 12.0005 11.9683C12.0005 11.1598 12.0005 10.4385 12.0005 9.78687L8.47488 6.26126H12.0004Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.07124 1.56546C4.19441 2.63416 2.63409 4.19444 1.56543 6.07127V12.0003H4.69588V4.69601V4.69591H12.0002C12.0002 3.70859 12.0002 2.76799 12.0002 1.56546H6.07124Z"
      fill="#D80027"
    />
    <path
      d="M12.0005 10.5243L7.73695 6.26083H6.26133V6.26093L12.0004 11.9999H12.0005C12.0005 11.9999 12.0005 10.9824 12.0005 10.5243Z"
      fill="#D80027"
    />
    <path
      d="M13.565 6.2605V11.9996C13.565 14.7952 17.2172 15.6518 17.2172 15.6518C17.2172 15.6518 20.8694 14.7952 20.8694 11.9996V6.2605H13.565Z"
      fill="#338AF3"
    />
    <path d="M13.565 11.9992C13.565 14.7948 17.2172 15.6514 17.2172 15.6514C17.2172 15.6514 20.8694 14.7948 20.8694 11.9992H13.565Z" fill="#A2001D" />
    <path d="M18.7824 8.86912H17.7388V7.82559H16.6953V8.86912H15.6519V9.91256H16.6953V13.043H17.7388V9.91256H18.7824V8.86912Z" fill="black" />
  </svg>
));
export const MT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2510)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.9998 -0.00050354C18.6272 -0.00050354 23.9998 5.37212 23.9998 11.9995C23.9998 18.6269 18.6272 23.9995 11.9998 23.9995"
        fill="#D80027"
      />
      <path d="M8.34753 4.69623V3.13103H6.78233V4.69623H5.21708V6.26143H6.78233V7.82668H8.34753V6.26143H9.91273V4.69623H8.34753Z" fill="#ACABB1" />
    </g>
    <defs>
      <clipPath id="clip0_5_2510">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2540)">
      <path
        d="M1.45866 6.26036L11.9996 7.30385L22.5405 6.26036C20.5052 2.53024 16.5481 -0.000497818 11.9996 -0.000497818C7.45107 -0.000497818 3.49393 2.53024 1.45866 6.26036Z"
        fill="#D80027"
      />
      <path
        d="M1.45878 17.7384L11.9997 18.7819L22.5406 17.7384C23.4708 16.0335 23.9997 14.0782 23.9997 11.9993L11.9997 10.9558L-0.000297546 11.9993C-0.000297546 14.0782 0.528593 16.0335 1.45878 17.7384Z"
        fill="#FFDA44"
      />
      <path
        d="M1.45878 6.26097C0.528593 7.96587 -0.000297546 9.92121 -0.000297546 12.0001H23.9997C23.9997 9.92121 23.4708 7.96587 22.5406 6.26097H11.9997H1.45878Z"
        fill="#0052B4"
      />
      <path
        d="M11.9996 23.9996C16.5481 23.9996 20.5052 21.4688 22.5405 17.7387H1.45866C3.49393 21.4688 7.45107 23.9996 11.9996 23.9996Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2540">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MV: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path d="M19.826 6.26099H4.1738V17.7393H19.826V6.26099Z" fill="#6DA544" />
    <path
      d="M13.9322 15.3913C12.0593 15.3913 10.5409 13.8729 10.5409 12C10.5409 10.127 12.0593 8.60867 13.9322 8.60867C14.5162 8.60867 15.0657 8.75633 15.5454 9.0163C14.7929 8.28032 13.7637 7.82605 12.6279 7.82605C10.3228 7.82605 8.454 9.69477 8.454 11.9999C8.454 14.3051 10.3228 16.1738 12.6279 16.1738C13.7637 16.1738 14.7929 15.7196 15.5454 14.9836C15.0657 15.2436 14.5162 15.3913 13.9322 15.3913Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const MW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2482)">
      <path
        d="M-6.86646e-05 11.9998C-6.86646e-05 13.4676 0.263978 14.8737 0.746322 16.1737L11.9999 16.6954L23.2535 16.1737C23.7359 14.8737 23.9999 13.4676 23.9999 11.9998C23.9999 10.5319 23.7359 9.12589 23.2535 7.8259L11.9999 7.30414L0.746322 7.82586C0.263978 9.12589 -6.86646e-05 10.5319 -6.86646e-05 11.9998Z"
        fill="#D80027"
      />
      <path
        d="M11.9999 -0.000366211C6.84029 -0.000366211 2.44177 3.25613 0.746258 7.82574H23.2535C21.558 3.25613 17.1594 -0.000366211 11.9999 -0.000366211Z"
        fill="black"
      />
      <path
        d="M23.2534 16.1747H0.746185C2.4417 20.7442 6.84022 24.0008 11.9998 24.0008C17.1594 24.0008 21.5579 20.7442 23.2534 16.1747Z"
        fill="#496E2D"
      />
      <path
        d="M15.5865 5.73994L14.121 5.0506L14.9014 3.63127L13.31 3.93572L13.1083 2.328L11.9998 3.51042L10.8914 2.328L10.6897 3.93572L9.09829 3.63127L9.87872 5.0506L8.41317 5.73994H15.5865Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2482">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MX: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2546)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.9999 11.9997C23.9999 7.24218 21.2312 3.13143 17.2172 1.19043V22.8089C21.2312 20.868 23.9999 16.7572 23.9999 11.9997Z"
        fill="#D80027"
      />
      <path
        d="M-6.86646e-05 11.9997C-6.86646e-05 16.7572 2.7686 20.868 6.78256 22.809V1.19043C2.7686 3.13143 -6.86646e-05 7.24217 -6.86646e-05 11.9997Z"
        fill="#6DA544"
      />
      <path
        d="M8.86958 11.9993C8.86958 13.7281 10.2711 15.1297 12 15.1297C13.7289 15.1297 15.1305 13.7281 15.1305 11.9993V10.9558H8.86958V11.9993Z"
        fill="#6DA544"
      />
      <path
        d="M16.1735 9.91338H13.043C13.043 9.3371 12.5758 8.8699 11.9995 8.8699C11.4233 8.8699 10.9561 9.3371 10.9561 9.91338H7.82561C7.82561 10.4897 8.32759 10.9569 8.90383 10.9569H8.86909C8.86909 11.5332 9.33625 12.0003 9.91258 12.0003C9.91258 12.5767 10.3797 13.0438 10.9561 13.0438H13.043C13.6194 13.0438 14.0865 12.5767 14.0865 12.0003C14.6628 12.0003 15.13 11.5332 15.13 10.9569H15.0952C15.6716 10.9569 16.1735 10.4897 16.1735 9.91338Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2546">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2488)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M11.4784 12.0002H24.0001C24.0001 10.9171 23.8557 9.86791 23.5867 8.86975H11.4784V12.0002Z" fill="#D80027" />
      <path d="M11.4784 5.73873H22.2388C21.5042 4.54004 20.5651 3.48053 19.4699 2.60828H11.4784V5.73873Z" fill="#D80027" />
      <path
        d="M12.0002 24.0002C14.8244 24.0002 17.4202 23.024 19.47 21.3915H4.53033C6.58022 23.024 9.17601 24.0002 12.0002 24.0002Z"
        fill="#D80027"
      />
      <path
        d="M1.76148 18.2601H22.2389C22.8286 17.2978 23.286 16.2459 23.5868 15.1296H0.413589C0.714386 16.2459 1.17175 17.2978 1.76148 18.2601Z"
        fill="#D80027"
      />
      <path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4" />
      <path
        d="M7.98006 10.2709C6.34122 10.2709 5.01268 8.94229 5.01268 7.30349C5.01268 5.6647 6.34126 4.33612 7.98006 4.33612C8.49105 4.33612 8.97184 4.46535 9.39161 4.69279C8.73311 4.04887 7.83255 3.65137 6.83875 3.65137C4.82176 3.65137 3.18657 5.28651 3.18657 7.30354C3.18657 9.32057 4.82176 10.9557 6.83875 10.9557C7.83255 10.9557 8.73311 10.5582 9.39161 9.91429C8.97184 10.1416 8.49109 10.2709 7.98006 10.2709Z"
        fill="#FFDA44"
      />
      <path
        d="M8.81666 5.21729L9.34348 6.31894L10.5332 6.04407L10.0004 7.14277L10.9572 7.90153L9.76597 8.17008L9.7693 9.39122L8.81666 8.62725L7.86397 9.39122L7.86725 8.17008L6.67597 7.90153L7.63278 7.14277L7.09995 6.04407L8.28978 6.31894L8.81666 5.21729Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2488">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const MZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2614)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M6.48567 16.696L3.51464 20.4852C5.68608 22.6569 8.68575 24.0003 11.9995 24.0003C16.9603 24.0003 21.2172 20.9896 23.0447 16.696H6.48567Z"
        fill="#FFDA44"
      />
      <path
        d="M23.0634 7.34838C21.2461 3.03161 16.9771 0.000579834 11.9995 0.000579834C8.68575 0.000579834 5.68608 1.34397 3.51464 3.51569L6.5198 7.34838H23.0634Z"
        fill="#496E2D"
      />
      <path
        d="M2.60862 8.82593V15.1302H23.5866C23.8557 14.1322 23.9999 13.083 23.9999 11.9998C23.9999 10.901 23.8519 9.83693 23.5752 8.82593H2.60862Z"
        fill="black"
      />
      <path
        d="M3.51431 3.51428C-1.17197 8.20056 -1.17197 15.7986 3.51431 20.4849C5.45086 18.5484 7.31334 16.6859 11.9996 11.9996L3.51431 3.51428Z"
        fill="#A2001D"
      />
      <path
        d="M4.85698 8.86945L5.63394 11.2608H8.14859L6.11431 12.7389L6.89122 15.1304L4.85698 13.6523L2.82265 15.1304L3.59975 12.7389L1.56547 11.2608H4.07994L4.85698 8.86945Z"
        fill="#FFDA44"
      />
      <path d="M7.13107 11.9992H2.58307V14.0862H7.13107V11.9992Z" fill="#F0F0F0" />
      <path
        d="M7.99217 9.60735L7.25431 8.86945L4.85675 11.267L2.45919 8.86945L1.72133 9.60735L4.121 12.0028L1.72133 14.4025L2.45919 15.1304L4.85675 12.7371L7.25431 15.1304L7.99217 14.4025L5.5925 12.0028L7.99217 9.60735Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2614">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M3.51452 20.4849C4.01791 20.9883 4.55501 21.4372 5.1184 21.8325L21.8326 5.11826C21.4374 4.55487 20.9884 4.01778 20.485 3.51439C19.9816 3.011 19.4445 2.56212 18.8811 2.16687L2.16701 18.8811C2.56221 19.4444 3.01113 19.9815 3.51452 20.4849Z"
      fill="#A2001D"
    />
    <path
      d="M3.51502 3.51478C-0.270792 7.30059 -0.997542 12.9862 1.33322 17.5022L17.5024 1.33307C12.9863 -0.997692 7.30074 -0.270848 3.51502 3.51478Z"
      fill="#0052B4"
    />
    <path
      d="M20.4858 20.4847C24.2715 16.699 24.9983 11.0134 22.6676 6.49731L6.49842 22.6665C11.0144 24.9972 16.7 24.2705 20.4858 20.4847Z"
      fill="#496E2D"
    />
    <path
      d="M9.91322 6.78182L8.56856 7.41431L9.28463 8.71659L7.82452 8.43731L7.63945 9.91223L6.62245 8.8274L5.60541 9.91223L5.42044 8.43731L3.96028 8.71654L4.6763 7.41426L3.33169 6.78182L4.67634 6.14929L3.96028 4.8471L5.42039 5.12638L5.60545 3.65137L6.62245 4.73624L7.6395 3.65137L7.82452 5.12638L9.28463 4.8471L8.56866 6.14934L9.91322 6.78182Z"
      fill="#FFDA44"
    />
  </svg>
));
export const NE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2685)">
      <path
        d="M1.19031 6.78207C0.427463 8.3597 -0.000411987 10.1296 -0.000411987 11.9994C-0.000411987 13.8693 0.427463 15.6392 1.19031 17.2168L11.9996 18.2603L22.8089 17.2168C23.5717 15.6392 23.9996 13.8693 23.9996 11.9994C23.9996 10.1296 23.5717 8.3597 22.8089 6.78207L11.9996 5.73859L1.19031 6.78207Z"
        fill="#F0F0F0"
      />
      <path d="M1.1909 17.2183C3.13181 21.2323 7.24223 24.001 11.9998 24.001C16.7573 24.001 20.8677 21.2323 22.8086 17.2183H1.1909Z" fill="#6DA544" />
      <path
        d="M1.1909 6.78238H22.8086C20.8677 2.76843 16.7572 -0.000244141 11.9998 -0.000244141C7.24228 -0.000244141 3.13181 2.76843 1.1909 6.78238Z"
        fill="#FF9811"
      />
      <path
        d="M12 16.1742C14.3052 16.1742 16.1739 14.3055 16.1739 12.0003C16.1739 9.69513 14.3052 7.82642 12 7.82642C9.6948 7.82642 7.82609 9.69513 7.82609 12.0003C7.82609 14.3055 9.6948 16.1742 12 16.1742Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2685">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NF: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2716)">
      <path
        d="M17.2169 1.19044C15.6393 0.4276 13.8695 -0.000274658 11.9996 -0.000274658C10.1297 -0.000274658 8.35982 0.4276 6.78219 1.19044L5.73871 11.9997L6.78219 22.809C8.35982 23.5718 10.1297 23.9997 11.9996 23.9997C13.8695 23.9997 15.6393 23.5718 17.2169 22.809L18.2604 11.9997L17.2169 1.19044Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.78255 1.19125C2.7686 3.13216 -7.62939e-05 7.24258 -7.62939e-05 12.0001C-7.62939e-05 16.7576 2.7686 20.8681 6.78255 22.809V1.19125Z"
        fill="#6DA544"
      />
      <path
        d="M17.2172 1.19125V22.809C21.2311 20.8681 23.9998 16.7576 23.9998 12.0001C23.9998 7.24263 21.2311 3.13216 17.2172 1.19125Z"
        fill="#6DA544"
      />
      <path d="M15.1305 15.6517L12 5.73862L8.86957 15.6517H11.2174V18.2603H12.7826V15.6517H15.1305Z" fill="#6DA544" />
    </g>
    <defs>
      <clipPath id="clip0_5_2716">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2692)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M-0.000411987 12.0002C-0.000411987 17.1598 3.25609 21.5583 7.8257 23.2539V0.746643C3.25609 2.44211 -0.000411987 6.84067 -0.000411987 12.0002Z"
        fill="#6DA544"
      />
      <path
        d="M23.9999 12.0002C23.9999 6.84067 20.7434 2.44211 16.1738 0.746643V23.2539C20.7434 21.5583 23.9999 17.1598 23.9999 12.0002Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2692">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2675)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0003 -0.000183105C7.24279 -0.000183105 3.13204 2.76849 1.19104 6.78244H22.8096C20.8686 2.76849 16.7578 -0.000183105 12.0003 -0.000183105Z"
        fill="#338AF3"
      />
      <path
        d="M12.0003 24.001C16.7578 24.001 20.8686 21.2323 22.8096 17.2184H1.19104C3.13204 21.2323 7.24279 24.001 12.0003 24.001Z"
        fill="#338AF3"
      />
      <path
        d="M12.0003 8.34772C9.98328 8.34772 8.34814 9.98286 8.34814 11.9999C8.34814 14.0169 9.98328 15.6521 12.0003 15.6521C14.0173 15.6521 15.6525 14.0169 15.6525 11.9999C15.6525 9.98286 14.0173 8.34772 12.0003 8.34772ZM12.0003 14.0869C10.8478 14.0869 9.91335 13.1525 9.91335 11.9999C9.91335 10.8472 10.8477 9.91292 12.0003 9.91292C13.1529 9.91292 14.0873 10.8472 14.0873 11.9999C14.0873 13.1525 13.1529 14.0869 12.0003 14.0869Z"
        fill="#FFDA44"
      />
      <path d="M13.8069 12.5222L11.9995 12.0005L10.1921 12.5222L9.58969 13.5657H14.4093L13.8069 12.5222Z" fill="#0052B4" />
      <path d="M11.9998 9.39136L10.7949 11.4783L11.9998 12L13.2047 11.4783L11.9998 9.39136Z" fill="#338AF3" />
      <path d="M10.1923 12.5211H13.8071L13.2046 11.4777H10.7948L10.1923 12.5211Z" fill="#6DA544" />
    </g>
    <defs>
      <clipPath id="clip0_5_2675">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2656)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0002 -0.000549316C6.8406 -0.000549316 2.44208 3.25595 0.746567 7.82556H23.2538C21.5583 3.25595 17.1598 -0.000549316 12.0002 -0.000549316Z"
        fill="#A2001D"
      />
      <path
        d="M12.0002 24.0004C17.1598 24.0004 21.5583 20.7439 23.2538 16.1743H0.746582C2.4421 20.7439 6.84061 24.0004 12.0002 24.0004Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2656">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2739)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M0.413361 15.131C1.10767 17.7072 2.63791 19.9401 4.69563 21.5211V15.131H0.413361Z" fill="#D80027" />
      <path
        d="M10.9563 23.9549C11.3003 23.9845 11.6481 24.0006 11.9998 24.0006C17.5441 24.0006 22.2094 20.2402 23.5864 15.131H10.9563V23.9549Z"
        fill="#D80027"
      />
      <path
        d="M23.5864 8.87005C22.2094 3.76086 17.5441 0.00050354 11.9998 0.00050354C11.6481 0.00050354 11.3003 0.0165348 10.9563 0.0461598V8.87005H23.5864Z"
        fill="#D80027"
      />
      <path d="M4.69563 2.48028C2.63791 4.06137 1.10767 6.29417 0.413361 8.87037H4.69563V2.48028Z" fill="#D80027" />
      <path
        d="M23.8984 10.4343H9.3913H9.39125V0.284744C8.28228 0.53065 7.23092 0.929229 6.2608 1.45859V10.4342V10.4343H0.101517C0.0347202 10.9467 -6.10352e-05 11.469 -6.10352e-05 11.9995C-6.10352e-05 12.53 0.0347202 13.0524 0.101517 13.5647H6.26075H6.2608V22.5404C7.23092 23.0697 8.28228 23.4684 9.39125 23.7142V13.5649V13.5648H23.8984C23.9651 13.0524 23.9999 12.53 23.9999 11.9995C23.9999 11.469 23.9651 10.9466 23.8984 10.4343Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2739">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NP: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2645)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M23.9299 13.3046L23.9296 13.3042L23.9296 13.3046H23.9299Z" fill="#0052B4" />
      <path
        d="M23.9292 13.3041C23.9292 13.3041 23.9292 13.304 23.9292 13.3038L10.7693 0.0621948C10.1756 0.12271 9.59472 0.226492 9.02983 0.370351C3.83894 1.69199 -3.05176e-05 11.9998 -3.05176e-05 11.9998C-3.05176e-05 11.9998 16.7999 23.2421 18.7165 21.945C19.0999 21.6855 19.4676 21.4044 19.8177 21.1034L12.0185 13.3041H23.9292Z"
        fill="#0052B4"
      />
      <path
        d="M20.8697 11.9995L9.19913 0.328979C3.92302 1.59071 0.000144958 6.33662 0.000144958 11.9995C0.000144958 18.6269 5.37277 23.9995 12.0001 23.9995C14.514 23.9995 16.8469 23.226 18.7749 21.9047L8.86969 11.9995H20.8697Z"
        fill="#D80027"
      />
      <path
        d="M11.4125 17.7175L9.94699 17.0281L10.7274 15.6088L9.13601 15.9133L8.93435 14.3055L7.8259 15.488L6.71745 14.3055L6.51574 15.9133L4.92438 15.6088L5.70481 17.0281L4.23921 17.7175L5.70481 18.4068L4.92438 19.8262L6.51584 19.5217L6.7174 21.1294L7.8259 19.9469L8.93435 21.1294L9.13601 19.5217L10.7274 19.8262L9.94695 18.4069L11.4125 17.7175Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.4342 6.65496L9.36831 6.15363L9.93592 5.12131L8.77844 5.34274L8.63177 4.1734L7.82556 5.03342L7.01936 4.1734L6.87264 5.34274L5.71516 5.12131L6.28281 6.15363L5.21683 6.65496L7.82556 7.17677L10.4342 6.65496Z"
        fill="#F0F0F0"
      />
      <path d="M10.9567 6.65533C10.9567 8.38422 9.55513 9.78578 7.82624 9.78578C6.09735 9.78578 4.69579 8.38422 4.69579 6.65533" fill="#F0F0F0" />
    </g>
    <defs>
      <clipPath id="clip0_5_2645">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2637)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#0052B4" />
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M12.0011 -0.000549316C5.72527 -0.000549316 0.575674 4.81731 0.0467834 10.956H23.9554C23.4265 4.81731 18.2769 -0.000549316 12.0011 -0.000549316Z"
        fill="#0052B4"
      />
      <path
        d="M11.9999 24.0001C18.2758 24.0001 23.4254 19.1822 23.9543 13.0436H0.0456467C0.574537 19.1822 5.72413 24.0001 11.9999 24.0001Z"
        fill="#0052B4"
      />
      <path
        d="M9.91324 16.1745L8.56859 16.8071L9.2846 18.1093L7.82449 17.83L7.63948 19.305L6.62243 18.2202L5.60543 19.305L5.42042 17.83L3.96026 18.1093L4.67632 16.807L3.33167 16.1745L4.67637 15.5421L3.96026 14.2399L5.42037 14.5191L5.60548 13.0441L6.62243 14.129L7.63953 13.0441L7.82449 14.5191L9.28465 14.2399L8.56863 15.5421L9.91324 16.1745Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2637">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2698)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#FFDA44" />
      <path d="M12.0003 5.7395V9.78683L7.82642 5.7395H12.0003Z" fill="#0052B4" />
      <path d="M6.26124 12.0002H9.78675L6.26124 7.30457L5.73952 10.9567L6.26124 12.0002Z" fill="#0052B4" />
      <path
        d="M11.9684 12.0007H12.0005C12.0005 11.9899 12.0005 11.9794 12.0005 11.9685C11.9898 11.9793 11.9791 11.99 11.9684 12.0007Z"
        fill="#F0F0F0"
      />
      <path
        d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9993 10.5247L7.73579 6.26123H6.26016V6.26132L11.9992 12.0003H11.9993C11.9993 12.0003 11.9993 10.9828 11.9993 10.5247Z"
        fill="#D80027"
      />
      <path
        d="M6.07061 1.56494C5.608 1.82838 5.1648 2.12196 4.7433 2.44244H5.23567L3.93433 3.3881L4.4313 4.91796L3.12995 3.97249L2.99148 4.07313C2.45116 4.68672 1.97209 5.35554 1.5648 6.07075V11.9997H4.69525V4.69549V4.69539H11.9996C11.9996 3.70807 11.9996 2.76747 11.9996 1.56494H6.07061Z"
        fill="#D80027"
      />
      <path
        d="M5.12592 2.16431C4.9965 2.25492 4.8689 2.34806 4.74323 2.44363L3.9344 3.38929L3.13003 3.97363L2.99039 4.07507C2.69573 4.40976 2.4194 4.76095 2.16299 5.12718C2.45526 5.26903 2.78334 5.34876 3.13003 5.34876C4.35468 5.34876 5.3474 4.35604 5.3474 3.13138C5.3475 2.7846 5.26781 2.45662 5.12592 2.16431Z"
        fill="#0052B4"
      />
      <path
        d="M2.99011 4.07382L3.12975 3.97238L4.4311 4.9179L3.93408 3.38804L5.23533 2.44238H4.74286C4.10564 2.92702 3.51844 3.47377 2.99011 4.07382Z"
        fill="#FFDA44"
      />
      <path
        d="M8.29422 2.0874L8.55325 2.88451H9.39138L8.71333 3.37721L8.97222 4.17432L8.29422 3.68167L7.61618 4.17432L7.87502 3.37721L7.19698 2.88451H8.03515L8.29422 2.0874Z"
        fill="#FFDA44"
      />
      <path
        d="M3.13009 7.30518L3.38912 8.10228H4.22725L3.54925 8.59504L3.80814 9.39215L3.13009 8.89944L2.452 9.39215L2.71089 8.59504L2.03289 8.10228H2.87102L3.13009 7.30518Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2698">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const NZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2661)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
      <path
        d="M11.9684 12.0006H12.0005C12.0005 11.9897 12.0005 11.9792 12.0005 11.9684C11.9898 11.9791 11.9791 11.9898 11.9684 12.0006Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0003 6.26092C12.0003 4.14944 12.0003 2.76592 12.0003 6.10352e-05H11.9983C5.37185 0.00118604 0.000350952 5.3733 0.000350952 12.0001H6.26121V8.47455L9.78677 12.0001H11.9683C11.979 11.9894 11.9897 11.9787 12.0004 11.968C12.0004 11.1595 12.0004 10.4381 12.0004 9.78653L8.47478 6.26092H12.0003Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.07113 1.565C4.1943 2.63371 2.63402 4.19399 1.56532 6.07082V11.9998H4.69577V4.69555V4.69546H12.0001C12.0001 3.70813 12.0001 2.76753 12.0001 1.565H6.07113Z"
        fill="#D80027"
      />
      <path
        d="M12.0004 10.5247L7.73697 6.26123C7.73697 6.26123 6.2613 6.26132 6.2613 6.26123V6.26132L12.0003 12.0003H12.0004C12.0004 12.0003 12.0004 10.9828 12.0004 10.5247Z"
        fill="#D80027"
      />
      <path
        d="M20.7811 8.90472L21.0401 9.70188H21.8782L21.2001 10.1945L21.4592 10.9916L20.7811 10.499L20.1029 10.9916L20.362 10.1945L19.6838 9.70188H20.522L20.7811 8.90472Z"
        fill="#D80027"
      />
      <path
        d="M17.7849 14.6436L18.1735 15.8393H19.4307L18.4135 16.5783L18.8021 17.774L17.7849 17.035L16.7677 17.774L17.1563 16.5783L16.1391 15.8393H17.3964L17.7849 14.6436Z"
        fill="#D80027"
      />
      <path
        d="M17.8985 5.25195L18.2223 6.24847H19.27L18.4223 6.86417L18.7461 7.86064L17.8985 7.24475L17.0509 7.86064L17.3746 6.86417L16.5271 6.24847H17.5747L17.8985 5.25195Z"
        fill="#D80027"
      />
      <path
        d="M15.0152 8.87L15.4037 10.0658H16.661L15.6438 10.8047L16.0324 12.0005L15.0152 11.2615L13.998 12.0005L14.3866 10.8047L13.3694 10.0658H14.6266L15.0152 8.87Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2661">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const OM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2748)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M9.15527e-05 12.0005C9.15527e-05 16.549 2.53087 20.5062 6.26095 22.5414V1.45958C2.53087 3.49479 9.15527e-05 7.45198 9.15527e-05 12.0005Z"
        fill="#D80027"
      />
      <path
        d="M23.2538 16.1751C23.7361 14.8752 24.0001 13.4691 24.0001 12.0013C24.0001 10.5334 23.7361 9.12731 23.2538 7.82737H0.746529C0.264139 9.12731 9.15527e-05 10.5334 9.15527e-05 12.0013C9.15527e-05 13.4691 0.264139 14.8752 0.746529 16.1751L12.0001 17.2186L23.2538 16.1751Z"
        fill="#D80027"
      />
      <path
        d="M12.0003 23.9997C17.1599 23.9997 21.5583 20.7432 23.2539 16.1736H0.746689C2.44216 20.7432 6.84072 23.9997 12.0003 23.9997Z"
        fill="#6DA544"
      />
      <path
        d="M0.000274658 11.9996C0.000274658 17.5439 3.76063 22.2092 8.86982 23.5862V0.413006C3.76063 1.79001 0.000274658 6.45529 0.000274658 11.9996Z"
        fill="#D80027"
      />
      <path
        d="M7.34156 5.28158L6.23479 4.17481L5.49698 4.91272L4.75917 4.17481L3.65241 5.28158L4.39027 6.01944L3.65231 6.75734L4.75908 7.86411L5.49694 7.1262L6.23479 7.86411L7.34156 6.75734L6.6037 6.01944L7.34156 5.28158Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2748">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M4.57764e-05 11.9998C4.57764e-05 18.6272 5.37267 23.9998 12 23.9998C12 19.4363 12 11.9998 12 11.9998C12 11.9998 4.17394 11.9998 4.57764e-05 11.9998Z"
      fill="#0052B4"
    />
    <path
      d="M11.9996 0.000823975C18.627 0.000823975 23.9996 5.37345 23.9996 12.0008C19.4361 12.0008 11.9996 12.0008 11.9996 12.0008C11.9996 12.0008 11.9996 4.17471 11.9996 0.000823975Z"
      fill="#D80027"
    />
    <path
      d="M7.14363 4.1748L7.92067 6.56627H10.4352L8.40091 8.04424L9.17791 10.4357L7.14363 8.9577L5.10935 10.4357L5.88635 8.04424L3.85207 6.56627H6.36658L7.14363 4.1748Z"
      fill="#0052B4"
    />
    <path
      d="M16.857 13.5647L17.6341 15.9562H20.1486L18.1143 17.4341L18.8913 19.8256L16.857 18.3476L14.8228 19.8256L15.5998 17.4341L13.5655 15.9562H16.08L16.857 13.5647Z"
      fill="#D80027"
    />
  </svg>
));
export const PE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2801)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M24 12.0015C24 6.84199 20.7435 2.44342 16.1739 0.747955V23.2552C20.7435 21.5596 24 17.1611 24 12.0015Z" fill="#D80027" />
      <path
        d="M0.000228882 12.0007C0.000228882 17.1603 3.25673 21.5588 7.82634 23.2543V0.747101C3.25673 2.44257 0.000228882 6.84113 0.000228882 12.0007Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2801">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PF: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M1.45911 6.26165H22.5409C20.5057 2.53153 16.5485 0.000793457 12 0.000793457C7.45151 0.000793457 3.49437 2.53153 1.45911 6.26165Z"
      fill="#D80027"
    />
    <path
      d="M11.9997 23.9999C16.5482 23.9999 20.5053 21.4691 22.5406 17.739H1.45877C3.49404 21.4691 7.45118 23.9999 11.9997 23.9999Z"
      fill="#D80027"
    />
    <path
      d="M16.174 11.9996C16.174 14.3049 14.3053 15.6518 12.0001 15.6518C9.69494 15.6518 7.82622 14.3049 7.82622 11.9996C7.82622 9.69442 9.69494 7.82574 12.0001 7.82574C14.3053 7.82574 16.174 9.69442 16.174 11.9996Z"
      fill="#FFDA44"
    />
    <path d="M16.174 11.9998C16.174 14.305 14.3053 16.1737 12.0001 16.1737C9.69494 16.1737 7.82622 14.305 7.82622 11.9998" fill="#0052B4" />
    <path d="M10.4351 10.9561H9.39162V13.043H10.4351V10.9561Z" fill="#D80027" />
    <path d="M14.6089 10.9561H13.5654V13.043H14.6089V10.9561Z" fill="#D80027" />
    <path d="M12.522 9.39093H11.4785V13.0431H12.522V9.39093Z" fill="#D80027" />
  </svg>
));
export const PG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2783)">
      <path
        d="M20.4853 20.4857C15.799 25.172 8.20108 25.172 3.51471 20.4857C-1.17158 15.7994 -1.17158 8.2014 3.51475 3.51508C8.20103 -1.1712 15.0611 -0.43334 19.7474 4.25299C24.4337 8.93926 25.1716 15.7994 20.4853 20.4857Z"
        fill="black"
      />
      <path d="M3.51465 3.51462C8.20093 -1.17166 15.7989 -1.17156 20.4852 3.51467C25.1715 8.20095 25.1715 15.7989 20.4852 20.4852" fill="#A2001D" />
      <path
        d="M9.17146 16.1739L9.36571 16.7718H9.99435L9.48576 17.1412L9.68006 17.7391L9.17146 17.3696L8.66287 17.7391L8.85712 17.1412L8.34857 16.7718H8.97717L9.17146 16.1739Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.56506 10.435L7.88892 11.4315H8.93658L8.08893 12.0473L8.4127 13.0437L7.56506 12.4279L6.71746 13.0437L7.04128 12.0473L6.19359 11.4315H7.24134L7.56506 10.435Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.56506 17.7388L7.88883 18.7352H8.93658L8.08884 19.351L8.4127 20.3475L7.56506 19.7316L6.71746 20.3475L7.04118 19.351L6.19359 18.7352H7.2412L7.56506 17.7388Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.6289 13.0439L10.9528 14.0404H12.0005L11.1528 14.6562L11.4766 15.6526L10.6289 15.0367L9.78135 15.6526L10.1052 14.6562L9.25752 14.0404H10.3052L10.6289 13.0439Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.50221 13.0439L4.82607 14.0404H5.87368L5.02608 14.6562L5.3498 15.6526L4.50221 15.0367L3.65457 15.6526L3.97843 14.6562L3.13074 14.0404H4.17844L4.50221 13.0439Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0881 8.88631C19.5518 8.35002 18.855 8.03319 18.1061 7.97877L20.3477 6.23535C19.455 5.34261 18.2584 4.93944 17.0909 5.02471C16.9511 4.52239 16.6846 4.04792 16.2896 3.65291L15.4042 5.42375C15.3461 5.31791 15.2725 5.2183 15.1828 5.12863C14.6734 4.61924 13.8475 4.61924 13.3382 5.12863C12.8289 5.63802 12.8288 6.46386 13.3382 6.97325C13.4279 7.06292 13.5275 7.13647 13.6334 7.1946L11.8625 8.08002C12.2576 8.47517 12.7324 8.74185 13.235 8.88153C13.1495 10.0491 13.5522 11.2454 14.445 12.1382L16.4035 9.62019C16.5508 9.47511 16.7454 9.395 16.9524 9.395C17.1614 9.395 17.3579 9.47638 17.5057 9.62427C17.6536 9.77206 17.735 9.96861 17.735 10.1776C17.735 10.3867 17.6536 10.5832 17.5057 10.731L18.2436 11.4689C18.5885 11.124 18.7785 10.6655 18.7785 10.1777C18.7785 9.77858 18.6512 9.39917 18.4161 9.08549C18.7586 9.17694 19.0823 9.3561 19.3504 9.62427C20.1641 10.438 20.1641 11.762 19.3504 12.5757L20.0883 13.3136C20.6795 12.7223 21.0052 11.9362 21.0052 11.1C21.005 10.2637 20.6793 9.4776 20.0881 8.88631Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2783">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2807)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0004 -3.05176e-05V12L3.51508 20.4853C5.68665 22.6568 8.68665 24 12.0004 24C18.6278 24 24.0004 18.6273 24.0004 12C24.0004 5.37259 12.0004 -3.05176e-05 12.0004 -3.05176e-05Z"
        fill="#D80027"
      />
      <path
        d="M12.0004 -3.05176e-05C8.68665 -3.05176e-05 5.68665 1.34313 3.51508 3.51466C6.45929 6.45888 7.50447 7.50409 12.0004 12H24.0004C24.0004 5.37259 18.6278 -3.05176e-05 12.0004 -3.05176e-05Z"
        fill="#0052B4"
      />
      <path
        d="M8.21723 11.9998L6.75173 11.3105L7.53215 9.89117L5.94074 10.1956L5.73909 8.58795L4.63059 9.77033L3.52213 8.58795L3.32043 10.1956L1.72907 9.89113L2.50949 11.3105L1.04395 11.9998L2.50949 12.6892L1.72907 14.1085L3.32057 13.8041L3.52209 15.4117L4.63059 14.2294L5.73909 15.4117L5.94074 13.8041L7.53205 14.1086L6.75168 12.6892L8.21723 11.9998Z"
        fill="#FFDA44"
      />
      <path
        d="M3.20082 4.69525L3.68851 5.37695L4.48749 5.12388L3.98977 5.79831L4.47746 6.48002L3.68218 6.21513L3.18451 6.88952L3.19074 6.05139L2.39551 5.78645L3.19463 5.53338L3.20082 4.69525Z"
        fill="#FFDA44"
      />
      <path
        d="M3.20082 17.1096L3.68851 17.7913L4.48749 17.5381L3.98977 18.2126L4.47746 18.8943L3.68218 18.6294L3.18451 19.3038L3.19074 18.4657L2.39551 18.2008L3.19463 17.9477L3.20082 17.1096Z"
        fill="#FFDA44"
      />
      <path
        d="M10.1563 10.9033L9.66865 11.585L8.86961 11.3318L9.36733 12.0063L8.87965 12.6881L9.67493 12.4231L10.1726 13.0975L10.1664 12.2594L10.9616 11.9945L10.1625 11.7414L10.1563 10.9033Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2807">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2757)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M0.000198364 12.0002C0.000198364 16.5487 2.53093 20.5058 6.26106 22.5411V1.45926C2.53093 3.49453 0.000198364 7.45167 0.000198364 12.0002Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9996 0.000819206C9.92073 0.000819206 7.96539 0.52971 6.2605 1.4599V22.5417C7.96539 23.4719 9.92073 24.0008 11.9996 24.0008C18.627 24.0008 23.9996 18.6282 23.9996 12.0008C23.9996 5.37344 18.627 0.000819206 11.9996 0.000819206Z"
        fill="#496E2D"
      />
      <path
        d="M17.1309 13.9861C15.6127 15.083 13.4928 14.7415 12.3959 13.2234C11.2989 11.7053 11.6404 9.58533 13.1585 8.48845C13.6319 8.14645 14.1637 7.94428 14.7048 7.87402C13.6638 7.71834 12.5635 7.95291 11.643 8.61802C9.77453 9.96811 9.35421 12.5772 10.7043 14.4458C12.0543 16.3142 14.6635 16.7345 16.532 15.3843C17.4526 14.7192 18.0207 13.7483 18.1997 12.711C17.9632 13.2025 17.6043 13.644 17.1309 13.9861Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.0661 7.82723L17.9213 8.74884L19.0621 8.22047L18.4497 9.31847L19.3049 10.2402L18.0713 9.99712L17.459 11.0952L17.309 9.84693L16.0754 9.60389L17.2162 9.07551L17.0661 7.82723Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2757">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M24 11.9996C24 18.627 18.6274 23.9996 12 23.9996C5.37262 23.9996 0 18.627 0 11.9996" fill="#D80027" />
  </svg>
));
export const PN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
    <path
      d="M11.9684 12.0006H12.0006C12.0006 11.9898 12.0006 11.9793 12.0006 11.9685C11.9898 11.9792 11.9791 11.9899 11.9684 12.0006Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.0005 6.26101C12.0005 4.14953 12.0005 2.76601 12.0005 0.000152588H11.9984C5.37191 0.00127759 0.000457764 5.37339 0.000457764 12.0002H6.26131V8.47464L9.78683 12.0002H11.9684C11.9791 11.9895 11.9898 11.9788 12.0005 11.968C12.0005 11.1596 12.0005 10.4382 12.0005 9.78662L8.47489 6.26101H12.0005Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.07124 1.56503C4.19441 2.63374 2.63409 4.19402 1.56543 6.07085V11.9998H4.69588V4.69558V4.69549H12.0002C12.0002 3.70816 12.0002 2.76757 12.0002 1.56503H6.07124Z"
      fill="#D80027"
    />
    <path
      d="M12.0005 10.5247L7.73695 6.26132H6.26132V6.26142L12.0004 12.0004H12.0005C12.0005 12.0004 12.0005 10.9829 12.0005 10.5247Z"
      fill="#D80027"
    />
    <path
      d="M18.7831 7.30388L17.2179 7.82564L15.6527 7.30388L15.131 5.99953L15.6527 4.69519H18.7831L18.2614 5.99953L18.7831 7.30388Z"
      fill="#ACABB1"
    />
    <path
      d="M13.565 7.30389V13.043C13.565 15.8386 17.2172 16.6952 17.2172 16.6952C17.2172 16.6952 20.8694 15.8386 20.8694 13.043V7.30389H13.565Z"
      fill="#338AF3"
    />
    <path
      d="M13.8948 14.4023C14.7925 16.1258 17.2177 16.6948 17.2177 16.6948C17.2177 16.6948 19.643 16.1258 20.5407 14.4023L17.2177 8.86877L13.8948 14.4023Z"
      fill="#6DA544"
    />
    <path
      d="M20.8694 12.985L17.2172 7.30389L13.565 12.985V13.043C13.565 13.5604 13.6903 14.0112 13.8942 14.4026L17.2172 9.2335L20.5402 14.4026C20.744 14.0111 20.8694 13.5603 20.8694 13.0429V12.985Z"
      fill="#FFDA44"
    />
  </svg>
));
export const PR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2838)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.999 -0.000549316C8.07311 -0.000549316 4.58772 1.8849 2.39847 4.79945H21.5995C19.4102 1.8849 15.9249 -0.000549316 11.999 -0.000549316Z"
        fill="#D80027"
      />
      <path
        d="M11.999 23.9994C15.9249 23.9994 19.4102 22.1139 21.5995 19.1994H2.39847C4.58772 22.1139 8.07311 23.9994 11.999 23.9994Z"
        fill="#D80027"
      />
      <path
        d="M-0.000549316 11.9994C-0.000549316 12.8214 0.0823257 13.624 0.239779 14.3994H23.7592C23.9167 13.624 23.9995 12.8214 23.9995 11.9994C23.9995 11.1775 23.9166 10.3749 23.7592 9.59943H0.239779C0.0823257 10.3749 -0.000549316 11.1775 -0.000549316 11.9994Z"
        fill="#D80027"
      />
      <path
        d="M3.51431 3.51538C-1.17197 8.20166 -1.17197 15.7997 3.51431 20.486C5.45086 18.5495 7.31334 16.687 11.9996 12.0007L3.51431 3.51538Z"
        fill="#0052B4"
      />
      <path
        d="M4.85698 8.86877L5.63393 11.2601H8.14858L6.1143 12.7382L6.89121 15.1297L4.85698 13.6517L2.82265 15.1297L3.59974 12.7382L1.56546 11.2601H4.07993L4.85698 8.86877Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2838">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2770)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M7.3043 7.82693H23.2535C21.558 3.25732 17.1595 0.000816345 12 0.000816345C8.68617 0.000816345 5.6865 1.34421 3.51506 3.51593L7.3043 7.82693Z"
        fill="black"
      />
      <path
        d="M7.3043 16.1736H23.2535C21.558 20.7432 17.1595 23.9997 12 23.9997C8.68617 23.9997 5.6865 22.6563 3.51506 20.4846L7.3043 16.1736Z"
        fill="#6DA544"
      />
      <path
        d="M3.51464 3.51488C-1.17165 8.20116 -1.17165 15.7992 3.51464 20.4855C5.45118 18.549 7.31367 16.6865 12 12.0002L3.51464 3.51488Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2770">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2831)">
      <path
        d="M-0.000411987 12.0007C-0.000411987 17.1602 3.25609 21.5588 7.8256 23.2543L8.86913 12.0007L7.8256 0.747101C3.25609 2.44266 -0.000411987 6.84113 -0.000411987 12.0007Z"
        fill="#6DA544"
      />
      <path
        d="M24.0001 12C24.0001 5.37259 18.6275 -3.05176e-05 12.0001 -3.05176e-05C10.5323 -3.05176e-05 9.12617 0.264016 7.82614 0.74636V23.2536C9.12617 23.736 10.5323 24 12.0001 24C18.6275 24 24.0001 18.6273 24.0001 12Z"
        fill="#D80027"
      />
      <path
        d="M7.82623 16.1745C10.1314 16.1745 12.0001 14.3058 12.0001 12.0006C12.0001 9.69544 10.1314 7.82672 7.82623 7.82672C5.52106 7.82672 3.65234 9.69544 3.65234 12.0006C3.65234 14.3058 5.52106 16.1745 7.82623 16.1745Z"
        fill="#FFDA44"
      />
      <path
        d="M5.47775 9.9126V12.5213C5.47775 13.8179 6.52888 14.8691 7.82558 14.8691C9.12229 14.8691 10.1734 13.818 10.1734 12.5213V9.9126H5.47775Z"
        fill="#D80027"
      />
      <path
        d="M7.82623 13.3038C7.3947 13.3038 7.04361 12.9527 7.04361 12.5212V11.4777H8.60881V12.5212C8.60881 12.9527 8.25772 13.3038 7.82623 13.3038Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2831">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const PW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3" />
    <path
      d="M9.39108 17.2183C12.2726 17.2183 14.6085 14.8824 14.6085 12.0009C14.6085 9.11944 12.2726 6.78354 9.39108 6.78354C6.50961 6.78354 4.17371 9.11944 4.17371 12.0009C4.17371 14.8824 6.50961 17.2183 9.39108 17.2183Z"
      fill="#FFDA44"
    />
  </svg>
));
export const PY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2794)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0003 -3.05176e-05C7.24279 -3.05176e-05 3.13204 2.76864 1.19104 6.78259H22.8096C20.8686 2.76864 16.7578 -3.05176e-05 12.0003 -3.05176e-05Z"
        fill="#D80027"
      />
      <path
        d="M12.0003 24.0008C16.7578 24.0008 20.8686 21.2321 22.8096 17.2181H1.19104C3.13204 21.2321 7.24279 24.0008 12.0003 24.0008Z"
        fill="#0052B4"
      />
      <path
        d="M14.9511 8.52664L13.8444 9.63341C14.3164 10.1055 14.6085 10.7577 14.6085 11.478C14.6085 12.9188 13.4405 14.0867 11.9998 14.0867C10.5591 14.0867 9.39109 12.9187 9.39109 11.478C9.39109 10.7577 9.68312 10.1055 10.1552 9.63341L9.04843 8.52664C8.29304 9.28189 7.82588 10.3254 7.82588 11.478C7.82588 13.7833 9.6946 15.6519 11.9998 15.6519C14.305 15.6519 16.1737 13.7832 16.1737 11.478C16.1736 10.3254 15.7065 9.28189 14.9511 8.52664Z"
        fill="#6DA544"
      />
      <path
        d="M11.9999 9.91263L12.3885 11.1084H13.6457L12.6286 11.8473L13.0171 13.0431L11.9999 12.3041L10.9827 13.0431L11.3713 11.8473L10.3541 11.1084H11.6114L11.9999 9.91263Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2794">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const QA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2847)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M24 11.9999C24 5.37256 18.6274 -6.10352e-05 12 -6.10352e-05C9.65248 -6.10352e-05 7.46276 0.674705 5.61316 1.83983L8.24346 2.95738L4.69563 4.46478L8.24346 5.97214L4.69563 7.47945L8.24346 8.98672L4.69563 10.4938L8.24346 12.0008L4.69563 13.5081L8.24346 15.0153L4.69563 16.5224L8.24346 18.0296L4.69563 19.5369L8.24346 21.044L5.61434 22.1609C7.4637 23.3255 9.65295 23.9999 12 23.9999C18.6274 23.9999 24 18.6273 24 11.9999Z"
        fill="#751A46"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2847">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const RO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2874)">
      <path
        d="M16.1741 0.745367C14.8741 0.26307 13.4681 -0.000976556 12.0002 -0.000976556C10.5324 -0.00102343 9.12633 0.26307 7.82635 0.745367L6.78287 11.999L7.82635 23.2526C9.12629 23.735 10.5323 23.999 12.0002 23.999C13.468 23.999 14.8741 23.735 16.1741 23.2526L17.2176 11.999L16.1741 0.745367Z"
        fill="#FFDA44"
      />
      <path
        d="M23.9997 11.9996C23.9997 6.84005 20.7432 2.44144 16.1736 0.745972V23.2533C20.7432 21.5576 23.9997 17.1592 23.9997 11.9996Z"
        fill="#D80027"
      />
      <path
        d="M0.000167847 11.9995C0.000167847 17.1592 3.25667 21.5576 7.82618 23.2532L7.82623 0.745972C3.25667 2.44144 0.000167847 6.83991 0.000167847 11.9995Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2874">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const RS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path
      d="M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z"
      fill="#0052B4"
    />
    <path
      d="M12.0003 0.000118256C6.84075 0.000118256 2.44224 3.25662 0.746719 7.82623H23.254C21.5584 3.25662 17.1599 0.000118256 12.0003 0.000118256Z"
      fill="#D80027"
    />
    <path
      d="M3.10339 6.78314V12.7694C3.10339 16.1746 7.55188 17.2179 7.55188 17.2179C7.55188 17.2179 12.0003 16.1746 12.0003 12.7694V6.78314H3.10339Z"
      fill="#D80027"
    />
    <path d="M4.9422 7.82637H10.1596V5.7394L9.11614 6.26112L7.55093 4.69592L5.98568 6.26112L4.9422 5.7394V7.82637Z" fill="#FFDA44" />
    <path d="M10.956 13.6025L7.56473 10.2112L4.17342 13.6025L5.28018 14.7093L7.56473 12.4248L9.84928 14.7093L10.956 13.6025Z" fill="#FFDA44" />
    <path
      d="M10.956 10.4341H9.3737C9.46267 10.2805 9.51442 10.1026 9.51442 9.91243C9.51442 9.33605 9.04721 8.86894 8.47093 8.86894C8.07273 8.86894 7.72693 9.09197 7.55101 9.41986C7.37509 9.09202 7.02929 8.86894 6.63109 8.86894C6.05481 8.86894 5.5876 9.33605 5.5876 9.91243C5.5876 10.1026 5.63935 10.2805 5.72832 10.4341H4.17339C4.17339 11.0104 4.67537 11.4775 5.2516 11.4775H5.21687C5.21687 12.0539 5.68403 12.521 6.26035 12.521C6.26035 13.0313 6.62682 13.4552 7.11081 13.546L6.28862 15.4023C6.68265 15.5625 7.11324 15.6515 7.56474 15.6515C8.01624 15.6515 8.44684 15.5625 8.84087 15.4023L8.01868 13.546C8.50267 13.4553 8.86913 13.0313 8.86913 12.521C9.44546 12.521 9.91262 12.0539 9.91262 11.4775H9.87788C10.4541 11.4775 10.956 11.0103 10.956 10.4341Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const RU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2879)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.2539 16.1733C23.7363 14.8734 24.0003 13.4673 24.0003 11.9995C24.0003 10.5316 23.7363 9.12555 23.2539 7.82556H0.746665C0.264322 9.12555 0.000274658 10.5316 0.000274658 11.9995C0.000274658 13.4673 0.264322 14.8734 0.746665 16.1733L12.0003 17.2168L23.2539 16.1733Z"
        fill="#0052B4"
      />
      <path
        d="M12.0003 23.9995C17.1599 23.9995 21.5584 20.743 23.2539 16.1734H0.746719C2.44223 20.743 6.84075 23.9995 12.0003 23.9995Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2879">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const RW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2884)">
      <path
        d="M0.00038147 11.9991C0.00038147 14.078 0.529272 16.0333 1.45946 17.7382L12.0004 18.7817L22.5413 17.7382C23.4715 16.0333 24.0004 14.078 24.0004 11.9991L12.0004 10.9556L0.00038147 11.9991Z"
        fill="#FFDA44"
      />
      <path
        d="M22.5409 6.26086C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H24C24 9.92109 23.4711 7.96575 22.5409 6.26086Z"
        fill="#338AF3"
      />
      <path
        d="M12.0004 23.9991C16.5489 23.9991 20.506 21.4683 22.5413 17.7382H1.45944C3.49471 21.4683 7.45185 23.9991 12.0004 23.9991Z"
        fill="#496E2D"
      />
      <path
        d="M13.565 7.02244L15.0306 7.71183L14.2502 9.1312L15.8416 8.8268L16.0433 10.4344L17.1517 9.252L18.2602 10.4344L18.4618 8.8268L20.0532 9.13111L19.2728 7.71178L20.7383 7.02244L19.2727 6.33314L20.0532 4.91377L18.4618 5.21817L18.2601 3.6106L17.1517 4.79297L16.0432 3.6106L15.8416 5.21817L14.2501 4.91377L15.0306 6.33319L13.565 7.02244Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2884">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544" />
    <path
      d="M6.78288 14.3476C6.78288 15.2121 7.48366 15.9128 8.34809 15.9128H13.0437C13.0437 16.6332 13.6277 17.2172 14.3481 17.2172H15.9133C16.6337 17.2172 17.2176 16.6332 17.2176 15.9128V14.3476H6.78288Z"
      fill="#F0F0F0"
    />
    <path
      d="M17.3474 6.78308V10.4352C17.3474 11.0106 16.8793 11.4787 16.3039 11.4787V13.0439C17.7424 13.0439 18.9126 11.8737 18.9126 10.4352V6.78308H17.3474Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.13035 10.435C6.13035 11.0104 5.66226 11.4785 5.08687 11.4785V13.0437C6.52532 13.0437 7.69556 11.8734 7.69556 10.435V6.78283H6.13035V10.435Z"
      fill="#F0F0F0"
    />
    <path d="M16.5655 6.78308H15.0003V10.4353H16.5655V6.78308Z" fill="#F0F0F0" />
    <path
      d="M12.6521 8.87005C12.6521 9.01391 12.535 9.13091 12.3912 9.13091C12.2474 9.13091 12.1303 9.01386 12.1303 8.87005V6.78308H10.5651V8.87005C10.5651 9.01391 10.4481 9.13091 10.3043 9.13091C10.1605 9.13091 10.0434 9.01386 10.0434 8.87005V6.78308H8.47816V8.87005C8.47816 9.87697 9.29735 10.6962 10.3043 10.6962C10.6921 10.6962 11.0517 10.5743 11.3478 10.3673C11.6438 10.5742 12.0035 10.6962 12.3913 10.6962C12.4693 10.6962 12.5461 10.6907 12.6216 10.6811C12.5107 11.138 12.0992 11.4787 11.6086 11.4787V13.0439C13.0471 13.0439 14.2173 11.8737 14.2173 10.4353V8.87005V6.78308H12.6521V8.87005H12.6521Z"
      fill="#F0F0F0"
    />
    <path d="M10.826 11.4781H8.47816V13.0433H10.826V11.4781Z" fill="#F0F0F0" />
  </svg>
));
export const SB: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3039)">
      <path
        d="M20.4861 20.4851C24.9866 15.9845 25.1643 8.79933 21.021 4.08563L12.0004 11.9994L4.08664 21.02C8.80033 25.1633 15.9855 24.9856 20.4861 20.4851Z"
        fill="#496E2D"
      />
      <path
        d="M3.51485 3.51437C8.01536 -0.986137 15.2006 -1.16384 19.9143 2.97939L12.0004 12.0001L2.97991 19.9138C-1.16336 15.2001 -0.98561 8.01488 3.51485 3.51437Z"
        fill="#0052B4"
      />
      <path
        d="M19.9139 2.98016L2.97949 19.9146C3.15068 20.1093 3.32843 20.3004 3.51448 20.4864C3.70048 20.6723 3.89158 20.8501 4.0864 21.0214L21.0207 4.08697C20.8495 3.89216 20.6717 3.7011 20.4856 3.51505C20.2997 3.32915 20.1086 3.15135 19.9139 2.98016Z"
        fill="#FFDA44"
      />
      <path
        d="M5.05675 4.17438L5.31583 4.97158H6.154L5.47591 5.46419L5.73489 6.26139L5.05675 5.76869L4.37861 6.26139L4.63769 5.46419L3.95955 4.97158H4.79777L5.05675 4.17438Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.33753 4.17358L9.59661 4.97079H10.4347L9.75664 5.46339L10.0157 6.2606L9.33753 5.76789L8.65939 6.2606L8.91847 5.46339L8.24033 4.97079H9.0785L9.33753 4.17358Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.05635 8.34778L5.31543 9.14498H6.1536L5.47551 9.63763L5.73449 10.4348L5.05635 9.94213L4.37821 10.4348L4.63729 9.63763L3.95915 9.14498H4.79737L5.05635 8.34778Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.33753 8.34778L9.59661 9.14498H10.4347L9.75664 9.63763L10.0157 10.4348L9.33753 9.94213L8.65939 10.4348L8.91847 9.63763L8.24033 9.14498H9.0785L9.33753 8.34778Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.19704 6.26166L7.45612 7.05886H8.29424L7.61615 7.55151L7.87518 8.34871L7.19704 7.85601L6.5189 8.34871L6.77793 7.55151L6.09979 7.05886H6.93801L7.19704 6.26166Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3039">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2974)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M20.1002 3.14639C17.9655 1.19208 15.122 -0.000656128 11.9997 -0.000656128C11.4886 -0.000656128 10.9849 0.031547 10.4906 0.0935626L4.69539 6.78197L0.379471 15.0055C0.658283 16.0865 1.08456 17.1081 1.63455 18.0485L11.9997 11.9993L20.1002 3.14639Z"
        fill="#FFDA44"
      />
      <path
        d="M21.9905 18.648L5.20134 21.888C7.13395 23.2193 9.47573 23.9993 11.9999 23.9993C16.1681 23.9993 19.8393 21.8739 21.9905 18.648Z"
        fill="#6DA544"
      />
      <path
        d="M20.1023 3.14822L1.64183 18.0603C2.12469 18.8838 2.7028 19.6447 3.36125 20.3276L24.0002 11.9996C24.0002 8.49525 22.4978 5.34206 20.1023 3.14822Z"
        fill="#D80027"
      />
      <path
        d="M-0.000488281 12C-0.000488281 13.0381 0.131418 14.0454 0.379246 15.0061L10.4904 0.0942001C4.57536 0.836419 -0.000488281 5.88373 -0.000488281 12Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2974">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3162)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M9.39082 10.435H23.8979C23.1309 4.54718 18.0964 0.000213623 11.9995 0.000213623C11.1035 0.000213623 10.2307 0.0992605 9.39078 0.285448V10.435H9.39082Z"
        fill="#0052B4"
      />
      <path d="M6.26076 10.4348V1.45917C2.96572 3.25701 0.606924 6.55471 0.101471 10.4349H6.26076V10.4348Z" fill="#0052B4" />
      <path d="M6.26071 13.5656H0.101471C0.606924 17.4458 2.96572 20.7435 6.26076 22.5413L6.26071 13.5656Z" fill="#0052B4" />
      <path
        d="M9.39078 13.5657V23.7152C10.2307 23.9014 11.1035 24.0004 11.9995 24.0004C18.0964 24.0004 23.1309 19.4535 23.8979 13.5656H9.39078V13.5657Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3162">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027" />
    <path
      d="M7.30396 6.26097C7.30396 4.51262 8.53269 3.05209 10.1735 2.69373C9.92132 2.6387 9.65971 2.60884 9.39088 2.60884C7.3738 2.60884 5.73871 4.24393 5.73871 6.26101C5.73871 8.27809 7.3738 9.91318 9.39088 9.91318C9.65961 9.91318 9.92127 9.88333 10.1735 9.82825C8.53269 9.46989 7.30396 8.00936 7.30396 6.26097Z"
      fill="#F0F0F0"
    />
    <path
      d="M11.9997 2.86998L12.2587 3.66709H13.0969L12.4187 4.15979L12.6777 4.9569L11.9997 4.46429L11.3216 4.9569L11.5806 4.15979L10.9025 3.66709H11.7406L11.9997 2.86998Z"
      fill="#F0F0F0"
    />
    <path
      d="M9.96648 4.43466L10.2255 5.23182H11.0636L10.3855 5.72447L10.6446 6.52158L9.96648 6.02897L9.28829 6.52158L9.54737 5.72447L8.86923 5.23182H9.7074L9.96648 4.43466Z"
      fill="#F0F0F0"
    />
    <path
      d="M14.033 4.43466L14.2921 5.23182H15.1302L14.4521 5.72447L14.7111 6.52158L14.033 6.02897L13.3549 6.52158L13.6139 5.72447L12.9358 5.23182H13.774L14.033 4.43466Z"
      fill="#F0F0F0"
    />
    <path
      d="M13.2506 6.78336L13.5096 7.58051H14.3477L13.6696 8.07317L13.9286 8.87028L13.2506 8.37767L12.5725 8.87028L12.8315 8.07317L12.1534 7.58051H12.9915L13.2506 6.78336Z"
      fill="#F0F0F0"
    />
    <path
      d="M10.7489 6.78336L11.0079 7.58051H11.8461L11.1679 8.07317L11.427 8.87028L10.7489 8.37767L10.0707 8.87028L10.3298 8.07317L9.65167 7.58051H10.4898L10.7489 6.78336Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const SI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3033)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.2538 7.82644H10.435V4.69598H4.17412V7.82644H0.74662C0.264276 9.12637 0.000228882 10.5325 0.000228882 12.0003C0.000228882 13.4682 0.264276 14.8742 0.74662 16.1742L12.0002 17.2177L23.2538 16.1742C23.7362 14.8742 24.0002 13.4682 24.0002 12.0003C24.0002 10.5325 23.7362 9.12637 23.2538 7.82644Z"
        fill="#0052B4"
      />
      <path
        d="M12.0002 23.9996C17.1598 23.9996 21.5583 20.7431 23.2538 16.1735H0.746582C2.4421 20.7431 6.84061 23.9996 12.0002 23.9996Z"
        fill="#D80027"
      />
      <path
        d="M4.17403 7.82641V8.86984C4.17403 11.2661 7.30448 12.0003 7.30448 12.0003C7.30448 12.0003 10.4349 11.2661 10.4349 8.86984V7.82641L9.39145 8.86989L7.30448 7.30469L5.21751 8.86989L4.17403 7.82641Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3033">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3024)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12.0001 23.9996C18.6275 23.9996 24.0001 18.627 24.0001 11.9996C24.0001 10.5318 23.7361 9.12568 23.2537 7.82574H0.746497C0.264154 9.12568 0.000106812 10.5318 0.000106812 11.9996C0.000106812 18.627 5.37273 23.9996 12.0001 23.9996Z"
        fill="#0052B4"
      />
      <path
        d="M12.0001 23.9996C17.1596 23.9996 21.5582 20.7431 23.2537 16.1735H0.74646C2.44198 20.7431 6.84049 23.9996 12.0001 23.9996Z"
        fill="#D80027"
      />
      <path
        d="M3.10266 6.78189V12.7681C3.10266 16.1733 7.55115 17.2167 7.55115 17.2167C7.55115 17.2167 11.9996 16.1733 11.9996 12.7681V6.78189H3.10266Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.1465 6.78189V12.7681C4.1465 13.1679 4.23528 13.5454 4.41116 13.8993C6.1565 13.8993 8.76519 13.8993 10.6918 13.8993C10.8677 13.5454 10.9565 13.1679 10.9565 12.7681V6.78189H4.1465Z"
        fill="#D80027"
      />
      <path
        d="M9.6386 10.9562H8.07344V9.91267H9.11693V8.86918H8.07344V7.82574H7.02996V8.86918H5.98652V9.91267H7.02996V10.9562H5.46471V11.9996H7.02996V13.0431H8.07344V11.9996H9.6386V10.9562Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.83429 15.3573C6.50671 15.7799 7.19756 16.0252 7.55123 16.1343C7.9049 16.0253 8.59575 15.7799 9.26817 15.3573C9.94626 14.9311 10.4216 14.4437 10.6915 13.9007C10.3938 13.69 10.0306 13.5658 9.6382 13.5658C9.49532 13.5658 9.35653 13.5827 9.22307 13.6138C8.94028 12.9713 8.29832 12.5223 7.55128 12.5223C6.80423 12.5223 6.16223 12.9713 5.87948 13.6138C5.74603 13.5827 5.60718 13.5658 5.46435 13.5658C5.07196 13.5658 4.70873 13.69 4.41103 13.9007C4.68079 14.4437 5.15615 14.9311 5.83429 15.3573Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3024">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2981)">
      <path
        d="M23.2534 16.1743C23.7358 14.8743 23.9998 13.4682 23.9998 12.0004C23.9998 10.5325 23.7358 9.12649 23.2534 7.8265L11.9998 6.78302L0.746208 7.8265C0.263817 9.12649 -0.000183105 10.5325 -0.000183105 12.0004C-0.000183105 13.4682 0.263817 14.8743 0.746208 16.1743L11.9998 17.2178L23.2534 16.1743Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9998 24.0006C17.1594 24.0006 21.5579 20.7441 23.2534 16.1745H0.74617C2.44173 20.7441 6.8402 24.0006 11.9998 24.0006Z"
        fill="#338AF3"
      />
      <path
        d="M11.9999 0.00012207C6.84029 0.00012207 2.44182 3.25662 0.746262 7.82623H23.2535C21.558 3.25662 17.1594 0.00012207 11.9999 0.00012207Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2981">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2928)">
      <path
        d="M24 11.9997C24 18.6271 18.6274 23.9997 12 23.9997C5.37261 23.9997 -1.52588e-05 18.6271 -1.52588e-05 11.9997C0.521703 11.9997 12 10.4345 12 10.4345L24 11.9997Z"
        fill="#338AF3"
      />
      <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#F0F0F0" />
      <path
        d="M16.7632 8.28088L12 13.0442L7.23671 8.28088C6.62072 9.19527 6.26086 10.2959 6.26086 11.4789V13.0441C6.26086 15.5574 7.88485 17.6983 10.1385 18.4732C9.83766 19.0627 9.88838 19.7984 10.3291 20.3485C10.9145 19.8793 11.5206 19.3936 12.0347 18.9817C12.5488 19.3937 13.1549 19.8794 13.7402 20.3485C14.1862 19.792 14.2332 19.0453 13.9206 18.4523C16.1434 17.6606 17.739 15.5354 17.739 13.0441V11.479C17.7391 10.2959 17.3792 9.19532 16.7632 8.28088Z"
        fill="#6DA544"
      />
      <path
        d="M11.9996 17.2175C9.69812 17.2175 7.82574 15.3451 7.82574 13.0436V11.4784C7.82574 9.17691 9.69817 7.30453 11.9996 7.30453C14.3011 7.30453 16.1735 9.17696 16.1735 11.4784V13.0436C16.1735 15.3451 14.3012 17.2175 11.9996 17.2175Z"
        fill="#FFDA44"
      />
      <path
        d="M14.6089 13.0433V11.4781C14.6089 10.0396 13.4386 8.86942 12.0002 8.86942C10.5618 8.86942 9.39151 10.0397 9.39151 11.4781V13.0433L12.0002 13.565L14.6089 13.0433Z"
        fill="#338AF3"
      />
      <path
        d="M9.39151 13.0432C9.39151 14.4817 10.5618 15.6519 12.0002 15.6519C13.4386 15.6519 14.6089 14.4816 14.6089 13.0432H9.39151Z"
        fill="#6DA544"
      />
      <path
        d="M15.1304 7.30395C15.1304 6.43953 14.4297 5.73875 13.5652 5.73875C13.1642 5.73875 12.7987 5.88969 12.5218 6.13761V5.21698H13.0435V4.1735H12.5218V3.65178H11.4783V4.1735H10.9566V5.21698H11.4783V6.13761C11.2013 5.88969 10.8358 5.73875 10.4348 5.73875C9.57036 5.73875 8.86958 6.43953 8.86958 7.30395C8.86958 7.76741 9.07119 8.18366 9.3913 8.4703V9.39092H14.6087V8.4703C14.9288 8.18366 15.1304 7.76741 15.1304 7.30395Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2928">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2956)">
      <path
        d="M17.2174 1.19084C15.6397 0.427991 13.8698 0.000116348 12 0.000116348C10.1301 0.000116348 8.36024 0.427991 6.78262 1.19084L5.73914 12.0001L6.78262 22.8094C8.36024 23.5722 10.1301 24.0001 12 24.0001C13.8698 24.0001 15.6397 23.5722 17.2174 22.8094L18.2608 12.0001L17.2174 1.19084Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0001 7.82601L13.0361 11.0144H16.389L13.6766 12.9852L14.7126 16.1738L12.0001 14.2032L9.28771 16.1738L10.3239 12.9852L7.61151 11.0144H10.9642L12.0001 7.82601Z"
        fill="#496E2D"
      />
      <path
        d="M6.78294 1.19077C2.76904 3.13173 0.000320435 7.24215 0.000320435 11.9996C0.000320435 16.7571 2.76904 20.8675 6.78294 22.8085V1.19077Z"
        fill="#496E2D"
      />
      <path
        d="M17.2178 1.19143V22.8092C21.2317 20.8682 24.0004 16.7578 24.0004 12.0003C24.0004 7.24281 21.2317 3.13238 17.2178 1.19143Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2956">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3" />
    <path
      d="M12.0001 6.26068L13.2952 10.2464H17.486L14.0955 12.7097L15.3906 16.6955L12.0001 14.2321L8.60964 16.6955L9.9047 12.7097L6.51419 10.2464H10.705L12.0001 6.26068Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const SR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3138)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.2532 7.82681H0.745932C0.263635 9.12684 -0.000411987 10.5329 -0.000411987 12.0007C-0.000411987 13.4685 0.263635 14.8747 0.745932 16.1746H23.2532C23.7356 14.8747 23.9996 13.4685 23.9996 12.0007C23.9996 10.5329 23.7356 9.12684 23.2532 7.82681Z"
        fill="#A2001D"
      />
      <path
        d="M12.0346 24.0012C16.1447 24.0012 19.7717 21.9344 21.9344 18.7838H2.13483C4.29755 21.9344 7.92445 24.0012 12.0346 24.0012Z"
        fill="#6DA544"
      />
      <path
        d="M12.0343 0.000274658C16.1443 0.000274658 19.7714 2.06709 21.9341 5.21765H2.13449C4.29721 2.06709 7.92412 0.000274658 12.0343 0.000274658Z"
        fill="#6DA544"
      />
      <path
        d="M11.9995 7.82681L13.0355 11.0153H16.3882L13.6758 12.9861L14.7119 16.1746L11.9995 14.204L9.28708 16.1746L10.3232 12.9861L7.61078 11.0153H10.9635L11.9995 7.82681Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3138">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3085)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.0638 7.347C21.2465 3.03024 16.9775 -0.000793457 11.9999 -0.000793457C8.68611 -0.000793457 5.68644 1.3426 3.515 3.51432L6.52016 7.347H23.0638Z"
        fill="black"
      />
      <path
        d="M6.55423 16.6075L3.515 20.4837C5.68644 22.6554 8.68611 23.9988 11.9999 23.9988C16.9942 23.9988 21.2754 20.9475 23.0823 16.6075H6.55423Z"
        fill="#496E2D"
      />
      <path
        d="M2.60887 8.82605V15.1304H23.5868C23.856 14.1323 24.0002 13.0831 24.0002 12C24.0002 10.9011 23.8521 9.83705 23.5754 8.82605H2.60887Z"
        fill="#A2001D"
      />
      <path
        d="M3.51458 3.51459C-1.17171 8.20087 -1.17171 15.7989 3.51458 20.4852C5.45112 18.5487 7.31361 16.6862 11.9999 11.9999L3.51458 3.51459Z"
        fill="#0052B4"
      />
      <path
        d="M3.9085 9.01648L5.37311 11.0603L7.76973 10.2988L6.27859 12.3235L7.7432 14.3674L5.35689 13.5748L3.8657 15.5995L3.8821 13.085L1.4957 12.2923L3.89214 11.5309L3.9085 9.01648Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3085">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ST: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2937)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M7.30501 7.82622H23.2542C21.5588 3.25661 17.1602 0.000114441 12.0007 0.000114441C8.68689 0.000114441 5.68722 1.3435 3.51578 3.51522L7.30501 7.82622Z"
        fill="#6DA544"
      />
      <path
        d="M7.30416 16.1746H23.2534C21.5579 20.7442 17.1593 24.0007 11.9998 24.0007C8.68603 24.0007 5.68636 22.6573 3.51492 20.4856L7.30416 16.1746Z"
        fill="#6DA544"
      />
      <path
        d="M3.51471 3.51379C-1.17157 8.20007 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51379Z"
        fill="#D80027"
      />
      <path
        d="M15.2379 9.91279L15.7559 11.5071H17.4322L16.076 12.4924L16.5941 14.0867L15.2379 13.1014L13.8817 14.0867L14.3997 12.4924L13.0435 11.5071H14.7199L15.2379 9.91279Z"
        fill="black"
      />
      <path
        d="M20.4557 9.91279L20.9737 11.5071H22.6501L21.2939 12.4924L21.8119 14.0867L20.4557 13.1014L19.0995 14.0867L19.6175 12.4924L18.2613 11.5071H19.9377L20.4557 9.91279Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2937">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SV: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2909)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M12 -0.000976562C7.24242 -0.000976562 3.13167 2.7677 1.19067 6.78165H22.8092C20.8682 2.7677 16.7574 -0.000976562 12 -0.000976562Z"
        fill="#0052B4"
      />
      <path d="M12 23.9989C16.7575 23.9989 20.8682 21.2302 22.8092 17.2162H1.19069C3.13169 21.2302 7.24244 23.9989 12 23.9989Z" fill="#0052B4" />
      <path d="M9.58997 12.5225L11.9998 8.34857L14.4097 12.5225H9.58997Z" fill="#FFDA44" />
      <path d="M15.1303 13.8996L11.9998 15.4649L8.86935 13.8996V11.8127H15.1303V13.8996Z" fill="#6DA544" />
      <path
        d="M14.9516 8.52725L13.8449 9.63402C14.317 10.1061 14.609 10.7583 14.609 11.4786C14.609 12.9194 13.441 14.0873 12.0003 14.0873C10.5596 14.0873 9.39161 12.9194 9.39161 11.4786C9.39161 10.7583 9.68364 10.1061 10.1557 9.63402L9.04895 8.52725C8.29356 9.2825 7.8264 10.326 7.8264 11.4786C7.8264 13.7839 9.69512 15.6525 12.0003 15.6525C14.3055 15.6525 16.1742 13.7838 16.1742 11.4786C16.1741 10.326 15.707 9.2825 14.9516 8.52725Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2909">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SX: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3013)">
      <path
        d="M10.9564 13.0427C10.9564 13.0427 3.52157 3.51222 3.51454 3.51391C5.68607 1.34233 8.68612 -0.000823975 11.9999 -0.000823975C18.6272 -0.000823975 23.9999 5.3718 23.9999 11.9992L10.9564 13.0427Z"
        fill="#D80027"
      />
      <path
        d="M10.9564 11.9995C10.9564 11.9995 3.52157 20.4865 3.51454 20.4848C5.68607 22.6564 8.68612 23.9995 11.9999 23.9995C18.6272 23.9995 23.9999 18.6269 23.9999 11.9995H10.9564Z"
        fill="#0052B4"
      />
      <path
        d="M3.51471 3.51462C-1.17157 8.2009 -1.17157 15.7989 3.51471 20.4852C5.45126 18.5487 7.31375 16.6862 12 11.9999L3.51471 3.51462Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.31578 11.9996C1.30922 12.0857 1.30476 12.1725 1.30476 12.2604C1.30476 14.1333 2.82314 15.6517 4.69608 15.6517C6.56901 15.6517 8.08739 14.1333 8.08739 12.2604C8.08739 12.1725 8.08293 12.0857 8.07637 11.9996H1.31578Z"
        fill="#FFDA44"
      />
      <path
        d="M4.69577 10.4338C5.27207 10.4338 5.73925 9.96662 5.73925 9.39032C5.73925 8.81402 5.27207 8.34683 4.69577 8.34683C4.11947 8.34683 3.65228 8.81402 3.65228 9.39032C3.65228 9.96662 4.11947 10.4338 4.69577 10.4338Z"
        fill="#FFDA44"
      />
      <path
        d="M2.34752 9.13019V12.5215C2.34752 14.3187 4.69535 14.8693 4.69535 14.8693C4.69535 14.8693 7.04318 14.3187 7.04318 12.5215V9.13019H2.34752Z"
        fill="#D80027"
      />
      <path
        d="M4.69687 13.7776C4.26131 13.6209 3.39136 13.2203 3.39136 12.5219V10.174H6.00009V12.5219C6.00009 13.2226 5.13023 13.6222 4.69687 13.7776Z"
        fill="#338AF3"
      />
      <path
        d="M5.21772 11.4777V10.9559L4.696 10.6951L4.17424 10.9559V11.4777L3.91338 11.7386V12.782H5.47863V11.7386L5.21772 11.4777Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3013">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3174)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M11.9997 -0.000720978C6.84016 -0.000720978 2.44164 3.25578 0.746124 7.82539H23.2534C21.5578 3.25578 17.1593 -0.000720978 11.9997 -0.000720978Z"
        fill="#D80027"
      />
      <path
        d="M11.9999 24.0005C17.1595 24.0005 21.558 20.744 23.2535 16.1744H0.746307C2.44182 20.744 6.84034 24.0005 11.9999 24.0005Z"
        fill="black"
      />
      <path
        d="M7.17018 9.13013L7.81767 11.1229H9.91312L8.21788 12.3547L8.86542 14.3475L7.17018 13.1159L5.47495 14.3475L6.12248 12.3547L4.42725 11.1229H6.5227L7.17018 9.13013Z"
        fill="#6DA544"
      />
      <path
        d="M16.83 9.13013L17.4775 11.1229H19.573L17.8777 12.3547L18.5253 14.3475L16.83 13.1159L15.1348 14.3475L15.7823 12.3547L14.0871 11.1229H16.1825L16.83 9.13013Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3174">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const SZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3146)">
      <path
        d="M22.809 17.2165C23.5718 15.6389 23.9997 13.869 23.9997 11.9991C23.9997 10.1293 23.5718 8.35934 22.809 6.78176L11.9997 6.25999L1.19043 6.78171C0.427585 8.35934 -0.000289917 10.1293 -0.000289917 11.9991C-0.000289917 13.869 0.427585 15.6389 1.19043 17.2165L11.9997 17.7383L22.809 17.2165Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 0.000274658C7.24239 0.000274658 3.13164 2.76895 1.19064 6.7829H22.8092C20.8682 2.76895 16.7574 0.000274658 11.9999 0.000274658Z"
        fill="black"
      />
      <path
        d="M11.9999 23.9993C7.24239 23.9993 3.13164 21.2307 1.19064 17.2167H22.8092C20.8682 21.2307 16.7574 23.9993 11.9999 23.9993Z"
        fill="#0052B4"
      />
      <path
        d="M23.433 8.34787H0.566382C0.198788 9.49954 -0.000289917 10.7265 -0.000289917 12C-0.000289917 13.2736 0.198788 14.5005 0.566382 15.6522H23.433C23.8006 14.5005 23.9997 13.2736 23.9997 12C23.9997 10.7265 23.8006 9.49954 23.433 8.34787Z"
        fill="#A2001D"
      />
      <path d="M19.826 11.4791H4.17386V12.5226H19.826V11.4791Z" fill="#FFDA44" />
      <path d="M17.739 9.39119H6.26074V10.4347H17.739V9.39119Z" fill="#FFDA44" />
      <path
        d="M17.8135 11.9996C17.8135 11.9996 15.1302 15.13 11.9998 15.13C8.86937 15.13 8.86932 11.9996 8.86932 11.9996C8.86932 11.9996 8.86932 8.86911 11.9998 8.86911C15.1302 8.86911 17.8135 11.9996 17.8135 11.9996Z"
        fill="#F0F0F0"
      />
      <path d="M11.9996 15.13C8.8691 15.13 6.18588 11.9996 6.18588 11.9996C6.18588 11.9996 8.8691 8.86911 11.9996 8.86911" fill="black" />
      <path d="M10.9567 10.957H9.91324V13.044H10.9567V10.957Z" fill="#F0F0F0" />
      <path d="M14.0867 10.957H13.0432V13.044H14.0867V10.957Z" fill="black" />
      <path
        d="M4.17392 13.0445C4.75022 13.0445 5.2174 12.5773 5.2174 12.001C5.2174 11.4247 4.75022 10.9575 4.17392 10.9575C3.59762 10.9575 3.13043 11.4247 3.13043 12.001C3.13043 12.5773 3.59762 13.0445 4.17392 13.0445Z"
        fill="#0052B4"
      />
      <path
        d="M19.8266 13.0441C20.4029 13.0441 20.87 12.5769 20.87 12.0006C20.87 11.4243 20.4029 10.9571 19.8266 10.9571C19.2503 10.9571 18.7831 11.4243 18.7831 12.0006C18.7831 12.5769 19.2503 13.0441 19.8266 13.0441Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3146">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
    <path
      d="M11.9684 11.9996H12.0005C12.0005 11.9888 12.0005 11.9783 12.0005 11.9674C11.9898 11.9782 11.9791 11.9889 11.9684 11.9996Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.0005 6.26116C12.0005 4.14968 12.0005 2.76616 12.0005 0.000305176H11.9985C5.372 0.00143018 0.000549316 5.37354 0.000549316 12.0003H6.26141V8.47479L9.78692 12.0003H11.9685C11.9792 11.9896 11.9899 11.9789 12.0006 11.9682C12.0006 11.1597 12.0006 10.4384 12.0006 9.78677L8.47499 6.26116H12.0005Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.07112 1.56537C4.19429 2.63407 2.63396 4.19435 1.56531 6.07118V12.0002H4.69576V4.69592V4.69582H12.0001C12.0001 3.70849 12.0001 2.7679 12.0001 1.56537H6.07112Z"
      fill="#D80027"
    />
    <path
      d="M12.0004 10.524L7.73692 6.26062H6.26129V6.26071L12.0003 11.9997H12.0004C12.0004 11.9997 12.0004 10.9822 12.0004 10.524Z"
      fill="#D80027"
    />
    <path
      d="M13.565 6.26044V11.9995C13.565 14.7952 17.2171 15.6517 17.2171 15.6517C17.2171 15.6517 20.8693 14.7952 20.8693 11.9995V6.26044H13.565Z"
      fill="#FFDA44"
    />
    <path
      d="M16.6958 8.34775C16.6958 8.92407 16.2286 10.4347 15.6523 10.4347C15.076 10.4347 14.6088 8.92407 14.6088 8.34775C14.6088 7.77142 15.6523 7.30426 15.6523 7.30426C15.6523 7.30426 16.6958 7.77142 16.6958 8.34775Z"
      fill="#FF9811"
    />
    <path
      d="M19.4642 9.48423C19.6326 9.07337 19.7636 8.47281 19.7636 8.17384C19.7636 7.69356 19.1375 7.30426 19.1375 7.30426C19.1375 7.30426 18.5114 7.6936 18.5114 8.17384C18.5114 8.47281 18.6423 9.07337 18.8107 9.48423L18.4492 10.3003C18.6617 10.3867 18.8939 10.4347 19.1374 10.4347C19.3809 10.4347 19.6132 10.3867 19.8256 10.3003L19.4642 9.48423Z"
      fill="#A2001D"
    />
    <path
      d="M16.4351 12C16.4351 12 15.9134 13.0435 15.9134 14.087C15.9134 14.087 17.4786 14.087 18.5221 14.087C18.522 13.0435 18.0003 12 18.0003 12L17.2177 11.4783L16.4351 12Z"
      fill="#6DA544"
    />
    <path
      d="M18.0006 12.0005V11.7397C18.0006 11.3075 17.6502 10.957 17.2179 10.957C16.7857 10.957 16.4353 11.3074 16.4353 11.7397V12.0005H18.0006Z"
      fill="#D80027"
    />
  </svg>
));
export const TD: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1793)">
      <path
        d="M12.0004 -0.000549316C10.5325 -0.000549316 9.12643 0.263498 7.8265 0.745841L7.30473 11.9995L7.82645 23.2531C9.12643 23.7355 10.5325 23.9995 12.0004 23.9995C13.4682 23.9995 14.8743 23.7355 16.1743 23.2531L16.696 11.9995L16.1743 0.745841C14.8743 0.263498 13.4682 -0.000549316 12.0004 -0.000549316Z"
        fill="#FFDA44"
      />
      <path
        d="M24.0004 12.0004C24.0004 6.8408 20.7439 2.44228 16.1743 0.746765V23.254C20.7439 21.5585 24.0004 17.16 24.0004 12.0004Z"
        fill="#D80027"
      />
      <path d="M7.82611 23.254V0.746765C3.2565 2.44228 0 6.8408 0 12.0004C0 17.16 3.2565 21.5585 7.82611 23.254Z" fill="#0052B4" />
    </g>
    <defs>
      <clipPath id="clip0_5_1793">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3216)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M12 0.000396729C11.9913 0.000490479 11.4783 4.8004 11.4783 4.8004H21.6006C19.4113 1.88585 15.9259 0.000396729 12 0.000396729Z"
        fill="#496E2D"
      />
      <path
        d="M12.0002 24.0003C15.926 24.0003 19.4114 22.1149 21.6007 19.2003H2.39966C4.58891 22.1149 8.0743 24.0003 12.0002 24.0003Z"
        fill="#496E2D"
      />
      <path
        d="M23.7597 9.60037H11.4783L12 14.4004H23.7597C23.9172 13.6249 24 12.8223 24 12.0004C24 11.1784 23.9171 10.3758 23.7597 9.60037Z"
        fill="#496E2D"
      />
      <path d="M12 14.4C12 11.8957 12 2.81737 12 0C5.37262 0 0 5.37262 0 12C0 12.822 0.082875 13.6245 0.240281 14.4H12Z" fill="#D80027" />
      <path
        d="M6.62106 5.73828L7.39806 8.12961H9.91267L7.87843 9.60772L8.65534 11.9991L6.62106 10.5212L4.58678 11.9991L5.36382 9.60772L3.32959 8.12961H5.84411L6.62106 5.73828Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3216">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TH: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3209)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M23.2539 7.82596H0.746726C0.264336 9.12594 0.000335693 10.532 0.000335693 11.9998C0.000335693 13.4677 0.264336 14.8738 0.746726 16.1737H23.254C23.7363 14.8738 24.0003 13.4677 24.0003 11.9998C24.0003 10.532 23.7363 9.12594 23.2539 7.82596Z"
        fill="#0052B4"
      />
      <path
        d="M12.0013 -0.000579834C8.36426 -0.000579834 5.10536 1.61773 2.90472 4.17331H21.0979C18.8973 1.61773 15.6384 -0.000579834 12.0013 -0.000579834Z"
        fill="#D80027"
      />
      <path d="M21.097 19.8261H2.90375C5.10439 22.3817 8.36328 24 12.0004 24C15.6374 24 18.8963 22.3817 21.097 19.8261Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_5_3209">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TJ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3189)">
      <path
        d="M1.19084 6.78177C0.427997 8.3594 0.00012207 10.1293 0.00012207 11.9992C0.00012207 13.869 0.427997 15.6389 1.19084 17.2165L12.0001 18.26L22.8094 17.2165C23.5722 15.6389 24.0001 13.869 24.0001 11.9992C24.0001 10.1293 23.5722 8.3594 22.8094 6.78177L12.0001 5.73829L1.19084 6.78177Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.19144 17.2176C3.13239 21.2315 7.24281 24.0002 12.0003 24.0002C16.7578 24.0002 20.8682 21.2315 22.8092 17.2176H1.19144Z"
        fill="#6DA544"
      />
      <path
        d="M1.19144 6.78204H22.8092C20.8682 2.76813 16.7578 -0.000587463 12.0003 -0.000587463C7.24281 -0.000587463 3.13239 2.76813 1.19144 6.78204Z"
        fill="#D80027"
      />
      <path d="M9.91333 15.1315H14.0873V13.3575L13.2525 13.7749L12.0003 12.5227L10.7481 13.7749L9.91333 13.3575V15.1315Z" fill="#FFDA44" />
      <path
        d="M7.52492 13.0438L7.71921 13.6416H8.34781L7.83921 14.0111L8.03351 14.609L7.52492 14.2395L7.01632 14.609L7.21062 14.0111L6.70203 13.6416H7.33062L7.52492 13.0438Z"
        fill="#FFDA44"
      />
      <path
        d="M8.1273 10.9577L8.3216 11.5555H8.95019L8.4416 11.925L8.63585 12.5229L8.1273 12.1534L7.61871 12.5229L7.81301 11.925L7.30441 11.5555H7.93301L8.1273 10.9577Z"
        fill="#FFDA44"
      />
      <path
        d="M9.84874 9.39278L10.043 9.99063H10.6716L10.1631 10.3601L10.3573 10.958L9.84874 10.5885L9.34019 10.958L9.53444 10.3601L9.02585 9.99063H9.65449L9.84874 9.39278Z"
        fill="#FFDA44"
      />
      <path
        d="M16.475 13.0438L16.2807 13.6416H15.6521L16.1607 14.0111L15.9664 14.609L16.475 14.2395L16.9835 14.609L16.7893 14.0111L17.2979 13.6416H16.6693L16.475 13.0438Z"
        fill="#FFDA44"
      />
      <path
        d="M15.8727 10.9577L15.6784 11.5555H15.0498L15.5584 11.925L15.3641 12.5229L15.8727 12.1534L16.3813 12.5229L16.187 11.925L16.6956 11.5555H16.067L15.8727 10.9577Z"
        fill="#FFDA44"
      />
      <path
        d="M14.1512 9.39278L13.9569 9.99063H13.3284L13.8369 10.3601L13.6426 10.958L14.1512 10.5885L14.6598 10.958L14.4655 10.3601L14.9741 9.99063H14.3455L14.1512 9.39278Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0004 8.60937L12.1947 9.20721H12.8233L12.3147 9.57673L12.509 10.1746L12.0004 9.8051L11.4918 10.1746L11.6861 9.57673L11.1775 9.20721H11.8061L12.0004 8.60937Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3189">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TK: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
    <path
      d="M19.3043 5.73914C19.1967 6.25641 19.1478 6.80733 19.1478 7.35652C19.1478 10.5222 21.035 13.2621 23.7394 14.4955C23.9097 13.6904 24 12.8558 24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 18.6274 5.37262 24 12 24C16.1101 24 19.7371 21.9332 21.8998 18.7826H6.78263V17.2174H22.8093C22.9733 16.8782 23.1215 16.53 23.2537 16.1739H6.78263L19.3043 5.73914Z"
      fill="#0052B4"
    />
    <path
      d="M8.81559 6.26117L9.07462 7.05833H9.91275L9.2347 7.55103L9.49373 8.34814L8.81559 7.85553L8.13754 8.34814L8.39653 7.55103L7.71838 7.05833H8.55656L8.81559 6.26117Z"
      fill="#F0F0F0"
    />
    <path
      d="M5.41131 12.0001L5.73512 12.9966H6.78278L5.93514 13.6123L6.25895 14.6088L5.41131 13.9929L4.56372 14.6088L4.88748 13.6123L4.03989 12.9966H5.08754L5.41131 12.0001Z"
      fill="#F0F0F0"
    />
    <path
      d="M5.41131 3.65247L5.73512 4.64898H6.78278L5.93514 5.26468L6.25895 6.26115L5.41131 5.64531L4.56372 6.26115L4.88748 5.26468L4.03989 4.64898H5.08754L5.41131 3.65247Z"
      fill="#F0F0F0"
    />
    <path
      d="M2.80239 8.3475L3.1262 9.34402H4.17381L3.32622 9.95972L3.65003 10.9562L2.80239 10.3403L1.9548 10.9562L2.27856 9.95972L1.43097 9.34402H2.47858L2.80239 8.3475Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const TL: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_2001)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M11.9997 -0.000305176C9.06173 -0.000305176 6.37083 1.05612 4.2848 2.8091L17.2171 11.9997L4.2848 21.1903C6.37083 22.9433 9.06173 23.9997 11.9997 23.9997C18.6271 23.9997 23.9997 18.6271 23.9997 11.9997C23.9997 5.37232 18.6271 -0.000305176 11.9997 -0.000305176Z"
        fill="#D80027"
      />
      <path
        d="M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z"
        fill="black"
      />
      <path
        d="M3.32691 9.25146L5.15316 10.9798L7.36134 9.77684L6.28205 12.0479L8.10834 13.7763L5.61488 13.4516L4.53544 15.7226L4.07386 13.2508L1.58039 12.926L3.78848 11.7231L3.32691 9.25146Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_2001">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3260)">
      <path
        d="M11.9997 -0.000610352C11.1037 -0.000610352 10.2309 0.0984365 9.39104 0.284624L8.86932 11.9993L9.39104 23.7141C10.231 23.9003 11.1038 23.9994 11.9997 23.9994C18.6271 23.9994 23.9997 18.6268 23.9997 11.9993C23.9996 5.37197 18.6271 -0.000610352 11.9997 -0.000610352Z"
        fill="#496E2D"
      />
      <path
        d="M3.13012 3.91705C1.18555 6.04968 -0.000289917 8.88608 -0.000289917 11.9996C-0.000289917 15.1131 1.1856 17.9496 3.13016 20.0823L3.65188 11.9996L3.13012 3.91705Z"
        fill="#496E2D"
      />
      <path
        d="M17.5515 9.05162C18.1418 7.40602 17.4786 5.61629 16.0551 4.72491C16.3111 4.75824 16.5675 4.81852 16.8204 4.90923C18.719 5.59041 19.7059 7.6816 19.0247 9.58013C18.3435 11.4788 16.2523 12.4656 14.3537 11.7844C14.1008 11.6937 13.8645 11.5772 13.6458 11.4402C15.3113 11.6571 16.9611 10.6972 17.5515 9.05162Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.277 4.27429L13.7639 4.9372L12.9751 4.65412L13.4469 5.34684L12.934 6.00965L13.7386 5.77499L14.2105 6.46762L14.2358 5.62987L15.0405 5.39517L14.2516 5.11218L14.277 4.27429Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.6623 6.4353L15.1493 7.09816L14.3604 6.81508L14.8323 7.5078L14.3193 8.17062L15.1239 7.93587L15.5958 8.62863L15.6212 7.79083L16.4258 7.55608L15.6369 7.27305L15.6623 6.4353Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.8341 5.06036L11.3211 5.72318L10.5322 5.44019L11.0041 6.13286L10.4911 6.79572L11.2957 6.56102L11.7676 7.25369L11.793 6.41594L12.5976 6.18124L11.8087 5.89816L11.8341 5.06036Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.778 7.53455L11.265 8.19741L10.4761 7.91437L10.9481 8.60709L10.435 9.26991L11.2397 9.03525L11.7116 9.72787L11.7369 8.89012L12.5416 8.65542L11.7526 8.37234L11.778 7.53455Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.1321 8.38L13.619 9.04282L12.8302 8.75979L13.3021 9.4525L12.789 10.1153L13.5937 9.88061L14.0656 10.5733L14.091 9.73549L14.8956 9.50083L14.1067 9.2178L14.1321 8.38Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.13019 3.9175V20.0827C4.76519 21.8758 6.9369 23.1707 9.39104 23.7148V0.285339C6.93686 0.829371 4.76523 2.12429 3.13019 3.9175Z"
        fill="#D80027"
      />
      <path d="M5.51949 6.31755L4.47131 5.5367V4.43247L5.51949 3.65167H7.00191L8.05008 4.43247V5.5367L7.00191 6.31755H5.51949Z" fill="#F0F0F0" />
      <path d="M6.26072 3.65167H5.51948L4.47131 4.43247V4.97233H6.26072V3.65167Z" fill="#FF9811" />
      <path d="M6.26074 6.31668H7.00193L8.0501 5.53583V4.97253H6.26074V6.31668Z" fill="#FF9811" />
      <path d="M5.51949 20.3484L4.47131 19.5676V18.4634L5.51949 17.6826H7.00191L8.05008 18.4634V19.5676L7.00191 20.3484H5.51949Z" fill="#F0F0F0" />
      <path d="M6.26072 17.6826H5.51948L4.47131 18.4634V19.0033H6.26072V17.6826Z" fill="#FF9811" />
      <path d="M6.26074 20.3493H7.00193L8.0501 19.5684V19.0052H6.26074V20.3493Z" fill="#FF9811" />
      <path d="M5.51939 13.3323L4.47122 12.5515V11.4473L5.51939 10.6664H7.00181L8.04998 11.4473V12.5515L7.00181 13.3323H5.51939Z" fill="#496E2D" />
      <path
        d="M8.08667 15.0514H7.63011V14.5949H6.82784L6.26056 14.0276L5.69332 14.5949H4.89106V15.0514H4.43454V15.9644H4.89106V16.4209H5.69328L6.2606 16.9883L6.82784 16.4209H7.63011V15.9644H8.08667V15.0514Z"
        fill="#496E2D"
      />
      <path
        d="M8.08694 8.03605H7.63038V7.57949H6.82811L6.26083 7.01221L5.6936 7.57949H4.89133V8.03605H4.43481V8.94908H4.89133V9.4056H5.69355L6.26088 9.97297L6.82811 9.4056H7.63038V8.94908H8.08694V8.03605Z"
        fill="#496E2D"
      />
      <path d="M6.78228 11.4792H5.7388V12.5227H6.78228V11.4792Z" fill="#D80027" />
      <path
        d="M6.26061 9.01487C6.54874 9.01487 6.78232 8.78129 6.78232 8.49315C6.78232 8.20502 6.54874 7.97144 6.26061 7.97144C5.97247 7.97144 5.73889 8.20502 5.73889 8.49315C5.73889 8.78129 5.97247 9.01487 6.26061 9.01487Z"
        fill="#D80027"
      />
      <path
        d="M6.26052 16.0308C6.54865 16.0308 6.78223 15.7972 6.78223 15.5091C6.78223 15.2209 6.54865 14.9874 6.26052 14.9874C5.97238 14.9874 5.7388 15.2209 5.7388 15.5091C5.7388 15.7972 5.97238 16.0308 6.26052 16.0308Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3260">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M11.9998 17.7387C15.1695 17.7387 17.739 15.1692 17.739 11.9995C17.739 8.82991 15.1695 6.26041 11.9998 6.26041C8.83018 6.26041 6.26068 8.82991 6.26068 11.9995C6.26068 15.1692 8.83018 17.7387 11.9998 17.7387Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.7065 9.80502L13.691 11.1618L15.2856 10.6448L14.2995 12.0004L15.2839 13.3572L13.6899 12.8382L12.7038 14.1938L12.7048 12.5175L11.1108 11.9985L12.7054 11.4815L12.7065 9.80502Z"
      fill="#D80027"
    />
    <path
      d="M13.304 15.3905C11.4311 15.3905 9.9127 13.8722 9.9127 11.9992C9.9127 10.1263 11.4311 8.60791 13.304 8.60791C13.888 8.60791 14.4375 8.75557 14.9172 9.01554C14.1646 8.27955 13.1355 7.82529 11.9997 7.82529C9.69454 7.82529 7.82578 9.69401 7.82578 11.9992C7.82578 14.3043 9.69454 16.1731 11.9997 16.1731C13.1355 16.1731 14.1647 15.7188 14.9172 14.9828C14.4375 15.2429 13.888 15.3905 13.304 15.3905Z"
      fill="#D80027"
    />
  </svg>
));
export const TO: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M7.82607 6.2614V4.6962H6.26082V6.2614H4.69562V7.82665H6.26082V9.39186H7.82607V7.82665H9.39128V6.2614H7.82607Z" fill="#D80027" />
    <path d="M12 0V12C5.37262 12 2.73867 12 0 12C0 18.6274 5.37262 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z" fill="#D80027" />
  </svg>
));
export const TR: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M11.5087 9.80505L12.4934 11.1619L14.0879 10.6448L13.1017 12.0004L14.0862 13.3572L12.4922 12.8382L11.5061 14.1938L11.5071 12.5175L9.91312 11.9985L11.5077 11.4815L11.5087 9.80505Z"
      fill="#F0F0F0"
    />
    <path
      d="M8.8218 15.3906C6.94886 15.3906 5.43049 13.8722 5.43049 11.9993C5.43049 10.1263 6.94886 8.60794 8.8218 8.60794C9.40577 8.60794 9.95524 8.75565 10.435 9.01557C9.68238 8.27954 8.65315 7.82532 7.51746 7.82532C5.21224 7.82532 3.34357 9.69404 3.34357 11.9992C3.34357 14.3044 5.21229 16.1731 7.51746 16.1731C8.65324 16.1731 9.68243 15.7188 10.435 14.9828C9.95524 15.2429 9.40577 15.3906 8.8218 15.3906Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const TT: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3240)">
      <path
        d="M6.49769 1.33197C5.42341 1.88645 4.41499 2.61325 3.51442 3.51381C2.61381 4.41442 1.88702 5.42284 1.33258 6.49713L9.04853 14.951L17.5024 22.6669C18.5767 22.1125 19.5851 21.3857 20.4857 20.4851C21.3863 19.5845 22.1131 18.5761 22.6675 17.5018L14.9516 9.04792L6.49769 1.33197Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.4855 20.486C20.9889 19.9826 21.4378 19.4454 21.8331 18.8821L5.11816 2.16708C4.55477 2.56229 4.01763 3.01126 3.51424 3.51465C3.01084 4.01804 2.56188 4.55518 2.16663 5.11862L18.8815 21.8335C19.4449 21.4383 19.9821 20.9894 20.4855 20.486Z"
        fill="black"
      />
      <path
        d="M3.51411 20.4865C7.30006 24.2725 12.9859 24.9992 17.5021 22.6683L1.33231 6.4985C-0.998546 11.0147 -0.271655 16.7006 3.51411 20.4865Z"
        fill="#D80027"
      />
      <path
        d="M20.4851 3.51458C16.6991 -0.271324 11.0134 -0.998074 6.49713 1.33269L22.6669 17.5026C24.9978 12.9864 24.2711 7.30049 20.4851 3.51458Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3240">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const TV: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#338AF3" />
    <path d="M5.73935 12.0012H9.78663L6.26107 7.82727L5.73935 9.39247V12.0012Z" fill="#0052B4" />
    <path d="M12.0002 9.78671L7.82626 5.73938H12.0002L12.0002 9.78671Z" fill="#0052B4" />
    <path
      d="M11.9683 11.9996H12.0005C12.0005 11.9888 12.0005 11.9783 12.0005 11.9674C11.9898 11.9782 11.979 11.9889 11.9683 11.9996Z"
      fill="#F0F0F0"
    />
    <path
      d="M12.0004 6.26116C12.0004 4.14968 12.0004 2.76612 12.0004 0.000305176H11.9984C5.37187 0.00143018 0.000366211 5.37354 0.000366211 12.0003H6.26127V8.47479L9.78679 12.0003H11.9683C11.979 11.9896 11.9897 11.9789 12.0005 11.9682C12.0005 11.1597 12.0005 10.4384 12.0005 9.78677L8.4748 6.26116H12.0004Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.07124 1.56537C4.19441 2.63407 2.63413 4.19435 1.56543 6.07118V12.0002H4.69588V4.69592V4.69582H12.0002C12.0002 3.70849 12.0002 2.7679 12.0002 1.56537H6.07124Z"
      fill="#D80027"
    />
    <path
      d="M12.0005 10.524L7.73695 6.26062H6.26132V6.26071L12.0004 11.9997H12.0005C12.0005 11.9997 12.0005 10.9822 12.0005 10.524Z"
      fill="#D80027"
    />
    <path
      d="M13.0972 19.8252L13.3562 20.6224H14.1944L13.5164 21.115L13.7754 21.9121L13.0972 21.4195L12.4192 21.9121L12.6782 21.115L12.0001 20.6224H12.8382L13.0972 19.8252Z"
      fill="#FFDA44"
    />
    <path
      d="M19.7727 14.6093L20.0317 15.4064H20.8698L20.1918 15.8991L20.4509 16.6962L19.7727 16.2036L19.0946 16.6962L19.3537 15.8991L18.6755 15.4064H19.5136L19.7727 14.6093Z"
      fill="#FFDA44"
    />
    <path
      d="M21.445 6.78253L21.704 7.57969H22.5422L21.8642 8.07234L22.1231 8.86945L21.445 8.37684L20.767 8.86945L21.026 8.07234L20.3478 7.57969H21.186L21.445 6.78253Z"
      fill="#FFDA44"
    />
    <path
      d="M21.8596 12.5214L22.1186 13.3186H22.9568L22.2787 13.8113L22.5377 14.6084L21.8596 14.1158L21.1815 14.6084L21.4406 13.8113L20.7624 13.3186H21.6006L21.8596 12.5214Z"
      fill="#FFDA44"
    />
    <path
      d="M14.299 17.9513L15.046 18.3319L15.6386 17.7393L15.5076 18.567L16.2543 18.9475L15.4264 19.0787L15.2953 19.9066L14.9149 19.1597L14.087 19.2909L14.6796 18.6983L14.299 17.9513Z"
      fill="#FFDA44"
    />
    <path
      d="M14.299 14.8214L15.046 15.2019L15.6386 14.6093L15.5076 15.4371L16.2543 15.8175L15.4264 15.9487L15.2953 16.7766L14.9149 16.0297L14.087 16.1609L14.6796 15.5683L14.299 14.8214Z"
      fill="#FFDA44"
    />
    <path
      d="M16.9079 16.8271L17.6549 17.2077L18.2475 16.6151L18.1165 17.4428L18.8632 17.8234L18.0353 17.9545L17.9042 18.7824L17.5238 18.0355L16.6959 18.1667L17.2885 17.5741L16.9079 16.8271Z"
      fill="#FFDA44"
    />
    <path
      d="M16.9079 10.1248L17.6549 10.5053L18.2475 9.91266L18.1165 10.7405L18.8632 11.121L18.0353 11.2521L17.9042 12.08L17.5238 11.3332L16.6959 11.4643L17.2885 10.8717L16.9079 10.1248Z"
      fill="#FFDA44"
    />
    <path
      d="M19.4365 10.0444L20.1834 10.425L20.7761 9.83234L20.645 10.6601L21.3918 11.0406L20.5639 11.1718L20.4328 11.9996L20.0523 11.2528L19.2244 11.384L19.8171 10.7914L19.4365 10.0444Z"
      fill="#FFDA44"
    />
  </svg>
));
export const TW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z"
      fill="#D80027"
    />
    <path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4" />
    <path
      d="M10.435 7.02305L8.96945 7.71249L9.74983 9.13181L8.15847 8.82731L7.95677 10.435L6.84836 9.25261L5.73986 10.435L5.53825 8.82731L3.94684 9.13172L4.72722 7.71239L3.26172 7.02305L4.72727 6.33375L3.94684 4.91438L5.5382 5.21883L5.73991 3.61121L6.84836 4.79358L7.95681 3.61121L8.15847 5.21883L9.74987 4.91438L8.96945 6.3338L10.435 7.02305Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.8486 9.25672C8.08226 9.25672 9.08233 8.25664 9.08233 7.02299C9.08233 5.78933 8.08226 4.78925 6.8486 4.78925C5.61494 4.78925 4.61487 5.78933 4.61487 7.02299C4.61487 8.25664 5.61494 9.25672 6.8486 9.25672Z"
      fill="#0052B4"
    />
    <path
      d="M6.84792 8.21398C6.19162 8.21398 5.65771 7.68003 5.65771 7.02373C5.65771 6.36744 6.19167 5.83348 6.84792 5.83348C7.50422 5.83348 8.03817 6.36744 8.03817 7.02373C8.03812 7.68003 7.50412 8.21398 6.84792 8.21398Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const TZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3203)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
      <path
        d="M3.51467 20.4856C4.01807 20.989 4.55516 21.4379 5.11855 21.8331L21.8328 5.11886C21.4376 4.55547 20.9886 4.01837 20.4853 3.51498C19.9818 3.01159 19.4448 2.56272 18.8814 2.16747L2.16721 18.8817C2.56236 19.445 3.01133 19.9821 3.51467 20.4856Z"
        fill="black"
      />
      <path
        d="M3.51456 3.5138C-0.271159 7.29961 -0.997956 12.9851 1.33281 17.5012L17.502 1.3321C12.9859 -0.998668 7.30033 -0.271825 3.51456 3.5138Z"
        fill="#6DA544"
      />
      <path
        d="M20.485 20.4851C24.2707 16.6994 24.9975 11.0138 22.6668 6.49771L6.49765 22.6669C11.0136 24.9976 16.6992 24.2708 20.485 20.4851Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3203">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const UA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44" />
    <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#338AF3" />
  </svg>
));
export const UG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3327)">
      <path
        d="M20.943 20.0002C22.8435 17.8771 23.9996 15.0739 23.9996 12.0002C23.9996 8.92654 22.8434 6.12327 20.943 4.00021L11.9996 3.13068L3.05621 4.00021C1.15576 6.12327 -0.000411987 8.92654 -0.000411987 12.0002C-0.000411987 15.0739 1.15571 17.8771 3.05617 20.0002L11.9996 20.8698L20.943 20.0002Z"
        fill="#FFDA44"
      />
      <path
        d="M3.0567 4.00047H20.9435C18.7462 1.54577 15.5538 0.000488281 12.0001 0.000488281C8.44634 0.000488281 5.25392 1.54577 3.0567 4.00047Z"
        fill="black"
      />
      <path
        d="M-0.000411987 12.0007L11.9996 13.0442L23.9996 12.0007C23.9996 10.598 23.7581 9.25186 23.3158 8.00067H0.683401C0.241041 9.25186 -0.000411987 10.598 -0.000411987 12.0007Z"
        fill="#D80027"
      />
      <path
        d="M0.683401 15.9993H23.3159C23.7581 14.7481 23.9996 13.402 23.9996 11.9993H-0.000411987C-0.000411987 13.402 0.241041 14.7481 0.683401 15.9993Z"
        fill="black"
      />
      <path d="M20.9434 19.9995H3.05658C5.2538 22.4542 8.44622 23.9995 12 23.9995C15.5538 23.9995 18.7462 22.4542 20.9434 19.9995Z" fill="#D80027" />
      <path
        d="M16.0042 12.0007C16.0042 14.2125 14.2115 16.0051 11.9998 16.0051C9.78813 16.0051 7.99548 14.2125 7.99548 12.0007C7.99548 9.78904 9.78813 7.9964 11.9998 7.9964C14.2115 7.9964 16.0042 9.78904 16.0042 12.0007Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.4666 12.2036L11.9996 11.568C11.9996 11.568 12.3428 10.4288 12.3611 10.3508C12.3745 10.2939 12.3816 10.2345 12.3816 10.1734C12.3816 9.9573 12.294 9.76164 12.1523 9.62008L12.5212 9.25117C12.2852 9.01516 11.9591 8.86914 11.5989 8.86914C11.2387 8.86914 10.9126 9.01511 10.6766 9.25117L11.0455 9.62008C10.9039 9.76169 10.8163 9.95734 10.8163 10.1734C10.8163 10.2525 10.8282 10.3286 10.85 10.4006L10.2946 10.956H11.3041C11.3041 10.956 10.8867 11.5829 10.6589 12.0977C10.431 12.6125 10.662 13.2409 11.1886 13.475L11.4931 13.6104L11.9996 14.0864V14.6081L11.4779 15.1299H12.5214V14.0864L12.9975 13.6103H13.9822C13.987 13.6005 13.9919 13.5909 13.9964 13.5809C14.2304 13.0543 13.9932 12.4376 13.4666 12.2036Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3327">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const US: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3364)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M11.478 12H23.9997C23.9997 10.9169 23.8553 9.86768 23.5863 8.86957H11.478V12Z" fill="#D80027" />
      <path d="M11.478 5.73855H22.2384C21.5038 4.53986 20.5646 3.48034 19.4695 2.60809H11.478V5.73855Z" fill="#D80027" />
      <path d="M11.9997 24C14.8239 24 17.4197 23.0239 19.4695 21.3914H4.52991C6.57975 23.0239 9.17555 24 11.9997 24Z" fill="#D80027" />
      <path
        d="M1.76107 18.2599H22.2385C22.8282 17.2976 23.2856 16.2457 23.5864 15.1295H0.413177C0.713974 16.2457 1.17133 17.2976 1.76107 18.2599Z"
        fill="#D80027"
      />
      <path
        d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3364">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const UY: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3373)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M11.9997 8.86873H23.5863C23.2854 7.75245 22.8281 6.70053 22.2384 5.73828H11.9997V8.86873Z" fill="#338AF3" />
      <path
        d="M4.53006 21.3898H19.4697C20.5649 20.5176 21.5041 19.4581 22.2386 18.2594H1.7612C2.49578 19.4581 3.43497 20.5176 4.53006 21.3898Z"
        fill="#338AF3"
      />
      <path
        d="M12.0001 -0.000854492C12.0001 1.04263 12.0001 2.60783 12.0001 2.60783H19.47C17.4201 0.975271 14.8243 -0.000854492 12.0001 -0.000854492Z"
        fill="#338AF3"
      />
      <path d="M11.9997 8.86873H23.5863C23.2854 7.75245 22.8281 6.70053 22.2384 5.73828H11.9997V8.86873Z" fill="#338AF3" />
      <path
        d="M0.00012207 12.0001C0.00012207 13.0833 0.144497 14.1324 0.413513 15.1306H23.5868C23.8557 14.1324 24.0001 13.0833 24.0001 12.0001H0.00012207Z"
        fill="#338AF3"
      />
      <path
        d="M10.4352 7.02323L8.96962 7.71262L9.75004 9.132L8.15864 8.82759L7.95698 10.4352L6.84857 9.25279L5.74007 10.4352L5.53846 8.82759L3.94706 9.1319L4.72743 7.71258L3.26193 7.02323L4.72748 6.33394L3.94706 4.91456L5.53842 5.21897L5.74012 3.61139L6.84857 4.79376L7.95703 3.61139L8.15864 5.21897L9.75009 4.91456L8.96967 6.33398L10.4352 7.02323Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3373">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const UZ: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3384)">
      <path
        d="M0.566839 8.34794C0.199245 9.49956 0.000166756 10.7264 0.000213631 12C0.000166756 13.2736 0.199292 14.5005 0.566886 15.6521L12.0002 16.174L23.4336 15.6522C23.8011 14.5006 24.0003 13.2736 24.0003 12.0001C24.0002 10.7265 23.8011 9.49956 23.4336 8.34789L12.0002 7.82617L0.566839 8.34794Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.4332 8.34789L11.9998 7.82617L0.56647 8.34789C0.457532 8.68933 0.363735 9.03747 0.285126 9.39137H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z"
        fill="#D80027"
      />
      <path
        d="M0.285034 14.609C0.36355 14.9629 0.457347 15.311 0.566284 15.6524L0.567409 15.6525L11.9996 16.1742L23.4329 15.6525C23.5418 15.3111 23.6356 14.9629 23.7142 14.609H0.285034Z"
        fill="#D80027"
      />
      <path
        d="M12.0004 24.0007C17.3543 24.0007 21.8885 20.4943 23.4337 15.6528H0.567108C2.11234 20.4942 6.64666 24.0007 12.0004 24.0007Z"
        fill="#6DA544"
      />
      <path
        d="M12.0001 -0.000854492C6.64629 -0.000807617 2.11207 3.50558 0.566742 8.34697L23.4334 8.34702C21.8882 3.50554 17.3539 -0.000901367 12.0001 -0.000854492Z"
        fill="#338AF3"
      />
      <path
        d="M5.48348 4.95618C5.48348 3.83226 6.27337 2.89335 7.3282 2.66301C7.16611 2.62757 6.99787 2.6084 6.82509 2.6084C5.52843 2.6084 4.47726 3.65952 4.47726 4.95623C4.47726 6.25293 5.52834 7.30406 6.82509 7.30406C6.99787 7.30406 7.16606 7.28484 7.3282 7.24945C6.27342 7.01901 5.48348 6.0801 5.48348 4.95618Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.71537 6.02246L8.87428 6.5116H9.38859L8.97253 6.81395L9.13143 7.30309L8.71537 7.00079L8.29921 7.30309L8.45816 6.81395L8.04205 6.5116H8.55637L8.71537 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3576 6.02246L10.5166 6.5116H11.0309L10.6148 6.81395L10.7737 7.30309L10.3576 7.00079L9.9415 7.30309L10.1004 6.81395L9.68439 6.5116H10.1987L10.3576 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9988 6.02246L12.1577 6.5116H12.672L12.2559 6.81395L12.4148 7.30309L11.9988 7.00079L11.5826 7.30309L11.7416 6.81395L11.3254 6.5116H11.8398L11.9988 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6409 6.02246L13.7999 6.5116H14.3141L13.8981 6.81395L14.057 7.30309L13.6409 7.00079L13.2247 7.30309L13.3837 6.81395L12.9676 6.5116H13.4819L13.6409 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.2823 6.02246L15.4412 6.5116H15.9555L15.5395 6.81395L15.6984 7.30309L15.2823 7.00079L14.8661 7.30309L15.0251 6.81395L14.609 6.5116H15.1233L15.2823 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3576 4.31506L10.5166 4.80416H11.0309L10.6148 5.10655L10.7737 5.59564L10.3576 5.29335L9.9415 5.59564L10.1004 5.10655L9.68439 4.80416H10.1987L10.3576 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9988 4.31506L12.1577 4.80416H12.672L12.2559 5.10655L12.4148 5.59564L11.9988 5.29335L11.5826 5.59564L11.7416 5.10655L11.3254 4.80416H11.8398L11.9988 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6409 4.31506L13.7999 4.80416H14.3141L13.8981 5.10655L14.057 5.59564L13.6409 5.29335L13.2247 5.59564L13.3837 5.10655L12.9676 4.80416H13.4819L13.6409 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.2823 4.31506L15.4412 4.80416H15.9555L15.5395 5.10655L15.6984 5.59564L15.2823 5.29335L14.8661 5.59564L15.0251 5.10655L14.609 4.80416H15.1233L15.2823 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9988 2.60803L12.1577 3.09722H12.672L12.2559 3.39952L12.4148 3.8887L11.9988 3.58641L11.5826 3.8887L11.7416 3.39952L11.3254 3.09722H11.8398L11.9988 2.60803Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6409 2.60803L13.7999 3.09722H14.3141L13.8981 3.39952L14.057 3.8887L13.6409 3.58641L13.2247 3.8887L13.3837 3.39952L12.9676 3.09722H13.4819L13.6409 2.60803Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.2823 2.60803L15.4412 3.09722H15.9555L15.5395 3.39952L15.6984 3.8887L15.2823 3.58641L14.8661 3.8887L15.0251 3.39952L14.609 3.09722H15.1233L15.2823 2.60803Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3384">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const VC: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3123)">
      <path
        d="M17.7391 1.45938C16.0342 0.529196 14.0788 0.000305176 11.9999 0.000305176C9.92102 0.000305176 7.96567 0.529196 6.26078 1.45938L5.2173 12.0003L6.26078 22.5412C7.96567 23.4714 9.92102 24.0003 11.9999 24.0003C14.0788 24.0003 16.0342 23.4714 17.7391 22.5412L18.7825 12.0003L17.7391 1.45938Z"
        fill="#FFDA44"
      />
      <path
        d="M6.2612 22.5408V1.45905C2.53107 3.49436 0.000335693 7.4515 0.000335693 12C0.000335693 16.5485 2.53107 20.5057 6.2612 22.5408Z"
        fill="#338AF3"
      />
      <path
        d="M24.0005 12.0001C24.0005 7.45162 21.4697 3.49448 17.7396 1.45917V22.541C21.4697 20.5058 24.0005 16.5487 24.0005 12.0001Z"
        fill="#6DA544"
      />
      <path d="M9.39193 15.1297L7.30492 11.9993L9.39189 8.86884L11.4789 11.9993L9.39193 15.1297Z" fill="#6DA544" />
      <path d="M14.6097 15.1297L12.5228 11.9993L14.6097 8.86884L16.6967 11.9993L14.6097 15.1297Z" fill="#6DA544" />
      <path d="M12.0008 19.3037L9.91383 16.1733L12.0008 13.0428L14.0878 16.1733L12.0008 19.3037Z" fill="#6DA544" />
    </g>
    <defs>
      <clipPath id="clip0_5_3123">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const VE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1544)">
      <path
        d="M22.8088 17.2166C23.5717 15.639 23.9995 13.8692 23.9995 11.9993C23.9995 10.1294 23.5717 8.35951 22.8088 6.78189L11.9995 5.7384L1.19025 6.78189C0.427355 8.35951 -0.000473022 10.1294 -0.000473022 11.9993C-0.000473022 13.8692 0.427355 15.639 1.19025 17.2166L11.9995 18.2601L22.8088 17.2166Z"
        fill="#0052B4"
      />
      <path
        d="M11.9997 24.0004C16.7572 24.0004 20.868 21.2317 22.809 17.2178H1.19044C3.13144 21.2317 7.24219 24.0004 11.9997 24.0004Z"
        fill="#D80027"
      />
      <path
        d="M20.7819 14.3561L20.1481 14.8514L20.4231 15.607L19.7562 15.1574L19.1224 15.6525L19.344 14.8793L18.6772 14.4295L19.4811 14.4015L19.7029 13.6283L19.978 14.3841L20.7819 14.3561Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.1589 11.5444L18.7328 12.2266L19.2499 12.8426L18.4694 12.6483L18.0431 13.3303L17.9869 12.5279L17.2065 12.3333L17.9523 12.0319L17.8963 11.2295L18.4132 11.8458L19.1589 11.5444Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.6724 9.45837L16.5053 10.2452L17.2018 10.6474L16.4019 10.7317L16.2347 11.5183L15.9075 10.7835L15.1075 10.8675L15.7053 10.3293L15.3782 9.59455L16.0747 9.99664L16.6724 9.45837Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6221 8.34802L13.7342 9.14457L14.5263 9.28416L13.8034 9.63695L13.9153 10.4334L13.3566 9.85482L12.6335 10.2074L13.0112 9.49712L12.4524 8.91859L13.2446 9.05823L13.6221 8.34802Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3766 8.34802L10.7542 9.05822L11.5462 8.91849L10.9876 9.49726L11.3651 10.2075L10.6422 9.85482L10.0833 10.4333L10.1954 9.63694L9.47247 9.28435L10.2646 9.14457L10.3766 8.34802Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.3262 9.45837L7.92405 9.99664L8.62047 9.59455L8.29342 10.3295L8.89113 10.8677L8.0912 10.7835L7.76392 11.5183L7.59691 10.7315L6.79694 10.6475L7.4935 10.2453L7.3262 9.45837Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.83967 11.5444L5.58559 11.8457L6.10243 11.2296L6.04651 12.0322L6.79219 12.3335L6.01177 12.528L5.95557 13.3303L5.52948 12.6483L4.74896 12.8428L5.26599 12.2266L4.83967 11.5444Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.21675 14.3561L4.02075 14.3841L4.29572 13.6284L4.51767 14.4017L5.32144 14.4297L4.65459 14.8796L4.87622 15.6527L4.24247 15.1575L3.57558 15.6072L3.85069 14.8514L3.21675 14.3561Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.809 6.78226C20.868 2.76831 16.7572 -0.000366211 11.9997 -0.000366211C7.24219 -0.000366211 3.13144 2.76831 1.19044 6.78226H22.809Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1544">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const VG: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1676)">
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4" />
      <path
        d="M11.9682 12.0007H12.0004C12.0004 11.9899 12.0004 11.9794 12.0004 11.9685C11.9896 11.9793 11.9789 11.99 11.9682 12.0007Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9998 6.26172C11.9998 4.15023 11.9998 2.76672 11.9998 0.000858307H11.9978C5.37127 0.00198331 -0.000183105 5.37409 -0.000183105 12.0009H6.26067V8.47534L9.78619 12.0009H11.9677C11.9784 11.9902 11.9891 11.9795 11.9999 11.9687C11.9999 11.1603 11.9999 10.4389 11.9999 9.78733L8.47425 6.26172H11.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.0706 1.56418C4.19377 2.63288 2.63345 4.19316 1.56479 6.06999V11.999H4.69524V4.69473V4.69463H11.9996C11.9996 3.7073 11.9996 2.76671 11.9996 1.56418H6.0706Z"
        fill="#D80027"
      />
      <path
        d="M17.2179 11.9996L13.9745 15.2431C14.5824 16.4155 15.8062 17.217 17.2179 17.217C18.6297 17.217 19.8535 16.4155 20.4614 15.2431L17.2179 11.9996Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9997 10.5244L7.73623 6.26096H6.2606V6.26106L11.9996 12.0001H11.9997C11.9997 12.0001 11.9997 10.9825 11.9997 10.5244Z"
        fill="#D80027"
      />
      <path
        d="M13.5652 6.26096V12.0001V12.0001C13.5653 14.7957 17.2174 15.6523 17.2174 15.6523C17.2174 15.6523 20.8695 14.7957 20.8696 12.0001V12.0001V6.26096H13.5652Z"
        fill="#6DA544"
      />
      <path d="M18 8.86989H16.4348V13.0438H18V8.86989Z" fill="#F0F0F0" />
      <path
        d="M17.2173 9.65172C17.6495 9.65172 17.9999 9.30132 17.9999 8.86909C17.9999 8.43686 17.6495 8.08646 17.2173 8.08646C16.7851 8.08646 16.4347 8.43686 16.4347 8.86909C16.4347 9.30132 16.7851 9.65172 17.2173 9.65172Z"
        fill="#A2001D"
      />
      <path d="M15.6529 7.30481H14.6094V8.34829H15.6529V7.30481Z" fill="#FFDA44" />
      <path d="M15.6522 9.652H14.6088V10.6955H15.6522V9.652Z" fill="#FFDA44" />
      <path d="M15.6522 12.0005H14.6088V13.044H15.6522V12.0005Z" fill="#FFDA44" />
      <path d="M19.8262 7.30546H18.7828V8.34894H19.8262V7.30546Z" fill="#FFDA44" />
      <path d="M19.8262 9.652H18.7828V10.6955H19.8262V9.652Z" fill="#FFDA44" />
      <path d="M19.8262 12.0005H18.7828V13.044H19.8262V12.0005Z" fill="#FFDA44" />
    </g>
    <defs>
      <clipPath id="clip0_5_1676">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const VI: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC" />
    <path
      d="M14.0378 8.38349C14.0378 7.25793 13.1253 6.34546 11.9997 6.34546C10.8741 6.34546 9.96165 7.25793 9.96165 8.38349H5.478C5.478 9.49166 6.44335 10.3901 7.55152 10.3901H7.48477C7.48477 11.4984 8.38308 12.3969 9.49144 12.3969C9.49144 13.3781 10.1962 14.1934 11.1269 14.3677L11.1217 14.3794H12.8778L12.8726 14.3677C13.8034 14.1934 14.5081 13.3781 14.5081 12.3969C15.6164 12.3969 16.5147 11.4984 16.5147 10.3901H16.4479C17.5561 10.3901 18.5214 9.49166 18.5214 8.38349H14.0378Z"
      fill="#FFDA44"
    />
    <path
      d="M11.1042 14.1724L9.84052 17.0253C10.5073 17.2964 11.236 17.447 12.0001 17.447C12.7642 17.447 13.493 17.2964 14.1597 17.0253L12.8961 14.1724H11.1042Z"
      fill="#FFDA44"
    />
    <path d="M9.39128 9.3855V12.896C9.39128 14.8928 12 15.5047 12 15.5047C12 15.5047 14.6086 14.8928 14.6086 12.896V9.3855H9.39128Z" fill="#F0F0F0" />
    <path d="M2.90988 12.0846L4.32077 16.0307L5.71699 12.0846H6.78256L4.74696 17.302H3.89454L1.84437 12.0846H2.90988Z" fill="#338AF3" />
    <path d="M19.3041 17.302V12.0846H20.3182V17.302H19.3041Z" fill="#338AF3" />
    <path d="M10.4343 10.5195V14.7736C10.793 15.0376 11.1789 15.2191 11.4778 15.3354V10.5195H10.4343Z" fill="#D80027" />
    <path d="M13.5643 10.5195V14.7736C13.2057 15.0376 12.8198 15.2191 12.5208 15.3354V10.5195H13.5643Z" fill="#D80027" />
    <path d="M14.6086 9.3855H9.39128V11.0409H14.6086V9.3855Z" fill="#0052B4" />
  </svg>
));
export const VN: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027" />
    <path
      d="M12.0001 6.26123L13.2952 10.247H17.486L14.0955 12.7103L15.3906 16.696L12.0001 14.2327L8.60963 16.696L9.90469 12.7103L6.51422 10.247H10.705L12.0001 6.26123Z"
      fill="#FFDA44"
    />
  </svg>
));
export const VU: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1517)">
      <path
        d="M24.0003 12.0003C24.0003 11.4698 23.9655 10.9475 23.8987 10.4351H10.435C7.98339 7.98365 3.51485 3.51539 3.51504 3.51501C-1.17123 8.20129 -1.17123 15.7992 3.51504 20.4856L10.4351 13.5656H23.8987C23.9654 13.0532 24.0003 12.5308 24.0003 12.0003Z"
        fill="black"
      />
      <path d="M23.9967 12.2726C23.9962 12.2958 23.9957 12.319 23.995 12.3422C23.9956 12.3189 23.9961 12.2958 23.9967 12.2726Z" fill="#F0F0F0" />
      <path d="M23.9851 12.6002C23.9841 12.6232 23.9825 12.646 23.9812 12.6689C23.9825 12.6461 23.984 12.6232 23.9851 12.6002Z" fill="#F0F0F0" />
      <path d="M23.9681 12.8632C23.9657 12.8969 23.9634 12.9307 23.9607 12.9643C23.9634 12.9307 23.9657 12.8969 23.9681 12.8632Z" fill="#F0F0F0" />
      <path d="M23.9285 10.6921C23.9329 10.7323 23.9373 10.7724 23.9413 10.8127C23.9373 10.7724 23.9329 10.7323 23.9285 10.6921Z" fill="#F0F0F0" />
      <path d="M23.9805 11.3298C23.9818 11.3527 23.9833 11.3756 23.9844 11.3985C23.9833 11.3756 23.9818 11.3527 23.9805 11.3298Z" fill="#F0F0F0" />
      <path d="M23.9945 11.6567C23.9952 11.6799 23.9956 11.7032 23.9962 11.7264C23.9957 11.7031 23.9951 11.6799 23.9945 11.6567Z" fill="#F0F0F0" />
      <path d="M23.961 11.0355C23.9637 11.0692 23.9661 11.1029 23.9685 11.1367C23.966 11.1029 23.9637 11.0692 23.961 11.0355Z" fill="#F0F0F0" />
      <path
        d="M23.8987 10.4344C23.9041 10.4755 23.9088 10.5168 23.9138 10.558C23.2015 4.61044 18.1397 -0.000366211 12.0003 -0.000366211C8.68649 -0.000366211 5.68645 1.34283 3.51488 3.5145L10.4347 10.4344H23.8987V10.4344Z"
        fill="#D80027"
      />
      <path
        d="M23.8987 13.5652H10.4347L3.51488 20.4851C5.68645 22.6567 8.68649 24 12.0003 24C18.1397 24 23.2016 19.3892 23.9138 13.4415C23.9088 13.4827 23.904 13.5241 23.8987 13.5652Z"
        fill="#6DA544"
      />
      <path d="M23.9412 13.1877C23.9372 13.228 23.9328 13.2681 23.9284 13.3083C23.9328 13.2681 23.9373 13.2281 23.9412 13.1877Z" fill="#F0F0F0" />
      <path d="M23.9685 11.137C23.9731 11.2012 23.9772 11.2655 23.9807 11.33C23.9772 11.2655 23.9731 11.2012 23.9685 11.137Z" fill="black" />
      <path d="M23.9132 10.5583C23.9186 10.6029 23.9237 10.6475 23.9285 10.6922C23.9236 10.6475 23.9185 10.6029 23.9132 10.5583Z" fill="black" />
      <path d="M23.9412 10.8124C23.9485 10.8869 23.9551 10.9616 23.9611 11.0367C23.9552 10.9616 23.9486 10.8869 23.9412 10.8124Z" fill="black" />
      <path d="M24.0005 12C24.0005 12.0913 23.9991 12.1823 23.9971 12.2731C23.9991 12.1823 24.0005 12.0913 24.0005 12Z" fill="black" />
      <path d="M23.9808 12.6688C23.9772 12.7333 23.9731 12.7977 23.9686 12.8619C23.9731 12.7977 23.9772 12.7333 23.9808 12.6688Z" fill="black" />
      <path d="M23.9611 12.964C23.9551 13.0389 23.9485 13.1137 23.9412 13.1882C23.9486 13.1137 23.9552 13.0389 23.9611 12.964Z" fill="black" />
      <path d="M23.9285 13.3081C23.9237 13.3528 23.9186 13.3974 23.9132 13.4419C23.9185 13.3974 23.9236 13.3528 23.9285 13.3081Z" fill="black" />
      <path d="M23.9971 11.7274C23.9991 11.8183 24.0005 11.9093 24.0005 12.0005C24.0005 11.9093 23.9991 11.8183 23.9971 11.7274Z" fill="black" />
      <path d="M23.9856 11.3982C23.9898 11.4841 23.993 11.5704 23.9954 11.6569C23.993 11.5704 23.9898 11.4841 23.9856 11.3982Z" fill="black" />
      <path d="M23.9953 12.3419C23.9929 12.4283 23.9897 12.5146 23.9855 12.6006C23.9898 12.5146 23.993 12.4283 23.9953 12.3419Z" fill="black" />
      <path
        d="M23.989 11.4733H9.99423L2.80563 4.28577C2.57327 4.53083 2.32141 4.87302 2.16565 5.11672L9.04028 11.995L2.15988 18.8755C2.2961 19.1178 2.59287 19.4765 2.80122 19.7099L9.99437 12.5168H23.9907C23.9981 12.3437 24.0005 12.1699 24.0005 11.995C24.0004 11.7608 23.9939 11.588 23.989 11.4733Z"
        fill="#FFDA44"
      />
      <path
        d="M2.9153 14.5574V13.5523C3.91833 13.5523 4.73428 12.7362 4.73428 11.7333C4.73428 11.0237 4.15692 10.4464 3.44733 10.4464C2.96391 10.4464 2.57058 10.8396 2.57058 11.3232C2.57058 11.6323 2.82206 11.8838 3.13125 11.8838C3.306 11.8838 3.44817 11.7416 3.44817 11.5668H4.45326C4.45326 12.2959 3.8602 12.8889 3.1313 12.8889C2.26791 12.889 1.56558 12.1865 1.56558 11.3232C1.56558 10.2856 2.4098 9.44141 3.44738 9.44141C4.71122 9.44141 5.73947 10.4697 5.73947 11.7335C5.73942 13.2905 4.47253 14.5574 2.9153 14.5574Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1517">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const WS: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z"
      fill="#D80027"
    />
    <path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4" />
    <path
      d="M9.61151 7.82622L9.80581 8.42411H10.4344L9.92581 8.79353L10.1201 9.39142L9.61151 9.0219L9.10292 9.39142L9.29721 8.79353L8.78862 8.42411H9.41721L9.61151 7.82622Z"
      fill="#F0F0F0"
    />
    <path
      d="M6.45448 3.13118L6.77824 4.1277H7.826L6.97831 4.7434L7.30217 5.73987L6.45448 5.12398L5.60684 5.73987L5.93065 4.7434L5.08301 4.1277H6.13067L6.45448 3.13118Z"
      fill="#F0F0F0"
    />
    <path
      d="M9.5854 4.17502L9.90917 5.17158H10.9569L10.1092 5.78729L10.433 6.78375L9.5854 6.16786L8.73776 6.78375L9.06157 5.78729L8.21393 5.17158H9.26159L9.5854 4.17502Z"
      fill="#F0F0F0"
    />
    <path
      d="M7.1106 8.34901L7.43442 9.34553H8.48207L7.63443 9.96123L7.95824 10.9577L7.1106 10.3419L6.26296 10.9577L6.58678 9.96123L5.73914 9.34553H6.78684L7.1106 8.34901Z"
      fill="#F0F0F0"
    />
    <path
      d="M4.36762 5.7399L4.69144 6.73641H5.73914L4.89145 7.35212L5.21526 8.34859L4.36762 7.73274L3.52003 8.34859L3.84379 7.35212L2.9962 6.73641H4.04386L4.36762 5.7399Z"
      fill="#F0F0F0"
    />
  </svg>
));
export const YE: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
    <path d="M12 23.9992C17.1595 23.9992 21.5581 20.7427 23.2536 16.1731H0.746353C2.44187 20.7427 6.84038 23.9992 12 23.9992Z" fill="black" />
    <path
      d="M12 0.000610352C6.84038 0.000610352 2.44187 3.25711 0.746353 7.82672H23.2536C21.5581 3.25711 17.1595 0.000610352 12 0.000610352Z"
      fill="#D80027"
    />
  </svg>
));
export const ZA: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_3054)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M3.51425 20.4852C-1.17203 15.7989 -1.17203 8.20092 3.51425 3.51459C3.51393 3.5151 10.4344 11.9999 10.4344 11.9999L3.51425 20.4852Z"
        fill="black"
      />
      <path
        d="M10.435 12.0002L1.59171 6.02423C1.31754 6.50081 1.07576 6.99825 0.868011 7.51312L5.345 12.0002L0.868152 16.4876C1.07571 17.0021 1.31726 17.4992 1.59125 17.9754L10.435 12.0002Z"
        fill="#FFDA44"
      />
      <path
        d="M23.8986 10.4348H10.4346L3.51476 3.51483C2.76908 4.26052 2.12122 5.10385 1.59172 6.02405L7.55604 12L1.59125 17.9751C2.12075 18.8955 2.76889 19.7392 3.51476 20.485L10.4346 13.5652H23.8986C23.9653 13.0528 24.0002 12.5304 24.0002 12C24.0002 11.4695 23.9653 10.9471 23.8986 10.4348Z"
        fill="#6DA544"
      />
      <path
        d="M4.6937 21.5181C6.71724 23.0735 9.25023 23.9988 11.9997 23.9988C17.5441 23.9988 22.2093 20.2385 23.5863 15.1293H11.0825L4.6937 21.5181Z"
        fill="#0052B4"
      />
      <path
        d="M23.5863 8.86875C22.2093 3.75957 17.5441 -0.000793457 11.9997 -0.000793457C9.25023 -0.000793457 6.71724 0.924566 4.6937 2.47997L11.0825 8.86875H23.5863Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_3054">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ZM: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1590)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D" />
      <path d="M16.6953 11.9993H11.9997V23.9993C13.4024 23.9993 14.7485 23.7578 15.9997 23.3156L16.6953 11.9993Z" fill="#D80027" />
      <path d="M20.0001 20.9427C22.4549 18.7455 24.0002 15.553 24.0002 11.9993H19.3045L20.0001 20.9427Z" fill="#FF9811" />
      <path d="M15.9999 11.9993V23.3155C17.4904 22.7886 18.8457 21.9759 19.9999 20.9427V11.9993H15.9999Z" fill="black" />
      <path
        d="M22.1738 7.82669H19.0434C19.0434 7.25041 18.5762 6.7832 17.9999 6.7832C17.4236 6.7832 16.9564 7.25041 16.9564 7.82669H13.826C13.826 8.40302 14.3279 8.87017 14.9042 8.87017H14.8694C14.8694 9.4465 15.3366 9.91366 15.9129 9.91366C15.9129 10.49 16.38 10.9571 16.9564 10.9571H19.0434C19.6197 10.9571 20.0869 10.49 20.0869 9.91366C20.6631 9.91366 21.1303 9.4465 21.1303 8.87017H21.0956C21.6719 8.87013 22.1738 8.40297 22.1738 7.82669Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1590">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
export const ZW: FC<SvgIconConstituentValues> = memo(({ ...props }: SvgIconConstituentValues) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{props.title}</title>
    <g clipPath="url(#clip0_5_1597)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path
        d="M22.8522 6.87246C22.2425 5.58461 21.4104 4.42291 20.4054 3.43643L12.0007 2.60913L3.59606 3.43647C3.56924 3.46277 3.54309 3.48968 3.51656 3.51625L6.87281 6.8725L12.0007 7.02911L22.8522 6.87246Z"
        fill="#FFDA44"
      />
      <path
        d="M3.51596 20.4853C3.56012 20.5295 3.60418 20.5737 3.64899 20.6172L12.0003 21.3923L20.3515 20.6172C21.3668 19.6328 22.2091 18.471 22.8273 17.1812L7.30459 16.6967C5.96898 18.0323 4.42848 19.5727 3.51596 20.4853Z"
        fill="#FFDA44"
      />
      <path
        d="M23.8805 10.3081L9.91289 9.91309L11.9999 12.0001C11.3817 12.6182 10.4589 13.541 9.91289 14.087L23.8732 13.7442C23.9562 13.1747 23.9999 12.5925 23.9999 12.0001C23.9999 11.4256 23.9586 10.861 23.8805 10.3081Z"
        fill="black"
      />
      <path
        d="M12 0.000610352C8.72684 0.000610352 5.76031 1.3117 3.59534 3.43664H20.4047C18.2397 1.3117 15.2732 0.000610352 12 0.000610352Z"
        fill="#6DA544"
      />
      <path d="M10.3076 10.3086H23.8802C23.709 9.09551 23.3567 7.94079 22.851 6.87256H6.87158L10.3076 10.3086Z" fill="#D80027" />
      <path
        d="M6.81944 17.1815H22.8267C23.3383 16.1141 23.6962 14.9592 23.873 13.7455H10.2555C8.92483 15.0761 7.79711 16.2038 6.81944 17.1815Z"
        fill="#D80027"
      />
      <path d="M12 24.0006C15.2463 24.0006 18.191 22.7109 20.3512 20.6167H3.64879C5.80898 22.7109 8.75366 24.0006 12 24.0006Z" fill="#6DA544" />
      <path
        d="M4.28516 2.80994C4.0184 3.03409 3.76101 3.26908 3.51477 3.51522L12.0001 12.0005L3.51477 20.4858C3.76096 20.732 4.0184 20.967 4.28516 21.1911L13.4758 12.0005L4.28516 2.80994Z"
        fill="black"
      />
      <path
        d="M4.82458 8.86914L5.60153 11.2605H8.11614L6.08186 12.7386L6.85886 15.13L4.82458 13.652L2.79025 15.13L3.56735 12.7386L1.53311 11.2605H4.04758L4.82458 8.86914Z"
        fill="#D80027"
      />
      <path
        d="M6.9621 12.1947L4.9372 11.4773C4.9372 11.4773 4.78757 10.0738 4.77852 10.0262C4.70981 9.66418 4.39167 9.39038 4.00963 9.39038C3.57745 9.39038 3.22701 9.74077 3.22701 10.173C3.22701 10.2447 3.23746 10.3137 3.25551 10.3797L2.68776 10.9513C2.68776 10.9513 3.3621 10.9513 3.69726 10.9513C3.69726 11.9991 2.91538 11.9991 2.91538 13.0425L3.34912 14.086H5.95781L6.39262 13.0425H6.39243C6.43598 12.9424 6.46242 12.8392 6.47334 12.736C6.84815 12.5844 6.9621 12.1947 6.9621 12.1947Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1597">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
